import React, { useEffect, useRef, useState, lazy, Suspense } from 'react';
import { useNavigate } from 'react-router-dom';
import { Phone, Mail, MessageSquare, Calendar, Clock, ChevronDown, ChevronUp, Plus, MapPin, ChevronRight, MoreVertical, FileText, Mic, EllipsisVertical, NotebookPen, CloudUpload, BookCheck, CalendarCheck, Video, ListChevronsDownUp, Undo2, ChevronLeftCircle, SquarePen, Edit, Spotlight, Sparkles, X, Tag, Globe, MessageCircle, FilePlus, CalendarDays, Check, GitBranch, Trash2, Minus, Maximize2, Wifi, User, MoreHorizontal } from 'lucide-react';
import { GoGitBranch } from "react-icons/go";
import { FaWhatsapp, FaRegMoneyBillAlt } from "react-icons/fa";
import { HiOutlineDocumentText } from "react-icons/hi2";
import { FaUsersGear } from "react-icons/fa6";
import { SiJfrogpipelines } from "react-icons/si";
import { GrDocumentConfig } from "react-icons/gr";
import nodata from '../../../assets/nodata.gif';
import { getLeadActivities, getCallLogt, getCallLog, getTaskHistoryListByUserId_new, getWebformDetailsByLeadId, getPipelineHistoryByLeadID, getTawkToChatLogsByLeadId, getConvUserByLeadId, getConversationAsRequiredConvId, getFollowupsByLeadId, getNotesByLeadId, getDocumentsByLeadId, addNotes, deleteNotes, deleteDocument, sendVoiceEnquiryOrLead, sendEmail, sendSms, saveInternationalSms, addLeadFollowupDLT, saveDealData, saveNewLead, editLead, sendWhatsAppTemplate, replaceJsonStr, getActiveApiKey, uploadLeadDocument, checkPermissionGetDnid, getUpcomingMeetingDetails, getPastMeetingDetails, getPhysiscalAppointmentWidgetList, getVirtulAPList } from '../../../utils/lead';
import { getSession } from '../../../getSession';
import { generateWebFormUrl } from '../../../utils/lead';
import PopUpModal from '../../../components/PopUpModal/PopUpModal';
import Button from '../../../components/common/Button';
import API_ENDPOINTS from '../../../config/apiEndpoints';
import AddFollowupForm from '../../../components/LeadForm/AddFollowupForm';
import CreateMeetingForm from '../../../components/LeadForm/CreateMeetingForm';
import AddAppointment from '../../../components/LeadForm/AddAppointment';
import AddPhysicalAppointmentForm from '../../../components/LeadForm/AddPhysicalAppointmentForm';
import Swal from 'sweetalert2';
import SendVoiceForm from '../../../components/LeadForm/SendVoiceForm';
import AddNotes from '../../../components/LeadForm/AddNotes';
import UploadData from '../../../components/LeadForm/UploadData';
import MediaLibrary from '../../../components/MediaLibrary';
import AddTask from '../../../components/LeadForm/AddTask';
import AppointmentTab from '../AppointmentTab';
import TaskTab from '../TaskTab';
import { insertNewTaskOrAppointmentLatest } from '../../../utils/lead';
import AddDeal from '../../../components/LeadForm/AddDeal';
import WebForm from '../../../components/LeadForm/WebForm';
import EditLeadForm from '../../../components/LeadForm/EditLeadForm';
import WhatsAppForm from '../../../components/LeadForm/WhatsAppForm';
import SMSForm from '../../Enquiries/Forms/SMSForm';
import MergeLead from '../../../components/LeadForm/MergeLead';
import AddInvoiceForm from '../../../components/LeadForm/AddInvoiceForm';
import AddQuotationForm from '../../../components/LeadForm/AddQuotationForm';
import AddTaxSettingForm from '../../../components/LeadForm/AddTaxSettingForm';
import { insertNewInvoice, saveQuotation, saveTaxSetting, insertNewQuote, isQuotationNumberAlreadyExists } from '../../../utils/lead';
import CustomButtonDropdown from './components/CustomButtonDropdown';
import WebhookParamsModal from './components/WebhookParamsModal';
import {
    buildInvokableUrl,
    checkWebhookUrl,
    fetchCustomButtonList,
    fetchLeadHeaderPlaceholders,
    invokeUrlByDisposition,
    parseWebhookParamConfig,
    resolveLeadId,
    updateWebhookParams
} from './components/customButtonsApi';
import { getInitials, getAvatarColorScheme } from '../../../utils/helpers';
import '../../../components/common/LeadDetails/LeadDetails.css';

const MailForm = lazy(() => import('../../Enquiries/Forms/MailForm'));

const API_BASE1 = (process.env.REACT_APP_SERVICES_API_BASE_URL || '').replace(/\/$/, '');
const NEW_ADDED_BASE_URL = (process.env.REACT_APP_SERVICES_API_BASE_URL || '').replace(/\/$/, '');
const Get_PipeLine_From_LeadID = `${API_BASE1}${API_ENDPOINTS.COMMON.GET_PIPELINE_FROM_LEADID}`;
const Pipeline_stage = `${NEW_ADDED_BASE_URL}${API_ENDPOINTS.COMMON.PIPELINE_STAGE_BASED_ON_DEALPIPELINE}`;
const Get_Mapping_Status = `${API_BASE1}${API_ENDPOINTS.COMMON.GEP_MAPPING_STATUS}`;
const Pipeline_history = `${NEW_ADDED_BASE_URL}${API_ENDPOINTS.COMMON.GET_PIPELINE_HISTORY_BY_LEADID}`;
const Get_Custom_Fields_New = `${NEW_ADDED_BASE_URL}${API_ENDPOINTS.COMMON.GET_CUSTOM_FIELDS_NEW}`;
const Get_Custom_Fields_Mapping_New = `${NEW_ADDED_BASE_URL}${API_ENDPOINTS.COMMON.GET_LEAD_DETAILS_WITH_CUSTOM}`;


const LeadDetails = ({ lead, isLeftCollapsed, leadPermissions = null, maskedFields = [], onBack }) => {
    const navigate = useNavigate();

    // ── Field Masking Helpers ──────────────────────────────────────────────
    const funMaskFieldOddEven = (str, typOddEven = 'even', mask = '*') => {
        if (typeof str !== 'string') {
            return '';
        }
        const vArray = str.split('');
        for (let i = 0; i < vArray.length; i++) {
            if (typOddEven === 'even') {
                if ((i + 1) % 2 === 0) {
                    vArray[i] = mask || '*';
                }
            } else {
                if ((i + 1) % 2 !== 0) {
                    vArray[i] = mask || '*';
                }
            }
        }
        return vArray.join('');
    };

    const getMaskedValue = (fieldName, rawValue) => {
        if (!rawValue) return '';
        const fieldMask = Array.isArray(maskedFields) ? maskedFields.find(f => f.FieldName === fieldName) : null;
        if (!fieldMask) return rawValue;

        const hiddenType = String(fieldMask.HiddenType || '').toLowerCase();
        if (hiddenType === 'masked') {
            return funMaskFieldOddEven(String(rawValue), 'even', '*');
        } else if (hiddenType === 'hidden') {
            return '';
        } else {
            return rawValue;
        }
    };

    const getUniqueMobiles = () => {
        if (!lead) return [];
        const originalInfo = lead.__original || lead;
        const mobileKeys = ['MobileNo', 'MobileNo1', 'MobileNo2', 'MobileNo3'];
        
        const unique = [];
        const seenEnds = new Set();
        
        const sortedKeys = [...mobileKeys].sort((a, b) => {
            const valA = String(originalInfo[a] || '');
            const valB = String(originalInfo[b] || '');
            return valB.length - valA.length;
        });

        sortedKeys.forEach(key => {
            const origVal = originalInfo[key];
            const displayVal = lead[key];
            
            if (origVal && origVal !== 'N/A' && origVal !== '0') {
                const digits = String(origVal).replace(/\D/g, '');
                const end10 = digits.length >= 10 ? digits.slice(-10) : digits;
                
                if (!seenEnds.has(end10) && end10.length > 0 && displayVal) {
                    seenEnds.add(end10);
                    unique.push(String(displayVal).trim());
                }
            }
        });
        return unique;
    };

    const getUniqueEmails = () => {
        if (!lead) return [];
        const originalInfo = lead.__original || lead;
        const emailKeys = ['EmailId', 'EmailId1', 'EmailId2', 'EmailId3', 'EmailID', 'EmailID1', 'EmailID2', 'EmailID3'];
        
        const unique = [];
        const seen = new Set();
        
        emailKeys.forEach(key => {
            const val = lead[key] || originalInfo[key];
            if (val && val !== 'N/A' && val !== '0' && !seen.has(String(val).toLowerCase())) {
                seen.add(String(val).toLowerCase());
                unique.push(String(val).trim());
            }
        });
        return unique;
    };

    const isHiddenField = (fieldName) => {
        const fieldMask = Array.isArray(maskedFields) ? maskedFields.find(f => f.FieldName === fieldName) : null;
        if (!fieldMask) return false;
        return String(fieldMask.HiddenType || '').toLowerCase() === 'hidden';
    };

    // ── Permission helpers (Lead-specific or Page fallback) ─────────────────
    // While leadPermissions is null (still loading), default true so UI isn't
    // broken. Once API responds each false flag hides its corresponding control.
    const p = leadPermissions;   // shorthand
    const canAdd = p ? p.Add !== false : true;
    const canEdit = p ? p.Edit !== false : true;
    const canView = p ? p.View !== false : true;
    const canDelete = p ? p.Delete !== false : true;
    const canSearch = p ? p.Search !== false : true;
    const canImport = p ? p.Import !== false : true;
    const canExport = p ? p.Export !== false : true;
    const canMassUpdate = p ? p.MassUpdate !== false : true;
    const canMassDelete = p ? p.MassDelete !== false : true;
    const canAddCustomField = p ? p.AddCustomField !== false : true;

    // Contact Options
    const canSendWhatsapp = p ? p.SendWhatsapp !== false : true;
    const canSendMail = p ? p.SendMail !== false : true;
    const canSendSms = p ? p.SendSms !== false : true;

    // Quick Actions
    const canAddFollowup = p ? p.AddFollowup !== false : true;
    const canMergeLead = p ? p.MergeLead !== false : true;
    const canAddAppointment = p ? p.AddAppointment !== false : true;
    const canSendVoice = p ? p.SendVoice !== false : true;
    const canAddNote = p ? p.AddNote !== false : true;
    const canUploadDocument = p ? p.UploadDocument !== false : true;
    const canAddTask = p ? p.AddTask !== false : true;
    const canAddDeal = p ? p.AddDeal !== false : true;
    const canAddTax = p ? p.AddTax !== false : true;
    const canAddQuotation = p ? p.AddQuotation !== false : true;
    const canAddInvoice = p ? p.AddInvoice !== false : true;
    const canAddWebform = p ? p.AddWebform !== false : true;

    // console.log(`leadDetail`, lead)
    const [showMoreDetails, setShowMoreDetails] = useState(false);
    const [activeTab, setActiveTab] = useState('activities');
    const [tabFetchKey, setTabFetchKey] = useState(0);
    const [activities, setActivities] = useState([]);
    const [callLogs, setCallLogs] = useState([]);
    const [callLogsLoading, setCallLogsLoading] = useState(false);
    const [callLogsHasMore, setCallLogsHasMore] = useState(false);
    const [callLogsStart, setCallLogsStart] = useState(0);
    const [tasks, setTasks] = useState([]);
    const { userId, TokenId, parentId, LoginName, DisplayName, channelProfileId, Mobile, ProfilePicturePath } = getSession();
    const [appointments, setAppointments] = useState([]);
    const [webforms, setWebforms] = useState([]);
    const [pipelineHistory, setPipelineHistory] = useState([]);
    const [pipelineStages, setPipelineStages] = useState([]);
    const [activePipeline, setActivePipeline] = useState(null);
    const [mappingStatuses, setMappingStatuses] = useState({});
    const [allPipelines, setAllPipelines] = useState([]);
    const [showAllPipelines, setShowAllPipelines] = useState(false);
    const [chatLogs, setChatLogs] = useState([]);
    const [followups, setFollowups] = useState([]);
    const [notes, setNotes] = useState([]);
    const [documents, setDocuments] = useState([]);
    const [meetings, setMeetings] = useState([]);
    const [pastMeetings, setPastMeetings] = useState([]);
    const [meetingTab, setMeetingTab] = useState('upcoming');
    const [showMoreDropdown, setShowMoreDropdown] = useState(false);
    const [isContactOptionsCollapsed, setIsContactOptionsCollapsed] = useState(false);
    const [showCallWidget, setShowCallWidget] = useState(false);
    const [callStatus, setCallStatus] = useState('Requesting');
    const [callTimer, setCallTimer] = useState('00:00:00');
    const [reportCountdown, setReportCountdown] = useState(null);
    const [showAiSummary, setShowAiSummary] = useState(false);
    const [aiSummaryData, setAiSummaryData] = useState('');
    const [isAiLoading, setIsAiLoading] = useState(false);
    const [isNewFollowup, setIsNewFollowup] = useState(true);
    const [isFullDetailsOpen, setIsFullDetailsOpen] = useState(false);
    const [enquiryDetailData, setEnquiryDetailData] = useState([]);

    const leadPrimaryId = lead?.ID || lead?.LeadId || lead?.Id;

    useEffect(() => {
        if (!leadPrimaryId || !userId) return;
        let isMounted = true;
        const fetchAiStatus = async () => {
            try {
                const fetchUrl = 'https://serviceskit19.azurewebsites.net/AIData/LeadFollowupData';
                const payload3 = {
                    Token: TokenId,
                    Message: "",
                    LoggedUserId: userId.toString(),
                    MAC_Address: "",
                    IP_Address: "",
                    Details: { lead_id: leadPrimaryId.toString(), UserID: userId.toString(), Option: 3, PrompText: "", ResponseText: "" }
                };
                const res3 = await fetch(fetchUrl, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(payload3)
                });
                const data3 = await res3.json();
                if (!isMounted) return;

                const resultData = data3?.Details?.data?.[0];
                if (resultData) {
                    setIsNewFollowup(resultData.IsNewFollowup !== false);
                    if (resultData.Result && resultData.IsNewFollowup === false) {
                        setAiSummaryData(resultData.Result);
                    }
                } else {
                    setIsNewFollowup(true);
                }
            } catch (e) {
                console.error("Error fetching AI summary status", e);
                if (isMounted) setIsNewFollowup(true);
            }
        };
        fetchAiStatus();
        return () => { isMounted = false; };
    }, [leadPrimaryId, userId]);

    const fetchAiSummary = async (e) => {
        e.stopPropagation();
        if (showAiSummary) {
            setShowAiSummary(false);
            return;
        }
        setShowAiSummary(true);
        if ((!isNewFollowup && aiSummaryData && !aiSummaryData.includes("Failed")) || isAiLoading) return;

        setIsNewFollowup(false);
        setAiSummaryData('');
        setIsAiLoading(true);
        try {
            const leadIdStr = leadPrimaryId.toString();
            const userIdStr = userId.toString();
            const fetchUrl = 'https://serviceskit19.azurewebsites.net/AIData/LeadFollowupData';

            // Option 1: Get the prompt data
            const payload1 = {
                Token: TokenId,
                Message: "",
                LoggedUserId: userIdStr,
                MAC_Address: "",
                IP_Address: "",
                Details: { lead_id: leadIdStr, UserID: userIdStr, Option: 1, ResponseText: "" }
            };

            const res1 = await fetch(fetchUrl, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload1)
            });
            const data1 = await res1.json();
            const promptText = data1?.Details?.data?.[0]?.Result || "";

            const openAiKey = "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";

            if (!openAiKey) {
                setAiSummaryData("Failed to generate summary: OpenAI Key not configured.");
                setIsAiLoading(false);
                return;
            }

            // Call OpenAI API
            const openAiRes = await fetch("https://api.openai.com/v1/chat/completions", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${openAiKey}`
                },
                body: JSON.stringify({
                    model: "gpt-4o-mini",
                    messages: [
                        { role: "system", content: "You are a helpful assistant." },
                        { role: "user", content: promptText }
                    ]
                })
            });

            const openAiData = await openAiRes.json();
            const aiResponseText = (openAiData.choices && openAiData.choices.length > 0) ? openAiData.choices[0].message.content : "";

            if (!aiResponseText) {
                setAiSummaryData("Failed to generate summary.");
                setIsAiLoading(false);
                return;
            }

            // Option 2: Save the response generated status
            const payload2 = {
                Token: TokenId,
                Message: "",
                LoggedUserId: userIdStr,
                MAC_Address: "",
                IP_Address: "",
                Details: { lead_id: leadIdStr, UserID: userIdStr, Option: 2 }
            };
            await fetch(fetchUrl, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload2)
            });

            // Option 3: Get the final formatted summary with timestamp
            const payload3 = {
                Token: TokenId,
                Message: "",
                LoggedUserId: userIdStr,
                MAC_Address: "",
                IP_Address: "",
                Details: { lead_id: leadIdStr, UserID: userIdStr, Option: 3, PrompText: "", ResponseText: "" }
            };
            const res3 = await fetch(fetchUrl, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload3)
            });
            const data3 = await res3.json();

            const finalSummary = data3?.Details?.data?.[0]?.Result || aiResponseText;
            setAiSummaryData(finalSummary);
        } catch (err) {
            console.error(err);
            setAiSummaryData("Error loading AI summary.");
        } finally {
            setIsAiLoading(false);
        }
    };
    const [isRightCollapsed, setIsRightCollapsed] = useState(false);
    const [isCallWidgetCollapsed, setIsCallWidgetCollapsed] = useState(false);
    const [showCallWidgetMoreMenu, setShowCallWidgetMoreMenu] = useState(false);
    const [isCallDisconnected, setIsCallDisconnected] = useState(false);

    useEffect(() => {
        let timer;
        if (reportCountdown !== null && reportCountdown > 0) {
            timer = setTimeout(() => {
                setReportCountdown(prev => prev - 1);
            }, 1000);
        } else if (reportCountdown === 0) {
            setShowCallWidget(false);
            setCallStatus('Requesting');
            setIsCallDisconnected(false);
            setReportCountdown(null);
            // If there's a legacy hangup button, trigger it
            const btnHangUp = document.getElementById('btnHangUp') || document.querySelector('[id$=btnHangUp]');
            if (btnHangUp) btnHangUp.click();
        }
        return () => clearTimeout(timer);
    }, [reportCountdown]);

    useEffect(() => {
        if (!leadPrimaryId) return;
        const fetchPipelineAndStages = async (id) => {
            try {
                const token = TokenId || localStorage.getItem('TokenId') || "-2295521862261168";

                // 1. Get Pipeline for Lead
                const pRes = await fetch(Get_PipeLine_From_LeadID, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        Token: token,
                        Details: { LeadId: id.toString() }
                    })
                });
                const pData = await pRes.json();
                const pipelinesRaw = pData.Details || pData.d || [];
                const pipelinesArray = Array.isArray(pipelinesRaw) ? pipelinesRaw : (pipelinesRaw.Table ? pipelinesRaw.Table : (pipelinesRaw ? [pipelinesRaw] : []));
                const activeP = pipelinesArray.length > 0 ? pipelinesArray[0] : null;

                if (activeP && activeP.PipeLineID) {
                    setActivePipeline(activeP);

                    const loadedPipelines = [];
                    for (const pipeline of pipelinesArray) {
                        if (!pipeline || !pipeline.PipeLineID) continue;

                        const sRes = await fetch(Pipeline_stage, {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({ Token: token, Details: parseInt(pipeline.PipeLineID, 10), Message: "", Status: "" })
                        });
                        const sData = await sRes.json();
                        const stagesList = sData.Details || sData.d || [];

                        const statuses = {};
                        await Promise.all(stagesList.map(async (stage) => {
                            try {
                                const mRes = await fetch(Get_Mapping_Status, {
                                    method: 'POST',
                                    headers: { 'Content-Type': 'application/json' },
                                    body: JSON.stringify({ Token: token, Details: { StageID: String(stage.Id), LeadID: String(id) } })
                                });
                                const mData = await mRes.json();
                                if (mData.Details && mData.Details.length > 0) {
                                    statuses[stage.Id] = mData.Details[0];
                                }
                            } catch (e) { console.error("Error mapping status:", e); }
                        }));

                        loadedPipelines.push({ pipeline, stages: stagesList, statuses });
                    }

                    setAllPipelines(loadedPipelines);

                    if (loadedPipelines.length > 0) {
                        setPipelineStages(loadedPipelines[0].stages);
                        setMappingStatuses(loadedPipelines[0].statuses);
                    }
                    // Fetch pipeline history to show dates
                    try {
                        const hRes = await fetch(Pipeline_history, {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({
                                Token: token,
                                Details: { leadId: parseInt(id, 10) }
                            })
                        });
                        if (hRes.ok) {
                            const hData = await hRes.json();
                            setPipelineHistory(hData.Details || hData.d || []);
                        }
                    } catch (e) { console.error("Error fetching pipeline history:", e); }
                }
            } catch (e) {
                console.error("Error fetching pipeline stages:", e);
            }
        };

        const fetchDynamicCustomFields = async (id) => {
            try {
                const token = TokenId || localStorage.getItem('TokenId') || "-2295521862261168";
                const { userId, parentId } = getSession();
                const uid = userId || localStorage.getItem('userId') || "34594";
                const pid = parentId || localStorage.getItem('parentId') || uid;

                const defRes = await fetch(Get_Custom_Fields_New, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        Token: token,
                        Message: "",
                        LoggedUserId: parseInt(uid, 10),
                        MAC_Address: "",
                        IP_Address: "",
                        Details: { ParentId: parseInt(pid, 10) }
                    })
                });
                const defData = await defRes.json();
                const fields = defData.Details || (defData.d && defData.d.Details) || [];

                const mapRes = await fetch(Get_Custom_Fields_Mapping_New, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        Token: token,
                        Details: JSON.stringify({
                            draw: 1,
                            StartNo: 0,
                            EndNo: 1,
                            UserId: parseInt(uid, 10),
                            ParentId: parseInt(pid, 10),
                            FilterText: "ID=" + id
                        })
                    })
                });
                const mapData = await mapRes.json();
                let mappingRow = null;
                const mappingDetails = mapData.Details || (mapData.d && mapData.d.Details) || mapData.d;
                if (mappingDetails) {
                    let parsedDetails = null;
                    try { parsedDetails = JSON.parse(mappingDetails); } catch (e) { }
                    mappingRow = (Array.isArray(parsedDetails) ? parsedDetails[0] : null)
                        || (parsedDetails && !Array.isArray(parsedDetails) ? (parsedDetails.Table?.[0] || parsedDetails.Data?.[0] || parsedDetails) : null);
                }

                if (fields && fields.length > 0) {
                    const transformed = fields.map(f => {
                        const val = mappingRow ? (mappingRow[f.FieldName] || mappingRow[f.FieldName.toLowerCase()] || mappingRow[f.FieldName.replace(/\s/g, '_')] || "") : "";
                        return { Text: `v${val}|${f.FieldName}|v`, Value: String(f.FieldId) };
                    });
                    setEnquiryDetailData(transformed);
                }
            } catch (e) {
                console.error("Error fetching dynamic custom fields:", e);
            }
        };

        fetchPipelineAndStages(leadPrimaryId);
        fetchDynamicCustomFields(leadPrimaryId);
    }, [leadPrimaryId, TokenId]);


    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [selectedFile, setSelectedFile] = useState(null);


    const callIntervalRef = useRef(null);
    const addFollowupRef = useRef(null);
    const editLeadRef = useRef(null);
    const addPhysicalAppointmentRef = useRef(null);
    // Track fetched tab+lead combos to prevent repeated API calls on re-renders or errors
    const fetchedTabsRef = useRef(new Set());
    const currentLeadIdRef = useRef(null);
    const addInvoiceRef = useRef(null);
    const addQuotationRef = useRef(null);
    const addTaxSettingRef = useRef(null);

    // -------------------------------------Modal States-------------------------------------
    const [isAddLeadModal, setIsAddLeadModal] = useState(false);
    const [isCreateMeetingModal, setIsCreateMeetingModal] = useState(false);
    const [selectedWebform, setSelectedWebform] = useState('');
    const [isAddPhysicalAppointmentModal, setIsAddPhysicalAppointmentModal] = useState(false);
    const [isAddAppointmentModal, setIsAddAppointmentModal] = useState(false);
    const [isSendVoiceModal, setIsSendVoiceModal] = useState(false);
    const [isAddNotesModal, setIsAddNotesModal] = useState(false);
    const [noteText, setNoteText] = useState('');
    const [isUploadDataModal, setIsUploadDataModal] = useState(false);
    const [showUploadDataMediaLibrary, setShowUploadDataMediaLibrary] = useState(false);
    const [isAddTaskModal, setIsAddTaskModal] = useState(false);
    const [isAddDealModal, setIsAddDealModal] = useState(false);
    const [isWebFormModal, setIsWebFormModal] = useState(false);
    const [isEditLeadModal, setIsEditLeadModal] = useState(false);
    const [isWhatsAppModalOpen, setIsWhatsAppModalOpen] = useState(false);
    const [isMailModalOpen, setIsMailModalOpen] = useState(false);
    const [isSMSModalOpen, setIsSMSModalOpen] = useState(false);
    const [isMergeLeadOpen, setIsMergeLeadOpen] = useState(false);
    const [isAddInvoiceModal, setIsAddInvoiceModal] = useState(false);
    const [isAddQuotationModal, setIsAddQuotationModal] = useState(false);
    const [isAddTaxSettingModal, setIsAddTaxSettingModal] = useState(false);
    const [customButtons, setCustomButtons] = useState([]);
    const [leadPlaceholders, setLeadPlaceholders] = useState([]);
    const [webhookModalState, setWebhookModalState] = useState({
        open: false,
        webhookId: '',
        requiredParams: {},
        leadIds: [],
        batchId: '',
        title: 'Webhook Parameters'
    });
    // Call widget / Click-to-call related state
    const [calleeImage, setCalleeImage] = useState(lead?.Image || 'https://docs.kit19.com/default/person.png');
    const [calleeName, setCalleeName] = useState(lead?.PersonName || '');
    const [calleePhone, setCalleePhone] = useState('');
    // Caller related state
    const [callerName, setCallerName] = useState(LoginName || '');
    const [callerPhone, setCallerPhone] = useState(Mobile || '');
    const [callerImage, setCallerImage] = useState(ProfilePicturePath || 'https://docs.kit19.com/default/person.png');


    // -------------------------------------------Modals Ends----------------------------------

    const handleFileUpload = async (fileOrMedia) => {
        try {
            if (!fileOrMedia) {
                Swal.fire({ icon: 'warning', title: 'Warning', text: 'No file selected' });
                return;
            }

            const { userId, TokenId, parentId } = getSession();

            // If file from UploadData (File object)
            const fileName = fileOrMedia.name || fileOrMedia.FileName;
            let fileSize = fileOrMedia.size || fileOrMedia.FileSize;
            if (typeof fileSize === "string") {
                const sizeStr = fileSize.replace(/\s+/g, '').toLowerCase();
                if (sizeStr.endsWith("kb")) {
                    fileSize = parseFloat(sizeStr) * 1024;
                } else if (sizeStr.endsWith("mb")) {
                    fileSize = parseFloat(sizeStr) * 1024 * 1024;
                } else if (sizeStr.endsWith("gb")) {
                    fileSize = parseFloat(sizeStr) * 1024 * 1024 * 1024;
                } else {
                    fileSize = parseFloat(sizeStr);
                }
            }
            fileSize = Number(fileSize) || 0;


            const payload = {
                Token: TokenId,
                Message: "",
                LoggedUserId: userId,
                MAC_Address: "",
                IP_Address: "102.16.32.189",
                Details: {
                    ParentId: parentId,
                    UserId: userId,
                    LeadId: lead?.ID || lead?.LeadId || "",
                    Filenames: [fileName],
                    Filesizes: [fileSize] // send actual bytes
                },
                BroadcastName: ""
            };

            console.log("Upload Payload:", payload);

            const response = await uploadLeadDocument(payload);

            if (response?.Status === 1) {
                Swal.fire({
                    icon: 'success',
                    title: 'Success',
                    text: response?.Details || 'File uploaded successfully'
                });

                setIsUploadDataModal(false);
                setShowUploadDataMediaLibrary(false);
                setSelectedFile(null);
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: response?.Message || 'Upload failed'
                });
            }

        } catch (err) {
            console.error('handleFileUpload error', err);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Something went wrong'
            });
        }
    };

    const handleSaveUpload = () => {
        if (!selectedFile) {
            alert("Please select a file");
            return;
        }

        handleFileUpload(selectedFile); // 👈 actual API call
        setIsUploadDataModal(false);
    };

    const handleMediaSelect = (file) => {
        setSelectedFile(file);   // 👈 just store
        setShowUploadDataMediaLibrary(false);
    };

    const moreDropdownRef = useRef(null);
    const [draggedItem, setDraggedItem] = useState(null);
    const sendVoiceRef = useRef(null);
    const whatsAppFormRef = useRef(null);
    const [tabsOrder, setTabsOrder] = useState([]);
    const [moreTabsOrder, setMoreTabsOrder] = useState([]);
    const [contextMenu, setContextMenu] = useState({ show: false, x: 0, y: 0, tab: null, source: null });
    const MAX_MAIN_TABS = 8;

    // Default tabs
    const defaultTabs = ['Activities', 'Calls', 'FollowUp', 'Document', 'Notes', 'Task', 'Appointment', 'Meeting'];
    const defaultMoreTabs = ['Chat', 'Webform', 'Pipeline', 'WaChat Log'];

    // Load tabs order from localStorage on mount
    useEffect(() => {
        const savedOrder = localStorage.getItem('leadDetailTabsOrder');
        const savedMoreOrder = localStorage.getItem('leadDetailMoreTabsOrder');

        if (savedOrder) {
            try {
                setTabsOrder(JSON.parse(savedOrder));
            } catch (error) {
                setTabsOrder(defaultTabs);
            }
        } else {
            setTabsOrder(defaultTabs);
        }

        if (savedMoreOrder) {
            try {
                setMoreTabsOrder(JSON.parse(savedMoreOrder));
            } catch (error) {
                setMoreTabsOrder(defaultMoreTabs);
            }
        } else {
            setMoreTabsOrder(defaultMoreTabs);
        }
    }, []);

    useEffect(() => {
        const loadCustomButtonDependencies = async () => {
            try {
                const [leadButtons, lead2Buttons, placeholders] = await Promise.all([
                    fetchCustomButtonList('Leads'),
                    fetchCustomButtonList('Leads 2'),
                    fetchLeadHeaderPlaceholders()
                ]);

                const mergedButtons = [...(Array.isArray(leadButtons) ? leadButtons : []), ...(Array.isArray(lead2Buttons) ? lead2Buttons : [])];
                const uniqueButtons = [];
                const seen = new Set();

                mergedButtons.forEach((button) => {
                    const key = String(button?.ButtonId || button?.ButtonName || '').trim().toLowerCase();
                    if (!key || seen.has(key)) {
                        return;
                    }
                    seen.add(key);
                    uniqueButtons.push(button);
                });

                setCustomButtons(uniqueButtons);
                setLeadPlaceholders(Array.isArray(placeholders) ? placeholders : []);
            } catch (error) {
                console.error('Failed to load custom buttons in details:', error);
            }
        };

        loadCustomButtonDependencies();
    }, []);

    const submitWebhookAction = async ({ webhookId, params, leadIds, batchId, headerKey, headerValue, senderId }) => {
        await updateWebhookParams({
            webhookId,
            params,
            leadIds,
            batchId,
            headerKey,
            headerValue,
            senderId
        });
        window.alert('Webhook parameters updated successfully and button service started.');
    };

    const handleCustomButtonAction = async (button) => {
        try {
            const action = String(button?.ActionBePerform || '').trim();
            const details = String(button?.ActionDetails || '');
            const disposition = String(button?.ButtonDisposition || 'Existing Tab');
            const buttonId = button?.ButtonId;
            const activeLeadId = resolveLeadId(lead);

            if (!activeLeadId) {
                window.alert('Lead id not found for this record.');
                return;
            }

            const targets = {
                leadIds: [activeLeadId],
                batchId: ''
            };

            if (action === 'Invoke a URL') {
                const finalUrl = await buildInvokableUrl(details, targets.leadIds);
                invokeUrlByDisposition(finalUrl, disposition);
                return;
            }

            if (action !== 'Webhook') {
                window.alert(`Unsupported action: ${action || 'Unknown'}`);
                return;
            }

            const webhookDetailsList = await checkWebhookUrl({
                buttonId,
                webhookURL: details,
                batchId: ''
            });

            if (!Array.isArray(webhookDetailsList) || !webhookDetailsList.length) {
                window.alert('No webhook details found in response.');
                return;
            }

            const parsed = parseWebhookParamConfig(webhookDetailsList[0]);
            if (!parsed.webhookId) {
                window.alert('Webhook ID missing in response.');
                return;
            }

            const requiredParamKeys = Object.keys(parsed.requiredParams || {});
            if (!requiredParamKeys.length) {
                await submitWebhookAction({
                    webhookId: parsed.webhookId,
                    params: {},
                    leadIds: targets.leadIds,
                    batchId: '',
                    headerKey: '',
                    headerValue: '',
                    senderId: ''
                });
                return;
            }

            setWebhookModalState({
                open: true,
                webhookId: parsed.webhookId,
                requiredParams: parsed.requiredParams,
                leadIds: targets.leadIds,
                batchId: '',
                title: button?.ButtonName ? `Webhook: ${button.ButtonName}` : 'Webhook Parameters'
            });
        } catch (error) {
            console.error('Details custom button execution failed:', error);
            window.alert(error?.message || 'Failed to execute custom button action.');
        }
    };

    const extractPhoneNumber = (text) => {
        if (!text) return '';
        const parts = text.split(',');
        for (const ph of parts) {
            if (ph && ph.trim() !== '') {
                // if phone label like "M: 9999999999" or contains spaces, take last token
                const tokens = ph.trim().split(' ');
                return tokens[tokens.length - 1].trim();
            }
        }
        return text;
    };

    const voipExtToMobileNo = (AgentId, MobileNo, jsonStr, _entityId, _entityName, callWidgetSetup) => {
        if (jsonStr) {
            // Ensure jQuery UI is loaded (required by jsCallWidget for $.fn.dialog)
            const ensureJQueryUI = (callback) => {
                if (window.$ && typeof window.$.fn?.dialog === 'function') {
                    callback();
                    return;
                }
                // jQuery UI not yet ready – load it if missing, then retry
                const jquiLoaded = Array.from(document.getElementsByTagName('script'))
                    .some(s => s.src.includes('jquery-ui'));
                if (!jquiLoaded) {
                    const jqui = document.createElement('script');
                    jqui.src = 'https://code.jquery.com/ui/1.13.2/jquery-ui.min.js';
                    jqui.onload = () => callback();
                    document.head.appendChild(jqui);
                } else {
                    // Already in DOM but still loading – wait
                    setTimeout(() => ensureJQueryUI(callback), 200);
                }
            };

            // Load jsCallWidget.js if not already present
            const loadCallWidget = (callback) => {
                if (window.$ && window.$.CallWidget) {
                    callback();
                    return;
                }
                const scripts = Array.from(document.getElementsByTagName('script'));
                const isLoaded = scripts.some(s => s.src.includes('jsCallWidget.js'));
                if (!isLoaded) {
                    const script = document.createElement('script');
                    script.src = '/assets/layout/js/jsCallWidget.js';
                    script.type = 'text/javascript';
                    script.onload = () => setTimeout(callback, 100);
                    document.head.appendChild(script);
                } else {
                    // Script tag exists but CallWidget not ready yet
                    setTimeout(() => loadCallWidget(callback), 300);
                }
            };

            const triggerCall = () => {
                // Also guard for jQuery UI .dialog() being available (required by jsCallWidget.js)
                if (window.$ && window.$.CallWidget && typeof window.$.fn?.dialog === 'function') {
                    try {
                        window.$.CallWidget.Init(_entityName, _entityId, callWidgetSetup);
                    } catch (initErr) {
                        console.error('CallWidget.Init failed:', initErr);
                        return;
                    }

                    const kitSend = window.kitSend || (({ url, data, async }, callback) => {
                        // kitSend fallback using fetch
                        const finalUrl = url.includes('://') ? url : `${window.WcfApiUrl || ''}/${url.replace(/^\/+/, '')}`;
                        fetch(finalUrl, {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: data
                        })
                            .then(r => r.json())
                            .then(callback)
                            .catch(err => {
                                console.error('kitSend fallback error:', err);
                                callback(null);
                            });
                    });

                    const providerName = document.querySelector('[id$=hdnIsCTCAllowed]')?.getAttribute('data-ServiceProvider') || '';

                    kitSend({
                        url: `UserCRM/CallVoipEndpoint`,
                        data: JSON.stringify({
                            Token: TokenId,
                            Message: "",
                            LoggedUserId: userId,
                            MAC_Address: "",
                            IP_Address: "102.16.32.189",
                            Details: {
                                ToMoblieNo: MobileNo,
                                AgentId: AgentId,
                                EntityId: _entityId.toString(),
                                EntityName: _entityName,
                                ProviderName: providerName
                            },
                            BroadcastName: ""
                        }),
                        async: true
                    }, function (response) {
                        if (response) {
                            // Check for Status 1 (Success) from ResponseStatusEntity
                            if (response.Status === 1 || response.status === 1) {
                                try {
                                    window.$.CallWidget.Submitted(response);
                                } catch (e) {
                                    console.warn('CallWidget.Submitted failed', e);
                                    window.$.CallWidget.Disconnected();
                                }
                            } else {
                                try { window.$.CallWidget.Disconnected(); } catch (e) { }
                                Swal.fire('OOPs...', response.Message || response.msg || 'Call request failed', 'warning');
                            }
                        } else {
                            try { window.$.CallWidget.Disconnected(); } catch (e) { }
                            Swal.fire('OOPs...', 'Unable to process your request. Please contact administrator or support team.', 'warning');
                        }
                    });
                } else {
                    // Dependencies not ready yet, retry
                    setTimeout(triggerCall, 500);
                }
            };

            // Chain: ensure jQuery UI → load CallWidget → trigger call
            ensureJQueryUI(() => loadCallWidget(() => triggerCall()));
        } else {
            Swal.fire('Warning', 'Voip Not Setup', 'warning');
        }
    };

    const handleClickToCall = async (e, phoneText) => {
        if (e && e.preventDefault) e.preventDefault();
        if (e && e.stopPropagation) e.stopPropagation();

        const phone = extractPhoneNumber(phoneText || lead?.MobileNo || '');
        const { userId: sessionUserId, TokenId } = getSession();
        const agentId = sessionUserId || 0;

        // Update hidden fields for legacy parity (ensure they exist in DOM)
        let hdnDnidNo = document.querySelector('[id$=hdnDnidNo]');
        if (!hdnDnidNo) {
            hdnDnidNo = document.createElement('input');
            hdnDnidNo.type = 'hidden';
            hdnDnidNo.id = 'hdnDnidNo';
            document.body.appendChild(hdnDnidNo);
        }

        let hdnIsCTCAllowed = document.querySelector('[id$=hdnIsCTCAllowed]');
        if (!hdnIsCTCAllowed) {
            hdnIsCTCAllowed = document.createElement('input');
            hdnIsCTCAllowed.type = 'hidden';
            hdnIsCTCAllowed.id = 'hdnIsCTCAllowed';
            document.body.appendChild(hdnIsCTCAllowed);
        }

        try {
            const payload = {
                Token: TokenId,
                Message: "",
                LoggedUserId: userId,
                MAC_Address: "",
                IP_Address: "102.16.32.189",
                Details: {
                    UserId: agentId
                },
                BroadcastName: ""
            };
            const result = await checkPermissionGetDnid(payload);

            let bHideDialPad = false;
            // The API response shape matches the C# snippet: { Status, Message, Details: { IsAllowed, PhoneNo, ... } }
            if (result && result.Status === 1 && result.Details) {
                const obj = result.Details;

                hdnDnidNo.value = obj.PhoneNo || '';

                if (hdnIsCTCAllowed) {
                    hdnIsCTCAllowed.setAttribute('data-DefaultIncoming', obj.DefaultIncoming || '');
                    hdnIsCTCAllowed.setAttribute('data-DefaultOutgoing', obj.DefaultOutgoing || '');
                    hdnIsCTCAllowed.setAttribute('data-ServiceProvider', obj.ServiceProvider || '');
                    hdnIsCTCAllowed.setAttribute('data-IsVoipAllowed', obj.IsVoipAllowed || '');
                    hdnIsCTCAllowed.setAttribute('data-PrefixValue', obj.PrefixValue || '');
                    hdnIsCTCAllowed.setAttribute('data-SuffixValue', obj.SuffixValue || '');

                    if (obj.VoipSetupData) {
                        try {
                            const voipData = typeof obj.VoipSetupData === 'string' ? obj.VoipSetupData : JSON.stringify(obj.VoipSetupData);
                            hdnIsCTCAllowed.setAttribute('data-VoipSetupData', voipData);
                        } catch (errParse) {
                            console.warn("Failed to set VoipSetupData", errParse);
                        }
                    }
                }

                if (obj.IsAllowed == 0 || !obj.PhoneNo) {
                    bHideDialPad = true;
                } else {
                    bHideDialPad = false;
                }
            } else {
                bHideDialPad = true;
            }

            if (bHideDialPad) {
                console.warn("CTC Not Allowed");
                localStorage.setItem("UserCTCStatus", 'Off');
                const hdnIsCTCAllowed = document.querySelector('[id$=hdnIsCTCAllowed]');
                if (hdnIsCTCAllowed) hdnIsCTCAllowed.value = 'false';
                // Remove data-target from elements that open the call modal if not allowed (as in jQuery)
                document.querySelectorAll('[data-target="#myModalClickToCall"]').forEach(el => el.setAttribute('data-target', ''));
            } else {
                console.warn("CTC Allowed");
                localStorage.setItem("UserCTCStatus", 'On');
                const hdnIsCTCAllowed = document.querySelector('[id$=hdnIsCTCAllowed]');
                if (hdnIsCTCAllowed) hdnIsCTCAllowed.value = 'true';
            }
        } catch (err) {
            console.error('checkPermissionGetDnid call failed', err);
        }

        // Try to detect click-to-call allowance from a hidden field in the page (legacy server markup)
        const hdn = document.querySelector('[id$=hdnIsCTCAllowed]');
        const isCTCAllowed = hdn && (hdn.value === 'true' || hdn.getAttribute('data-IsCTCAllowed') === 'true');
        const userCTCStatus = typeof window !== 'undefined' ? localStorage.getItem('UserCTCStatus') : null;

        const isAllowed = !!isCTCAllowed && userCTCStatus === 'On';

        // Update callee details for the widget UI
        setCalleeImage(lead?.Image || 'https://docs.kit19.com/default/person.png');
        setCalleeName(lead?.PersonName || '');
        setCalleePhone(phone || '');

        // If account balance check function exists, use it (legacy global)
        const hasSufficientBal = (typeof window !== 'undefined' && typeof window.IsCallAccBalSufficient === 'function') ? window.IsCallAccBalSufficient() : true;

        if (isAllowed && hasSufficientBal) {
            // Preferred flow: open the call widget and trigger a call if a legacy btn exists
            setShowCallWidget(true);
            setCallStatus('Requesting');
            setCallTimer('00:00:00');
            setIsCallDisconnected(false);
            setReportCountdown(null);

            // If there is a legacy btn with id btnCall, trigger it (keeps parity with original behaviour)
            setTimeout(() => {
                const btn = document.getElementById('btnCall');
                if (btn) btn.click();
            }, 200);
        } else {
            // If voip helper is available, use it (React local version)
            const voipData = hdn?.getAttribute('data-VoipSetupData') || '';
            const isVoipAllowed = hdn?.getAttribute('data-IsVoipAllowed') === 'true';

            if (voipData || isVoipAllowed) {
                const agentIdForVoip = document.querySelector('[id*=hdnSipUserId]')?.value || agentId || 0;
                const entityId = document.querySelector('[id$=hid_lead_id]')?.value || lead?.ID || lead?.LeadId || 0;
                try {
                    voipExtToMobileNo(parseInt(agentIdForVoip, 10) || 0, phone, voipData, entityId, 'lead');
                    // Open the call widget as well so users see the UI
                    setShowCallWidget(true);
                    setCallStatus('Dialing');
                    setIsCallDisconnected(false);
                    setReportCountdown(null);
                } catch (err) {
                    console.warn('voipExtToMobileNo call failed', err);
                    setShowCallWidget(true);
                    setIsCallDisconnected(false);
                    setReportCountdown(null);
                }
            } else {
                // Fallback: just open the widget
                setShowCallWidget(true);
                setIsCallDisconnected(false);
                setReportCountdown(null);
            }
        }

        // Set caller details as well to ensure they are up to date
        setCallerName(LoginName || '');
        setCallerPhone(Mobile || '');
        setCallerImage(ProfilePicturePath || 'https://docs.kit19.com/default/person.png');
    };


    // Mock activities
    const mockActivities = [
        { EventName: 'Outbound call made', UserLogin: 'John Doe', EventDate: new Date(Date.now() - 2 * 60 * 60 * 1000).toISOString(), EventType: 'https://kit19.com/assets/custom/img/LeadActivityIMG/Call.png' },
        { EventName: 'Note added: Follow up required', UserLogin: 'Sarah Smith', EventDate: new Date(Date.now() - 5 * 60 * 60 * 1000).toISOString(), EventType: 'https://kit19.com/assets/custom/img/LeadActivityIMG/Note.png' },
    ];

    // Stable lead ID derived for use as a dependency (prevents re-firing when lead object reference changes)
    const stableLeadId = lead?.LeadId || lead?.ID || lead?.Id || lead?.id || null;

    // Fetch activities or call logs when active tab or lead changes
    useEffect(() => {
        if (!lead || !stableLeadId) return;
        // DEBUG: trace activeTab and lead id to ensure fetch triggers
        try { console.debug && console.debug('LeadDetails effect:', { activeTab, stableLeadId, leadId: lead?.ID || lead?.LeadId || null, cached: fetchedTabsRef.current.has(`${activeTab}:${stableLeadId}`) }); } catch (e) { }

        // Reset the fetched-tabs cache when the lead itself changes
        if (currentLeadIdRef.current !== stableLeadId) {
            currentLeadIdRef.current = stableLeadId;
            fetchedTabsRef.current = new Set();
            // Reset call log pagination on lead change
            setCallLogs([]);
            setCallLogsStart(0);
            setCallLogsHasMore(false);
        }

        // Guard: skip if this tab+lead combination was already fetched (success or error)
        const cacheKey = `${activeTab}:${stableLeadId}`;
        // Force fetch for meeting tab to ensure data loads properly
        if (activeTab !== 'meeting' && activeTab !== 'appointment' && activeTab !== 'task' && fetchedTabsRef.current.has(cacheKey)) {
            return;
        }
        fetchedTabsRef.current.add(cacheKey);

        let isMounted = true;

        const fetchActivities = async () => {
            try {

                const details = {
                    LeadID: lead.LeadId || lead.ID || lead.Id || lead.id,
                    Start: 0,
                    Limit: 10
                };

                const payload = {
                    Token: TokenId,
                    Message: "",
                    LoggedUserId: userId,
                    MAC_Address: "",
                    IP_Address: "102.16.32.189",
                    Details: details,
                    BroadcastName: ""
                };
                const response = await getLeadActivities(payload);
                // API returns an object with a Details array (see sample). Handle several shapes.
                let raw = response?.Details ?? response?.d ?? response ?? [];
                // If Details is an object with .data, use it
                if (raw && raw.Details && Array.isArray(raw.Details.data)) raw = raw.Details.data;
                // If wrapped in Details.data
                if (raw && raw.data && Array.isArray(raw.data)) raw = raw.data;
                // At this point raw should be an array of activity objects
                const items = Array.isArray(raw) ? raw : [];
                // Normalize each activity to the UI shape used below
                const normalized = items.map(a => ({
                    EventName: a.EventName || '',
                    EventDescription: a.EventDescription || a.Description || a.EventName || '',
                    UserLogin: a.UserName || a.UserLogin || a.CreatedBy || '',
                    EventDate: a.EventDate || a.TimeStamp || a.EventTime || '',
                    EventType: a.EventIconURL || a.EventType || a.LeadPersonURL || a.ProfileImgFileName || '',
                    // keep original raw for debugging if needed
                    _raw: a
                }));
                setActivities(normalized);
            } catch (error) {
                console.error('fetchActivities error:', error);
                setActivities([]);
            }
        };

        const CALL_LOG_LIMIT = 10;
        const fetchCallLog = async () => {
            try {
                setCallLogsLoading(true);
                const entityId = lead.LeadId || lead.ID || lead.Id || lead.id;
                // Use WCF endpoint directly (matches legacy jQuery: CRMService.asmx/getCallLog)
                const data = await getCallLog({ EntityName: 'Lead', EntityID: entityId, Start: 0, Limit: CALL_LOG_LIMIT });
                setCallLogs(data);
                setCallLogsHasMore(data.length >= CALL_LOG_LIMIT);
                setCallLogsStart(data.length);
            } catch (error) {
                console.error('fetchCallLog error:', error);
                setCallLogs([]);
            } finally {
                setCallLogsLoading(false);
            }
        };

        if (activeTab === 'activities') {
            fetchActivities();
        } else if (activeTab === 'calls') {
            fetchCallLog();
        }
        else if (activeTab === 'webform') {
            const fetchWebform = async () => {
                try {
                    const { TokenId, userId } = getSession();

                    const payload = {
                        Token: TokenId,
                        Message: "",
                        LoggedUserId: userId,
                        MAC_Address: "",
                        IP_Address: "102.16.32.189",
                        Details: {
                            LeadId: lead.ID
                        },
                        BroadcastName: ""
                    };

                    const response = await getWebformDetailsByLeadId(payload);

                    let raw = response?.Details ?? response?.d ?? response ?? [];

                    // normalize wrappers
                    if (raw && raw.data) raw = raw.data;
                    if (raw && Array.isArray(raw.Details)) raw = raw.Details;

                    const arr = Array.isArray(raw) ? raw : [];

                    const normalized = arr.map(item => {
                        let formData = {};

                        // parse DynimicAttr JSON safely
                        try {
                            formData = item?.DynimicAttr ? JSON.parse(item.DynimicAttr) : {};
                        } catch (e) {
                            formData = {};
                        }

                        return {
                            EntryNo: item?.EntryNo ?? '',
                            FormName: item?.FormName ?? '',
                            EntryDate: item?.EntryDate ?? '',
                            FormData: formData,
                            Agent: item?.Agent?.DisplayName ?? ''
                        };
                    });

                    setWebforms(normalized);

                } catch (error) {
                    console.error('fetchWebform error:', error);
                    setWebforms([]);
                }
            };

            fetchWebform();
        }
        else if (activeTab === 'followup') {
            const fetchFollowups = async () => {
                try {
                    const { TokenId, userId } = getSession();
                    const payload = {
                        Token: TokenId,
                        Message: "",
                        LoggedUserId: userId,
                        MAC_Address: "",
                        IP_Address: "102.16.32.189",
                        Details: {
                            leadno: lead.LeadNo,
                            parentid: parentId,
                        },
                        BroadcastName: ""
                    };
                    const response = await getFollowupsByLeadId(payload);
                    let data = response?.Details ?? response?.d ?? response ?? [];
                    if (data && typeof data === 'string') {
                        try { data = JSON.parse(data); } catch (e) { /* keep as-is */ }
                    }
                    if (data && data.data) data = data.data;
                    setFollowups(Array.isArray(data) ? data : []);
                } catch (error) {
                    console.error('fetchFollowups error:', error);
                    setFollowups([]);
                }
            };
            fetchFollowups();
        }
        else if (activeTab === 'notes') {
            const fetchNotes = async () => {
                try {
                    const { TokenId, userId } = getSession();
                    const payload = {
                        Token: TokenId,
                        Message: "",
                        LoggedUserId: userId,
                        MAC_Address: "",
                        IP_Address: "102.16.32.189",
                        Details: {
                            leadid: lead.ID,
                            parentid: parentId,
                            userid: userId
                        },
                        BroadcastName: ""
                    };
                    const response = await getNotesByLeadId(payload);
                    // normalize response into an array of note objects
                    let raw = response?.Details ?? response?.d ?? response ?? [];

                    // If raw is a string, try to parse
                    if (typeof raw === 'string') {
                        try { raw = JSON.parse(raw); } catch (e) { /* keep as-is */ }
                    }

                    // If it's an object with Details as stringified array, parse that
                    if (raw && raw.Details && typeof raw.Details === 'string') {
                        try { const parsed = JSON.parse(raw.Details); if (Array.isArray(parsed)) raw = parsed; } catch (e) { /* ignore */ }
                    }

                    // If wrapped in common shapes like { Details: { data: [...] } } or { data: [...] }
                    if (raw && raw.Details && Array.isArray(raw.Details.data)) raw = raw.Details.data;
                    if (raw && raw.data && Array.isArray(raw.data)) raw = raw.data;

                    // If raw itself has a Details array, unwrap it
                    if (raw && Array.isArray(raw.Details)) raw = raw.Details;

                    const notesArray = Array.isArray(raw) ? raw : [];

                    // Ensure each note has expected keys (Notes, CreatedBy, CreatedDate, NoteID)
                    const normalizedNotes = notesArray.map(n => ({
                        Notes: n.Notes ?? n.notes ?? n.NoteText ?? '',
                        CreatedBy: n.CreatedBy ?? n.CreatedByName ?? n.UserName ?? n.User ?? '',
                        CreatedDate: n.CreatedDate ?? n.CreatedOn ?? n.Date ?? '',
                        NoteID: n.NoteID ?? n.ID ?? n.Id ?? n.id ?? ''
                    }));

                    if (isMounted) setNotes(normalizedNotes);
                } catch (error) {
                    console.error('fetchNotes error:', error);
                    if (isMounted) setNotes([]);
                }
            };
            fetchNotes();
        }
        else if (activeTab === 'documents' || activeTab === 'document') {
            const fetchDocuments = async () => {
                try {
                    // DEBUG: entering documents branch
                    try { console.debug && console.debug('fetchDocuments called for lead', lead?.ID || lead?.LeadId); } catch (e) { }
                    const { TokenId, userId } = getSession();
                    const payload = {
                        Token: TokenId,
                        Message: "",
                        LoggedUserId: userId,
                        MAC_Address: "",
                        IP_Address: "102.16.32.189",
                        Details: {
                            LeadID: lead.ID,
                            UserID: userId,
                            ParentID: parentId
                        },
                        BroadcastName: ""
                    };
                    const response = await getDocumentsByLeadId(payload);
                    let data = response?.Details ?? response?.d ?? response ?? [];
                    if (data && typeof data === 'string') {
                        try { data = JSON.parse(data); } catch (e) { /* keep as-is */ }
                    }
                    if (data && data.data) data = data.data;

                    // Normalize to array of documents
                    let docsArray = [];
                    if (Array.isArray(data)) docsArray = data;
                    else if (data && typeof data === 'object') docsArray = [data];
                    else docsArray = [];

                    const normalized = docsArray.map(d => {
                        const name = d.DocumentName ?? d.Document ?? d.FileName ?? d.Name ?? '';
                        const location = d.DocumentLocation ?? d.DocumentPath ?? d.Path ?? d.FilePath ?? d.Url ?? '';
                        const url = (location || '').toString();
                        const fullUrl = url && name ? (url.endsWith('/') ? url + name : url + '/' + name) : (d.Url ?? '');

                        // parse uploaded date into ISO if possible for consistent rendering
                        let created = d.CreatedDate ?? d.UploadedOn ?? d.CreatedOn ?? d.Date ?? d.UploadedDate ?? '';
                        try {
                            if (typeof created === 'string') {
                                const candidate = created.replace(/\s+/g, ' ').trim();
                                const parsed = Date.parse(candidate);
                                if (!isNaN(parsed)) created = new Date(parsed).toISOString();
                            }
                        } catch (e) { /* keep original */ }

                        return {
                            DocumentName: name,
                            DocumentType: d.DocumentType ?? d.FileType ?? d.Type ?? '',
                            UploadedBy: d.UserID ?? d.UserName ?? d.UploadedBy ?? d.CreatedBy ?? d.User ?? '',
                            CreatedDate: created,
                            DocumentID: d.DocUpID ?? d.DocumentID ?? d.ID ?? d.Id ?? d.id ?? '',
                            Url: fullUrl
                        };
                    });

                    setDocuments(normalized);
                } catch (error) {
                    console.error('fetchDocuments error:', error);
                    setDocuments([]);
                }
            };
            fetchDocuments();
        } else if (activeTab === 'meeting') {
            const fetchMeetings = async () => {
                try {
                    const { userId } = getSession();
                    const sipUserId = document.querySelector('[id$=hdnSipUserId]')?.value;
                    const meetingUserId = sipUserId || userId;

                    const payload = {
                        MeetName: '',
                        status: null,
                        userId: meetingUserId
                    };
                    const upcomingResponse = await getUpcomingMeetingDetails(payload);
                    let upData = upcomingResponse?.d || upcomingResponse?.Details || upcomingResponse || [];
                    if (typeof upData === 'string') {
                        try { upData = JSON.parse(upData); } catch (e) {
                            try { upData = eval('(' + upData + ')'); } catch (e2) { }
                        }
                    }
                    if (upData && upData.data) upData = upData.data;
                    setMeetings(Array.isArray(upData) ? upData : []);

                    const pastResponse = await getPastMeetingDetails(payload);
                    let pastData = pastResponse?.d || pastResponse?.Details || pastResponse || [];
                    if (typeof pastData === 'string') {
                        try { pastData = JSON.parse(pastData); } catch (e) {
                            try { pastData = eval('(' + pastData + ')'); } catch (e2) { }
                        }
                    }
                    if (pastData && pastData.data) pastData = pastData.data;
                    setPastMeetings(Array.isArray(pastData) ? pastData : []);

                } catch (error) {
                    console.error('fetchMeetings error:', error);
                    setMeetings([]);
                    setPastMeetings([]);
                }
            };
            fetchMeetings();
        } else if (activeTab === 'pipeline') {
            const fetchPipeline = async () => {
                try {
                    const { TokenId, userId } = getSession();
                    const payload = {
                        Token: TokenId,
                        Message: "",
                        LoggedUserId: userId,
                        MAC_Address: "",
                        IP_Address: "102.16.32.189",
                        Details: {
                            LeadID: String(lead.LeadId || lead.ID || lead.Id || lead.id),
                            Start: '0',
                            Limit: '10'
                        },
                        BroadcastName: ""
                    };
                    const response = await getPipelineHistoryByLeadID(payload);
                    let data = response?.Details ?? response?.d ?? response ?? [];
                    if (data && data.data) data = data.data;
                    setPipelineHistory(Array.isArray(data) ? data : []);
                } catch (error) {
                    console.error('fetchPipeline error:', error);
                    setPipelineHistory([]);
                }
            };
            fetchPipeline();
        }
        else if (activeTab === 'chat') {
            const fetchChat = async () => {
                try {
                    const { TokenId, userId } = getSession();
                    const payload = {
                        Token: TokenId,
                        Message: "",
                        LoggedUserId: userId,
                        MAC_Address: "",
                        IP_Address: "102.16.32.189",
                        Details: {
                            LeadId: lead.LeadId || lead.ID || lead.Id || lead.id
                        },
                        BroadcastName: ""
                    };
                    const response = await getTawkToChatLogsByLeadId(payload);
                    let data = response?.Details ?? response?.d ?? response ?? [];
                    if (data && typeof data === 'string') {
                        try { data = JSON.parse(data); } catch (e) { /* keep as-is */ }
                    }
                    if (data && data.data) data = data.data;
                    setChatLogs(Array.isArray(data) ? data : []);
                } catch (error) {
                    console.error('fetchChat error:', error);
                    setChatLogs([]);
                }
            };
            fetchChat();
        }
        else if (activeTab === 'wachatlog' || activeTab === 'wachat log') {
            const fetchwaChat = async () => {
                try {
                    const { TokenId, userId } = getSession();
                    const payload = {
                        Token: TokenId,
                        Message: "",
                        LoggedUserId: userId,
                        MAC_Address: "",
                        IP_Address: "102.16.32.189",
                        Details: {
                            LeadId: lead.LeadId || lead.ID || lead.Id || lead.id
                        },
                        BroadcastName: ""
                    };
                    const response = await getConvUserByLeadId(payload);
                    let data = response?.Details ?? response?.d ?? response ?? [];
                    if (data && typeof data === 'string') {
                        try { data = JSON.parse(data); } catch (e) { /* keep as-is */ }
                    }
                    if (data && data.data) data = data.data;
                    const convList = Array.isArray(data) ? data : [];

                    if (convList.length > 0) {
                        // Assuming the first item contains the necessary EntityId and EntityName
                        const firstConv = convList[0];
                        const secondPayload = {
                            Token: TokenId,
                            Message: "",
                            LoggedUserId: userId,
                            MAC_Address: "",
                            IP_Address: "102.16.32.189",
                            Details: {
                                EntityId: firstConv.EntityId || firstConv.Id || String(lead.LeadId || lead.ID || lead.Id || lead.id),
                                EntityName: firstConv.EntityName || "Lead"
                            },
                            BroadcastName: ""
                        };
                        const secondResponse = await getConversationAsRequiredConvId(secondPayload);
                        let finalData = secondResponse?.Details ?? secondResponse?.d ?? secondResponse ?? [];
                        if (finalData && typeof finalData === 'string') {
                            try { finalData = JSON.parse(finalData); } catch (e) { }
                        }
                        if (finalData && finalData.data) finalData = finalData.data;
                        setChatLogs(Array.isArray(finalData) ? finalData : []);
                    } else {
                        setChatLogs([]);
                    }
                } catch (error) {
                    console.error('fetchwaChat error:', error);
                    setChatLogs([]);
                }
            };
            fetchwaChat();
        }
        else if (activeTab === 'task') {
            // fetch task history with Mode = 'T'
            const fetchTasks = async () => {
                try {
                    const { TokenId, userId } = getSession();
                    const payload = {
                        Token: TokenId,
                        Message: "",
                        LoggedUserId: userId,
                        MAC_Address: "",
                        IP_Address: "102.16.32.189",
                        Details: {
                            FilterText: "",
                            UserId: userId || 0,
                            Mode: 'T'
                        },
                        BroadcastName: ""
                    };
                    const response = await getTaskHistoryListByUserId_new(payload);
                    let data = response?.Details ?? response?.d ?? response ?? [];
                    // if Details is an object/array, normalize to array
                    if (data && data.data) data = data.data;
                    setTasks(Array.isArray(data) ? data : []);
                } catch (error) {
                    console.error('fetchTasks error:', error);
                    setTasks([]);
                }
            };
            fetchTasks();
        } else if (activeTab === 'appointment') {
            const fetchAppointments = async () => {
                try {
                    const entityId = lead.Id || lead.LeadId || stableLeadId;
                    const entityName = "Lead";

                    const { TokenId, userId } = getSession();
                    const virtualPayload = {
                        Token: TokenId,
                        Message: "",
                        LoggedUserId: userId,
                        MAC_Address: "",
                        IP_Address: "102.16.32.189",
                        Details: {
                            FilterText: ` AND LeadId = ${entityId}`,
                            UserId: userId || 0,
                            Mode: 'A'
                        },
                        BroadcastName: ""
                    };

                    const [physicalResp, virtualResp] = await Promise.all([
                        getPhysiscalAppointmentWidgetList(entityId, entityName),
                        getVirtulAPList(virtualPayload)
                    ]);

                    // WCF services return { d: [...] } — unwrap the d layer first
                    let physicalData = physicalResp?.d ?? physicalResp ?? [];
                    if (typeof physicalData === 'string') {
                        try { physicalData = JSON.parse(physicalData); } catch (e) { }
                    }
                    // After unwrapping, d might itself be an object {d:[...]} on some proxies
                    if (physicalData && !Array.isArray(physicalData) && physicalData.d) {
                        physicalData = physicalData.d;
                    }
                    if (!Array.isArray(physicalData)) physicalData = [];

                    let virtualData = virtualResp?.d ?? virtualResp ?? [];
                    if (typeof virtualData === 'string') {
                        try { virtualData = JSON.parse(virtualData); } catch (e) { }
                    }
                    if (virtualData && !Array.isArray(virtualData) && virtualData.d) {
                        virtualData = virtualData.d;
                    }
                    if (!Array.isArray(virtualData)) virtualData = [];

                    if (isMounted) {
                        setAppointments({ physical: physicalData, virtual: virtualData });
                    }
                } catch (error) {
                    console.error('fetchAppointments error:', error);
                    if (isMounted) setAppointments({ physical: [], virtual: [] });
                }
            };
            fetchAppointments();
        }

        return () => {
            isMounted = false;
        };
    }, [activeTab, stableLeadId, tabFetchKey]);

    // Drag and drop handlers
    const handleDragStart = (e, tab, source = 'main') => {
        setDraggedItem({ tab, source });
        e.dataTransfer.effectAllowed = 'move';
    };

    const handleDragOver = (e) => {
        e.preventDefault();
        e.dataTransfer.dropEffect = 'move';
    };

    const handleDrop = (e, dropTab, dropSource = 'main') => {
        e.preventDefault();
        if (!draggedItem || (draggedItem.tab === dropTab && draggedItem.source === dropSource)) return;

        const dragSource = draggedItem.source;
        const dragTab = draggedItem.tab;

        // Handle different drag/drop scenarios
        if (dragSource === 'main' && dropSource === 'main') {
            // Both in main tabs - reorder
            const newOrder = [...tabsOrder];
            const dragIndex = newOrder.indexOf(dragTab);
            const dropIndex = newOrder.indexOf(dropTab);
            newOrder.splice(dragIndex, 1);
            newOrder.splice(dropIndex, 0, dragTab);
            setTabsOrder(newOrder);
            localStorage.setItem('leadDetailTabsOrder', JSON.stringify(newOrder));
        } else if (dragSource === 'main' && dropSource === 'more') {
            // From main to more dropdown
            const newMainOrder = tabsOrder.filter(t => t !== dragTab);
            const newMoreOrder = [...moreTabsOrder];
            const dropIndex = newMoreOrder.indexOf(dropTab);
            newMoreOrder.splice(dropIndex, 0, dragTab);
            setTabsOrder(newMainOrder);
            setMoreTabsOrder(newMoreOrder);
            localStorage.setItem('leadDetailTabsOrder', JSON.stringify(newMainOrder));
            localStorage.setItem('leadDetailMoreTabsOrder', JSON.stringify(newMoreOrder));
        } else if (dragSource === 'more' && dropSource === 'main') {
            // From more dropdown to main - check limit
            if (tabsOrder.length >= MAX_MAIN_TABS) {
                Swal.fire({
                    icon: 'info',
                    title: 'Maximum Tabs Reached',
                    text: `You can only have maximum ${MAX_MAIN_TABS} tabs in the main tab bar`,
                    confirmButtonText: 'OK',
                    confirmButtonColor: '#0d93b4'
                })
                // alert(`You can only have maximum ${MAX_MAIN_TABS} tabs in the main tab bar`);
                setDraggedItem(null);
                return;
            }
            const newMoreOrder = moreTabsOrder.filter(t => t !== dragTab);
            const newMainOrder = [...tabsOrder];
            const dropIndex = newMainOrder.indexOf(dropTab);
            newMainOrder.splice(dropIndex, 0, dragTab);
            setTabsOrder(newMainOrder);
            setMoreTabsOrder(newMoreOrder);
            localStorage.setItem('leadDetailTabsOrder', JSON.stringify(newMainOrder));
            localStorage.setItem('leadDetailMoreTabsOrder', JSON.stringify(newMoreOrder));
        } else if (dragSource === 'more' && dropSource === 'more') {
            // Both in more dropdown - reorder
            const newOrder = [...moreTabsOrder];
            const dragIndex = newOrder.indexOf(dragTab);
            const dropIndex = newOrder.indexOf(dropTab);
            newOrder.splice(dragIndex, 1);
            newOrder.splice(dropIndex, 0, dragTab);
            setMoreTabsOrder(newOrder);
            localStorage.setItem('leadDetailMoreTabsOrder', JSON.stringify(newOrder));
        }

        setDraggedItem(null);
    };

    const handleDragEnd = () => {
        setDraggedItem(null);
    };

    const mailFormRef = React.useRef(null);
    const smsFormRef = React.useRef(null);
    const addTaskRef = React.useRef(null);
    const addAppointmentRef = React.useRef(null);
    const addDealRef = React.useRef(null);

    const handleContextMenu = (e, tab, source) => {
        e.preventDefault();
        setContextMenu({
            show: true,
            x: e.clientX,
            y: e.clientY,
            tab,
            source
        });
    };

    const moveToDropdown = (tab) => {
        const newMainOrder = tabsOrder.filter(t => t !== tab);
        const newMoreOrder = [...moreTabsOrder, tab];
        setTabsOrder(newMainOrder);
        setMoreTabsOrder(newMoreOrder);
        localStorage.setItem('leadDetailTabsOrder', JSON.stringify(newMainOrder));
        localStorage.setItem('leadDetailMoreTabsOrder', JSON.stringify(newMoreOrder));
        setContextMenu({ show: false, x: 0, y: 0, tab: null, source: null });
    };

    const moveToMainTabs = (tab) => {
        if (tabsOrder.length >= MAX_MAIN_TABS) {
            Swal.fire({
                icon: 'info',
                title: 'Maximum Tabs Reached',
                text: `You can only have maximum ${MAX_MAIN_TABS} tabs in the main tab bar`,
                confirmButtonText: 'OK',
                confirmButtonColor: '#0d93b4'
            })
            // alert(`You can only have maximum ${MAX_MAIN_TABS} tabs in the main tab bar`);
            setContextMenu({ show: false, x: 0, y: 0, tab: null, source: null });
            return;
        }
        const newMoreOrder = moreTabsOrder.filter(t => t !== tab);
        const newMainOrder = [...tabsOrder, tab];
        setTabsOrder(newMainOrder);
        setMoreTabsOrder(newMoreOrder);
        localStorage.setItem('leadDetailTabsOrder', JSON.stringify(newMainOrder));
        localStorage.setItem('leadDetailMoreTabsOrder', JSON.stringify(newMoreOrder));
        setContextMenu({ show: false, x: 0, y: 0, tab: null, source: null });
    };

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            // Don't close if clicking inside context menu
            const contextMenuElement = document.getElementById('context-menu');
            if (contextMenuElement && contextMenuElement.contains(event.target)) {
                return;
            }

            if (moreDropdownRef.current && !moreDropdownRef.current.contains(event.target)) {
                setShowMoreDropdown(false);
            }
            // Close context menu when clicking anywhere
            if (contextMenu.show) {
                setContextMenu({ show: false, x: 0, y: 0, tab: null, source: null });
            }
        };

        if (showMoreDropdown || contextMenu.show) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [showMoreDropdown, contextMenu.show]);

    // Call timer effect
    useEffect(() => {
        if (showCallWidget) {
            let seconds = 0;
            setCallTimer('00:00:00');
            if (callIntervalRef.current) {
                clearInterval(callIntervalRef.current);
            }
            callIntervalRef.current = setInterval(() => {
                seconds += 1;
                const hh = String(Math.floor(seconds / 3600)).padStart(2, '0');
                const mm = String(Math.floor((seconds % 3600) / 60)).padStart(2, '0');
                const ss = String(seconds % 60).padStart(2, '0');
                setCallTimer(`${hh}:${mm}:${ss}`);
            }, 1000);
        } else {
            if (callIntervalRef.current) {
                clearInterval(callIntervalRef.current);
                callIntervalRef.current = null;
            }
            setCallTimer('00:00:00');
        }

        return () => {
            if (callIntervalRef.current) {
                clearInterval(callIntervalRef.current);
                callIntervalRef.current = null;
            }
        };
    }, [showCallWidget]);

    const resolveUrl = (url) => {
        if (!url) return 'https://kit19.com/assets/custom/img/LeadActivityIMG/Default.png';
        if (url.startsWith('http')) return url;
        return `https://kit19.com${url}`;
    };

    const formatFollowupDateTime = (value) => {
        if (!value) return '-';
        if (typeof value === 'string' && /^\d{1,2}-[A-Za-z]{3}-\d{4}/.test(value)) return value;

        const date = new Date(value);
        if (Number.isNaN(date.getTime())) return String(value);

        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        const dd = String(date.getDate()).padStart(2, '0');
        const mmm = months[date.getMonth()];
        const yyyy = date.getFullYear();
        const hh = String(date.getHours()).padStart(2, '0');
        const mm = String(date.getMinutes()).padStart(2, '0');
        const ss = String(date.getSeconds()).padStart(2, '0');
        return `${dd}-${mmm}-${yyyy} ${hh}:${mm}:${ss}`;
    };

    const formatFollowupAmount = (value) => {
        if (value === null || value === undefined || value === '') return '0.00';
        const n = Number(value);
        if (Number.isNaN(n)) return String(value);
        return n.toFixed(2);
    };

    const formatReassignValue = (value) => {
        if (value === null || value === undefined || value === '') return '-';
        if (typeof value === 'boolean') return value ? 'Yes' : 'No';
        if (value === 1 || value === '1') return 'Yes';
        if (value === 0 || value === '0') return 'No';
        return String(value);
    };

    // Tabs configuration: show first 5 as visible, rest go into More dropdown
    const allTabs = ['Activities', 'Calls', 'Followup', 'Notes', 'Documents', 'Task', 'Appointment', 'Chat', 'Webform', 'Pipeline'];
    const visibleTabs = allTabs.slice(0, 8);
    const moreTabs = allTabs.slice(5);

    if (!lead) {
        return (
            <div className="flex items-center justify-center h-full bg-[#ffffff]">
                <img src={nodata} alt="nodata" />
            </div>
        );
    }

    return (
        <>
        <div className="lead-details-view" id="enquiry-lead-details">
            <div className="lead-details-header">
                <button className="back-to-list-btn" style={{ display: 'flex', alignItems: 'center', gap: '8px', background: 'transparent', border: 'none', color: '#00a6e6', fontSize: '14px', fontWeight: '600', cursor: 'pointer', padding: 0 }} onClick={onBack || (() => window.history.back())}>
                    <X size={18} style={{ color: '#00a6e6' }} />
                    <span>Back to Lead</span>
                </button>
            </div>
            <div className="lead-details-content-wrapper" style={{ overflow: 'visible' }}>
                <div className="lead-details-main-content" style={{ flex: 1, position: 'relative', zIndex: 10, overflow: 'visible' }}>
                    <div className="details-section basic-details">
                        <div className="section-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <span>Basic Details</span>
                            <div className="header-actions" style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                                {canEdit && (
                                    <>
                                        <div
                                            className="icon-btn-circle"
                                            style={{ backgroundColor: '#f0fdf4', color: '#16a34a', padding: '4px', borderRadius: '4px', cursor: 'pointer' }}
                                            onClick={() => setIsEditLeadModal(true)}
                                        >
                                            <SquarePen size={18} />
                                        </div>
                                        <div
                                            className="icon-btn-circle"
                                            style={{ backgroundColor: '#fef2f2', color: '#ef4444', padding: '4px', borderRadius: '4px', cursor: 'pointer' }}
                                            onClick={() => {
                                                Swal.fire({
                                                    title: 'Confirm',
                                                    text: 'Are you sure you want to delete this lead?',
                                                    icon: 'warning',
                                                    showCancelButton: true,
                                                    confirmButtonColor: '#ef4444',
                                                    cancelButtonColor: '#6b7280',
                                                    confirmButtonText: 'Yes, delete it!'
                                                }).then((result) => {
                                                    if (result.isConfirmed) {
                                                        Swal.fire('Not implemented', 'Delete functionality is not yet available here.', 'info');
                                                    }
                                                });
                                            }}
                                        >
                                            <Trash2 size={18} />
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                        <div className="section-body">
                            <div className="lead-overview">
                                <div className="lead-avatar-big" style={{ cursor: 'pointer', position: 'relative' }}>
                                    <div
                                        className="avatar-circle rounded-full flex items-center justify-center"
                                        style={{
                                            backgroundColor: getAvatarColorScheme(lead.PersonName || 'Unknown').bg,
                                            color: getAvatarColorScheme(lead.PersonName || 'Unknown').text,
                                            border: `2px solid ${getAvatarColorScheme(lead.PersonName || 'Unknown').bg}`,
                                            width: '52px',
                                            height: '52px',
                                            minWidth: '52px',
                                            minHeight: '52px',
                                            borderRadius: '50%',
                                            overflow: 'hidden',
                                            flexShrink: 0,
                                        }}
                                    >
                                        {lead.Image && lead.Image !== 'https://docs.kit19.com/default/person.png' ? (
                                            <img src={lead.Image} alt={lead.PersonName} className="w-full h-full object-cover rounded-full" onError={(e) => { e.target.style.display = 'none'; e.target.parentElement.innerText = getInitials(lead.PersonName || 'Unknown'); }} />
                                        ) : getInitials(lead.PersonName || 'Unknown')}
                                    </div>
                                </div>
                                <div className="lead-info-main" style={{ flex: 1 }}>
                                    <h3 className="lead-name-text" style={{ fontSize: '18px', fontWeight: '700', color: '#1e293b', marginBottom: '4px' }}>{getMaskedValue('PersonName', lead.PersonName)}</h3>
                                    {lead.LeadNo && (
                                        <div style={{ marginBottom: '12px' }}>
                                            <span style={{ backgroundColor: '#22c55e', color: '#fff', borderRadius: '4px', padding: '2px 10px', fontSize: '12px', fontWeight: '700' }}>
                                                {lead.LeadNo}
                                            </span>
                                        </div>
                                    )}
                                    <div className="lead-contact-info" style={{ display: 'flex', gap: '20px', flexWrap: 'wrap', marginTop: '8px' }}>
                                        {/* Mobile Numbers De-duplication */}
                                        {getUniqueMobiles().map((num, idx) => (
                                            <span key={`mob-${idx}`} className="contact-item" onClick={(e) => handleClickToCall(e, num)} style={{ cursor: 'pointer', color: '#3b82f6', fontWeight: '600', display: 'flex', alignItems: 'center', gap: '6px', fontSize: '13px' }}>
                                                <Phone size={14} style={idx > 0 ? { color: '#10b981' } : {}} /> {getMaskedValue('MobileNo', num)}
                                            </span>
                                        ))}

                                        {/* Email Addresses De-duplication */}
                                        {getUniqueEmails().map((email, idx) => (
                                            <span key={`email-${idx}`} className="contact-item" style={{ color: '#475569', display: 'flex', alignItems: 'center', gap: '6px', fontSize: '13px' }}>
                                                <Mail size={14} style={{ color: '#f97316' }} /> {getMaskedValue('EmailID', email)}
                                            </span>
                                        ))}
                                    </div>
                                    <div className="mt-2 text-xs text-gray-500">
                                        Created On: {lead.CreatedOn}
                                    </div>
                                    <div className="mt-1">
                                        <CustomButtonDropdown buttons={customButtons} placeOnPage="InDetails" onButtonClick={handleCustomButtonAction} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                        {/* Pipeline Stages Visualization (Circles Stepper) */}
                        {(allPipelines.length > 0 || activePipeline) && (
                            <div className="bg-white rounded-lg shadow-sm p-4 pipeline-stepper-container" style={{ padding: '20px 25px 20px 25px', maxHeight: '180px', overflowY: 'auto' }}>
                                {/* Fallback for single if allPipelines not populated */}
                                {(allPipelines.length > 0 ? allPipelines : [{pipeline: activePipeline, stages: pipelineStages, statuses: mappingStatuses}]).map((pData, pIdx) => {
                                    if (pIdx > 0 && !showAllPipelines) return null;
                                    
                                    const pipeline = pData.pipeline;
                                    const stages = pData.stages;
                                    const statuses = pData.statuses;
                                    
                                    return (
                                        <div key={pipeline.PipeLineID || pIdx} className="mb-4 last:mb-0">
                                            <div className="flex items-center gap-2 mb-4">
                                                <GitBranch size={16} className="text-gray-600" />
                                                <span className="font-bold text-gray-800 text-[13px]">{pipeline.PipelineName} Pipeline</span>
                                            </div>

                                            {/* Hide native scrollbar with CSS but keep overflowX auto */}
                                            <div className="relative" style={{ overflowX: 'auto', paddingBottom: '10px', scrollbarWidth: 'none', msOverflowStyle: 'none' }} id={`pipeline-scroll-area-leads-${pIdx}`}>
                                                <style>{`#pipeline-scroll-area-leads-${pIdx}::-webkit-scrollbar { display: none; }`}</style>
                                                <div className="flex items-start" style={{ minWidth: 'max-content' }}>
                                                    {/* Connecting line */}
                                                    <div className="absolute top-[13px] left-[60px] right-[60px] h-[2px] bg-gray-200 z-0"></div>

                                                    {stages.map((stage, idx) => {
                                                        const currentStageId = parseInt(lead?.StageID || lead?.stageid || lead?.StageId || 0, 10);
                                                        const currentStageName = (lead?.StageName || lead?.stagename || "").toLowerCase();

                                                        const currentStageObj = stages.find(s => s.Id === currentStageId || s.Name.toLowerCase() === currentStageName);
                                                        const currentSeq = currentStageObj ? currentStageObj.Sequence : -1;

                                                        const isCompleted = stage.Sequence <= currentSeq;
                                                        const isActive = stage.Id === currentStageId || stage.Name.toLowerCase() === currentStageName;

                                                        const historyItem = pipelineHistory.find(h => (h.StageName === stage.Name || h.Name === stage.Name));
                                                        const mappedStatus = statuses[stage.Id];
                                                        const isMapped = mappedStatus && mappedStatus.Status === "Mapped";
                                                        const isDark = isMapped || isActive || isCompleted;

                                                        let displayDate = "";
                                                        if (mappedStatus) displayDate = mappedStatus.CreatedDate.split(' ')[0];
                                                        else if (historyItem) displayDate = new Date(historyItem.CreatedOn || historyItem.Date).toLocaleDateString('en-GB');

                                                        return (
                                                            <div key={stage.Id} className="relative z-10 flex flex-col items-center" style={{ width: '120px' }}>
                                                                {/* Circle */}
                                                                <div 
                                                                    className={`w-7 h-7 rounded-full flex items-center justify-center border-2 mb-2 transition-colors duration-300 ${isDark ? 'text-white' : 'bg-white border-gray-300 text-transparent'}`}
                                                                    style={isDark ? { borderColor: '#0ea5e9', backgroundColor: '#0ea5e9', boxShadow: '0 0 0 4px rgba(14, 165, 233, 0.1)' } : {}}
                                                                >
                                                                    {isDark && <Check size={16} strokeWidth={4} />}
                                                                </div>
                                                                {/* Name */}
                                                                <span className={`text-[11px] text-center px-1 leading-tight ${isDark ? 'font-bold text-gray-800' : 'font-medium text-gray-500'}`}>
                                                                    {stage.Name}
                                                                </span>
                                                                {/* Date */}
                                                                {displayDate && (
                                                                    <span className="text-[10px] text-gray-400 mt-0.5">{displayDate}</span>
                                                                )}
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                                
                                {allPipelines.length > 1 && (
                                    <div className="flex justify-center mt-1 border-t border-gray-100 pt-3 pb-1">
                                        <button 
                                            onClick={() => setShowAllPipelines(!showAllPipelines)}
                                            className="text-[11px] font-bold text-[#0ea5e9] hover:text-blue-700 flex items-center gap-1 transition-colors uppercase tracking-wider"
                                        >
                                            {showAllPipelines ? (
                                                <><ChevronUp size={14} /> Show Less Pipelines</>
                                            ) : (
                                                <><ChevronDown size={14} /> View {allPipelines.length - 1} More Pipeline{allPipelines.length > 2 ? 's' : ''}</>
                                            )}
                                        </button>
                                    </div>
                                )}
                            </div>
                        )}

                    <div className="details-section other-details" style={{ marginTop: '16px', display: 'flex', flexDirection: 'column' }}>
                        <div className="section-header" style={{ background: '#f8fafc', borderBottom: '1px solid #e2e8f0', padding: '12px 20px', fontSize: '13px', fontWeight: '700', color: '#475569' }}>
                            <span>Other Details</span>
                        </div>
                        <div className="section-body" style={{ padding: '0px' }}>
                            <div className="read-only-details" style={{ padding: '20px 25px' }}>
                                <div style={{
                                    display: 'grid',
                                    gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
                                    gap: '12px 40px',
                                    fontSize: '13px'
                                }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                        <span style={{ fontWeight: '700', color: '#1f2937', minWidth: '130px' }}>Source :</span>
                                        <span style={{ color: '#4b5563' }} title={getMaskedValue('SourceName', lead.SourceName)}>{getMaskedValue('SourceName', lead.SourceName) || '-'}</span>
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                        <span style={{ fontWeight: '700', color: '#1f2937', minWidth: '130px' }}>Followup Status :</span>
                                        <span style={{ color: '#4b5563' }} title={lead.FollowupStatus}>{lead.FollowupStatus || '-'}</span>
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                        <span style={{ fontWeight: '700', color: '#1f2937', minWidth: '130px' }}>Assigned To :</span>
                                        <span style={{ color: '#4b5563' }} title={lead.assigneduser}>{lead.assigneduser || '-'}</span>
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                        <span style={{ fontWeight: '700', color: '#1f2937', minWidth: '130px' }}>Last FollowUp By :</span>
                                        <span style={{ color: '#4b5563' }} title={lead.LastFollowupCreatedByName}>{lead.LastFollowupCreatedByName || '-'}</span>
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                        <span style={{ fontWeight: '700', color: '#1f2937', minWidth: '130px' }}>Last FollowUp On :</span>
                                        <span style={{ color: '#4b5563' }} title={lead.LastFollowupedOn}>{lead.LastFollowupedOn || '-'}</span>
                                    </div>
                                </div>
                                <div className="flex justify-between items-center mt-3 pt-3" style={{ borderTop: '1px solid #f1f5f9' }}>
                                    <button onClick={() => setIsFullDetailsOpen(true)} className="text-[13px] text-blue-600 font-semibold flex items-center gap-1 hover:text-blue-800 transition-colors uppercase tracking-wider ml-auto">
                                        View More
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>


                        {/* Activity Section */}
                        <div className="bg-white rounded-lg shadow-sm">
                            <div className="border-b border-gray-200 flex items-center justify-between" style={{ overflow: 'visible' }}>
                                <div className="flex px-4 items-center gap-0 overflow-x-auto flex-1" style={{ scrollbarWidth: 'none' }}>
                                    {tabsOrder.map(tab => (
                                        <button
                                            key={tab}
                                            draggable
                                            onDragStart={(e) => handleDragStart(e, tab, 'main')}
                                            onDragOver={handleDragOver}
                                            onDrop={(e) => handleDrop(e, tab, 'main')}
                                            onDragEnd={handleDragEnd}
                                            onClick={() => { setActiveTab(tab.toLowerCase()); setTabFetchKey(k => k + 1); }}
                                            onContextMenu={(e) => handleContextMenu(e, tab, 'main')}
                                            className={`py-4 px-3 text-sm font-medium capitalize border-b-2 transition cursor-move whitespace-nowrap ${activeTab === tab.toLowerCase()
                                                ? 'border-blue-600 text-blue-600'
                                                : 'border-transparent text-gray-500 hover:text-gray-700'
                                                } ${draggedItem?.tab === tab && draggedItem?.source === 'main' ? 'opacity-50' : ''}`}
                                        >
                                            {tab}
                                        </button>
                                    ))}
                                </div>

                                <div className="flex items-center gap-1 pr-4 flex-shrink-0 relative overflow-visible z-[99]" style={{ overflow: 'visible' }}>
                                    {/* AI Summary Button + Popup */}
                                    <div className="relative" ref={null}>
                                        <button
                                            onClick={fetchAiSummary}
                                            className="py-4 px-2 hover:bg-gray-100 rounded-full transition-colors group relative"
                                            title="Generate AI Summary"
                                        >
                                            <Sparkles className={`w-4 h-4 ${isNewFollowup ? 'text-blue-500 animate-bounce' : (showAiSummary || aiSummaryData ? 'text-blue-500' : 'text-gray-400')}`} />
                                        </button>

                                        {/* Floating Popup near icon */}
                                        {showAiSummary && (
                                            <div className="absolute right-0 top-full mt-1 z-50 w-[380px] bg-white rounded-xl shadow-2xl border border-blue-100 overflow-hidden flex flex-col">
                                                <div className="bg-gradient-to-r from-blue-600 to-indigo-600 px-5 py-3 flex items-center justify-between shadow-sm">
                                                    <div className="flex items-center gap-2">
                                                        <Sparkles className="w-5 h-5 text-yellow-300" />
                                                        <h3 className="text-white font-semibold text-[15px] tracking-wide">AI Lead Summary</h3>
                                                    </div>
                                                    <button
                                                        onClick={(e) => { e.stopPropagation(); setShowAiSummary(false); }}
                                                        className="text-blue-100 hover:text-white transition-colors bg-blue-700/30 hover:bg-blue-700/50 p-1 rounded-full"
                                                        title="Close"
                                                    >
                                                        <X size={16} />
                                                    </button>
                                                </div>
                                                <div className="p-5 max-h-[350px] overflow-y-auto bg-gradient-to-b from-white to-blue-50/30" style={{ scrollbarWidth: 'thin', scrollbarColor: '#cbd5e1 transparent' }}>
                                                    <div className="text-[13.5px] text-gray-700">
                                                        {isAiLoading ? (
                                                            <div className="flex flex-col items-center justify-center py-10 gap-4">
                                                                <Sparkles className="w-8 h-8 text-blue-500 animate-pulse" />
                                                                <p className="text-blue-600 font-medium animate-pulse tracking-wide">Generating insights...</p>
                                                            </div>
                                                        ) : (
                                                            <div className="whitespace-pre-wrap leading-relaxed text-gray-800 font-medium">
                                                                {aiSummaryData || 'No summary available.'}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>

                                    <div className="relative" ref={moreDropdownRef} style={{ overflow: 'visible' }}>
                                        <button
                                            onClick={() => setShowMoreDropdown(!showMoreDropdown)}
                                            className="py-4 px-2 text-gray-600 hover:text-gray-900 transition"
                                            title="More"
                                        >
                                            <MoreVertical className="w-5 h-5" />
                                        </button>
                                        {showMoreDropdown && (
                                            <div className="absolute right-0 top-full mt-1 w-48 bg-white border border-gray-200 rounded-lg shadow-lg z-[9999] overflow-y-auto max-h-[300px]">
                                                {moreTabsOrder.map((item) => (
                                                    <div
                                                        key={item}
                                                        draggable
                                                        onDragStart={(e) => handleDragStart(e, item, 'more')}
                                                        onDragOver={handleDragOver}
                                                        onDrop={(e) => handleDrop(e, item, 'more')}
                                                        onDragEnd={handleDragEnd}
                                                        onClick={() => { setActiveTab(item.toLowerCase()); setTabFetchKey(k => k + 1); setShowMoreDropdown(false); }}
                                                        onContextMenu={(e) => handleContextMenu(e, item, 'more')}
                                                        className={`w-full text-left px-4 py-3 text-sm text-gray-700 hover:bg-gray-50 transition border-b border-gray-100 last:border-b-0 cursor-move ${draggedItem?.tab === item && draggedItem?.source === 'more' ? 'opacity-50' : ''}`}
                                                    >
                                                        {item}
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                </div>

                                {/* Context Menu */}
                                {contextMenu.show && (
                                    <div
                                        id="context-menu"
                                        className="fixed bg-white border border-gray-200 rounded-lg shadow-lg z-[9999] py-1 min-w-[160px]"
                                        style={{
                                            left: `${contextMenu.x}px`,
                                            top: `${contextMenu.y}px`
                                        }}
                                        onClick={(e) => e.stopPropagation()}
                                    >
                                        {contextMenu.source === 'main' ? (
                                            <button
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    moveToDropdown(contextMenu.tab);
                                                }}
                                                className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition"
                                            >
                                                Move to More Menu
                                            </button>
                                        ) : (
                                            <button
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    moveToMainTabs(contextMenu.tab);
                                                }}
                                                className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition disabled:opacity-50 disabled:cursor-not-allowed"
                                                disabled={tabsOrder.length >= MAX_MAIN_TABS}
                                            >
                                                Move to Main Tabs {tabsOrder.length >= MAX_MAIN_TABS && '(Full)'}
                                            </button>
                                        )}
                                    </div>
                                )}
                            </div>
                            
                            <div className="p-6 max-h-[300px] h-[300px] overflow-y-auto">
                                <div className="space-y-4">
                                    {(() => {
                                        if (activeTab === 'appointment') {
                                            return <AppointmentTab appointments={appointments} />;
                                        }
                                        if (activeTab === 'task') {
                                            return <TaskTab tasks={tasks} />;
                                        }

                                        let items = [];
                                        if (activeTab === 'calls') items = callLogs;
                                        else if (activeTab === 'followup') items = followups;
                                        else if (activeTab === 'notes') items = notes;
                                        else if (activeTab === 'documents' || activeTab === 'document') items = documents;
                                        else if (activeTab === 'task') items = tasks;
                                        else if (activeTab === 'webform') items = webforms;
                                        else if (activeTab === 'pipeline') items = pipelineHistory;
                                        else if (activeTab === 'chat') items = chatLogs;
                                        else if (activeTab === 'wachatlog' || activeTab === 'wachat log') items = chatLogs;
                                        else if (activeTab === 'meeting') items = [...meetings, ...pastMeetings];
                                        else items = activities;

                                        if (!items || items.length === 0) {
                                            return (
                                                <div className="flex items-center justify-center py-6">
                                                    <p className="text-gray-500">No items found</p>
                                                </div>
                                            );
                                        }

                                        if (activeTab === 'followup') {
                                            return (
                                                <div className="overflow-x-auto border border-gray-200 rounded-lg">
                                                    <table className="w-full min-w-[1050px]">
                                                        <thead className="bg-gray-50 border-b border-gray-200">
                                                            <tr>
                                                                <th className="px-3 py-3 text-left text-[15px] font-semibold text-gray-700">FollowupStatus</th>
                                                                <th className="px-3 py-3 text-left text-[15px] font-semibold text-gray-700">NextStatusDate</th>
                                                                <th className="px-3 py-3 text-left text-[15px] font-semibold text-gray-700">IsReassign</th>
                                                                <th className="px-3 py-3 text-left text-[15px] font-semibold text-gray-700">Remarks</th>
                                                                <th className="px-3 py-3 text-left text-[15px] font-semibold text-gray-700">Products</th>
                                                                <th className="px-3 py-3 text-left text-[15px] font-semibold text-gray-700">AmountPaid</th>
                                                                <th className="px-3 py-3 text-left text-[15px] font-semibold text-gray-700">AssignedTo</th>
                                                                <th className="px-3 py-3 text-left text-[15px] font-semibold text-gray-700">FollowupCreatedDate</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {items.map((item, idx) => {
                                                                const followupStatus = item.FollowupStatus || item.Status || '-';
                                                                const nextStatusDate = formatFollowupDateTime(item.NextStatusDate || item.FollowupDate || item.Date);
                                                                const isReassign = formatReassignValue(item.IsReassign ?? item.IsReAssign ?? item.Reassign);
                                                                const remarks = item.Remarks || item.FollowupRemarks || item.Description || '-';
                                                                const products = item.Products || item.ProductName || '-';
                                                                const amountPaid = formatFollowupAmount(item.AmountPaid ?? item.Amount);
                                                                const assignedTo = item.AssignedTo || item.AssignedToName || item.AssignedUser || item.UserLogin || '-';
                                                                const followupCreatedDate = formatFollowupDateTime(item.FollowupCreatedDate || item.CreatedDate || item.CreatedOn || item.EventDate);

                                                                return (
                                                                    <tr key={`followup-${idx}`} className="border-b border-gray-100 last:border-b-0">
                                                                        <td className="px-3 py-3 text-sm text-gray-700">{followupStatus}</td>
                                                                        <td className="px-3 py-3 text-sm text-gray-700">{nextStatusDate}</td>
                                                                        <td className="px-3 py-3 text-sm text-gray-700">{isReassign}</td>
                                                                        <td className="px-3 py-3 text-sm text-gray-700">{remarks}</td>
                                                                        <td className="px-3 py-3 text-sm text-gray-700">{products}</td>
                                                                        <td className="px-3 py-3 text-sm text-gray-700">{amountPaid}</td>
                                                                        <td className="px-3 py-3 text-sm text-gray-700">{assignedTo}</td>
                                                                        <td className="px-3 py-3 text-sm text-gray-700">{followupCreatedDate}</td>
                                                                    </tr>
                                                                );
                                                            })}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            );
                                        } else if (activeTab === 'notes') {
                                            return (
                                                <div className="overflow-x-auto border border-gray-200 rounded-lg">
                                                    <table className="w-full min-w-[800px]">
                                                        <thead className="bg-gray-50 border-b border-gray-200">
                                                            <tr>
                                                                <th className="px-4 py-3 text-left text-[15px] font-semibold text-gray-700">Date</th>
                                                                <th className="px-4 py-3 text-left text-[15px] font-semibold text-gray-700">Notes</th>
                                                                <th className="px-4 py-3 text-left text-[15px] font-semibold text-gray-700">CreatedBy</th>
                                                                <th className="px-4 py-3 text-left text-[15px] font-semibold text-gray-700">Action</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {items.map((n, i) => {
                                                                const dateRaw = n.CreatedDate || n.CreatedOn || n.Date || '';
                                                                let dateDisplay = dateRaw;
                                                                try {
                                                                    const d = new Date(dateRaw);
                                                                    if (!isNaN(d)) dateDisplay = d.toLocaleString();
                                                                } catch (e) { }

                                                                return (
                                                                    <tr key={i} className="border-b last:border-b-0">
                                                                        <td className="px-4 py-3 align-top text-gray-700">{dateDisplay}</td>
                                                                        <td className="px-4 py-3 align-top text-gray-900 whitespace-pre-wrap">{n.Notes}</td>
                                                                        <td className="px-4 py-3 align-top text-gray-700">{n.CreatedBy}</td>
                                                                        <td className="px-4 py-3 align-top text-gray-700">
                                                                            <button
                                                                                onClick={async (ev) => {
                                                                                    ev && ev.stopPropagation && ev.stopPropagation();
                                                                                    const confirm = await Swal.fire({
                                                                                        title: 'Delete note?',
                                                                                        text: 'This will permanently delete the note.',
                                                                                        icon: 'warning',
                                                                                        showCancelButton: true,
                                                                                        confirmButtonText: 'Delete',
                                                                                        cancelButtonText: 'Cancel'
                                                                                    });
                                                                                    if (!confirm.isConfirmed) return;
                                                                                    try {
                                                                                        const payload = {
                                                                                            Token: TokenId,
                                                                                            Message: "",
                                                                                            LoggedUserId: userId,
                                                                                            MAC_Address: "",
                                                                                            IP_Address: "102.16.32.189",
                                                                                            Details: { noteid: n.NoteID || n.NoteId || n.id || 0, UserId: userId },
                                                                                            BroadcastName: ""
                                                                                        };
                                                                                        const resp = await deleteNotes(payload);
                                                                                        const ok = resp && (resp.Status === 1 || resp.status === 1 || (typeof resp === 'string' && resp.includes('Success')) || resp === true);
                                                                                        if (ok) {
                                                                                            Swal.fire({ icon: 'success', title: 'Deleted', text: 'Note deleted.' });
                                                                                            // refresh notes list
                                                                                            try {
                                                                                                const notesPayload = {
                                                                                                    Token: TokenId,
                                                                                                    Message: "",
                                                                                                    LoggedUserId: userId,
                                                                                                    MAC_Address: "",
                                                                                                    IP_Address: "102.16.32.189",
                                                                                                    Details: { leadid: lead.ID || lead.LeadId || lead.Id || lead.id, parentid: parentId, userid: userId },
                                                                                                    BroadcastName: ""
                                                                                                };
                                                                                                const notesResp = await getNotesByLeadId(notesPayload);
                                                                                                let raw = notesResp?.Details ?? notesResp?.d ?? notesResp ?? [];
                                                                                                if (typeof raw === 'string') {
                                                                                                    try { raw = JSON.parse(raw); } catch (e) { }
                                                                                                }
                                                                                                if (raw && raw.Details && Array.isArray(raw.Details.data)) raw = raw.Details.data;
                                                                                                if (raw && raw.data && Array.isArray(raw.data)) raw = raw.data;
                                                                                                if (raw && Array.isArray(raw.Details)) raw = raw.Details;
                                                                                                const notesArray = Array.isArray(raw) ? raw : [];
                                                                                                const normalizedNotes = notesArray.map(nn => ({
                                                                                                    Notes: nn.Notes ?? nn.notes ?? nn.NoteText ?? '',
                                                                                                    CreatedBy: nn.CreatedBy ?? nn.CreatedByName ?? nn.UserName ?? nn.User ?? '',
                                                                                                    CreatedDate: nn.CreatedDate ?? nn.CreatedOn ?? nn.Date ?? '',
                                                                                                    NoteID: nn.NoteID ?? nn.ID ?? nn.Id ?? nn.id ?? ''
                                                                                                }));
                                                                                                setNotes(normalizedNotes);
                                                                                            } catch (err) {
                                                                                                console.error('refresh notes after delete error:', err);
                                                                                            }
                                                                                        } else {
                                                                                            Swal.fire({ icon: 'error', title: 'Error', text: resp?.Message || 'Failed to delete note.' });
                                                                                        }
                                                                                    } catch (err) {
                                                                                        console.error('delete note error:', err);
                                                                                        Swal.fire({ icon: 'error', title: 'Error', text: 'An error occurred while deleting note.' });
                                                                                    }
                                                                                }}
                                                                                className="text-blue-500 hover:text-blue-700"
                                                                                title="Delete"
                                                                            >
                                                                                🗑
                                                                            </button>
                                                                        </td>
                                                                    </tr>
                                                                );
                                                            })}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            );
                                        } else if (activeTab === 'documents' || activeTab === 'document') {
                                            return (
                                                <div className="overflow-x-auto border border-gray-200 rounded-lg">
                                                    <table className="w-full min-w-[800px]">
                                                        <thead className="bg-gray-50 border-b border-gray-200">
                                                            <tr>
                                                                <th className="px-4 py-3 text-left text-[15px] font-semibold text-gray-700">Date</th>
                                                                <th className="px-4 py-3 text-left text-[15px] font-semibold text-gray-700">Documents</th>
                                                                <th className="px-4 py-3 text-left text-[15px] font-semibold text-gray-700">UploadedBy</th>
                                                                <th className="px-4 py-3 text-left text-[15px] font-semibold text-gray-700">Action</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {items.map((doc, i) => {
                                                                const dateRaw = doc.CreatedDate || doc.CreatedOn || doc.Date || '';
                                                                let dateDisplay = dateRaw;
                                                                try { const d = new Date(dateRaw); if (!isNaN(d)) dateDisplay = d.toLocaleString(); } catch (e) { }
                                                                return (
                                                                    <tr key={`doc-${i}`} className="border-b border-gray-100 last:border-b-0">
                                                                        <td className="px-4 py-3 text-sm text-gray-700">{dateDisplay}</td>
                                                                        <td className="px-4 py-3 text-sm text-blue-600"><a href={doc.Url || '#'} target="_blank" rel="noreferrer">{doc.DocumentName || doc.FileName || '-'}</a></td>
                                                                        <td className="px-4 py-3 text-sm text-gray-700">{doc.UploadedBy}</td>
                                                                        <td className="px-4 py-3 text-sm text-gray-700">
                                                                            <button
                                                                                onClick={async (ev) => {
                                                                                    ev && ev.stopPropagation && ev.stopPropagation();
                                                                                    const confirm = await Swal.fire({
                                                                                        title: 'Delete document?',
                                                                                        text: 'This will permanently delete the document.',
                                                                                        icon: 'warning',
                                                                                        showCancelButton: true,
                                                                                        confirmButtonText: 'Delete',
                                                                                        cancelButtonText: 'Cancel'
                                                                                    });
                                                                                    if (!confirm.isConfirmed) return;
                                                                                    try {
                                                                                        const payload = {
                                                                                            Token: TokenId,
                                                                                            Message: "",
                                                                                            LoggedUserId: userId,
                                                                                            MAC_Address: "",
                                                                                            IP_Address: "102.16.32.189",
                                                                                            Details: { DocUpID: doc.DocumentID || doc.DocUpID || 0, UserId: userId },
                                                                                            BroadcastName: ""
                                                                                        };
                                                                                        const resp = await deleteDocument(payload);
                                                                                        const ok = resp && (resp.Status === 1 || resp.status === 1 || resp === true || (typeof resp === 'string' && resp.includes('Success')));
                                                                                        if (ok) {
                                                                                            Swal.fire({ icon: 'success', title: 'Deleted', text: 'Document deleted.' });
                                                                                            setDocuments(prev => Array.isArray(prev) ? prev.filter(p => String(p.DocumentID) !== String(doc.DocumentID) && String(p.DocumentID) !== String(doc.DocUpID)) : []);
                                                                                        } else {
                                                                                            Swal.fire({ icon: 'error', title: 'Error', text: resp?.Message || 'Failed to delete document.' });
                                                                                        }
                                                                                    } catch (err) {
                                                                                        console.error('delete document error:', err);
                                                                                        Swal.fire({ icon: 'error', title: 'Error', text: 'An error occurred while deleting document.' });
                                                                                    }
                                                                                }}
                                                                                className="text-red-500 hover:text-red-700"
                                                                                title="Delete"
                                                                            >
                                                                                🗑
                                                                            </button>
                                                                        </td>
                                                                    </tr>
                                                                );
                                                            })}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            );
                                        } else if (activeTab === 'calls') {
                                            return (
                                                <div>
                                                    <div className="overflow-x-auto border border-gray-200 rounded-lg">
                                                        <table className="w-full min-w-[650px]">
                                                            <thead className="bg-gray-50 border-b border-gray-200">
                                                                <tr>
                                                                    <th className="px-4 py-3 text-left text-[13px] font-semibold text-gray-700 w-[40%]">Call Details</th>
                                                                    <th className="px-4 py-3 text-left text-[13px] font-semibold text-gray-700 w-[25%]">Call Time</th>
                                                                    <th className="px-4 py-3 text-left text-[13px] font-semibold text-gray-700 w-[35%]">Recording</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {items.map((log, idx) => {
                                                                    const agentName = log.AgentName || log.CallerName || log.UserName || log.Agent || '-';
                                                                    const phone = log.CallerNo || log.PhoneNo || log.MobileNo || log.Phone || '';
                                                                    const direction = log.Direction || log.CallType || log.CallDirection || '';
                                                                    const duration = log.Duration || log.CallDuration || log.TalkTime || '';
                                                                    const startTime = log.CallStartTime || log.StartTime || log.CreatedDate || log.CallDate || '';
                                                                    let timeDisplay = startTime;
                                                                    try { const d = new Date(startTime); if (!isNaN(d) && startTime) timeDisplay = d.toLocaleString(); } catch (e) { }
                                                                    const recordingUrl = log.RecordingURL || log.CallRecordingPath || log.RecordingPath || log.AudioPath || log.RecordingUrl || '';
                                                                    const isInbound = direction.toLowerCase().includes('inbound');
                                                                    return (
                                                                        <tr key={`call-${idx}`} className="border-b border-gray-100 last:border-b-0 hover:bg-gray-50 transition-colors">
                                                                            <td className="px-4 py-3">
                                                                                <div className="flex flex-col gap-1">
                                                                                    <span className="font-medium text-sm text-gray-800">{agentName}</span>
                                                                                    {phone && <span className="text-xs text-gray-500">{phone}</span>}
                                                                                    <div className="flex items-center gap-2 flex-wrap">
                                                                                        {direction && (
                                                                                            <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-semibold ${isInbound ? 'bg-green-100 text-green-700' : 'bg-blue-100 text-blue-700'}`}>
                                                                                                {isInbound ? '↙ ' : '↗ '}{direction}
                                                                                            </span>
                                                                                        )}
                                                                                        {duration && <span className="text-xs text-gray-400">⏱ {duration}</span>}
                                                                                    </div>
                                                                                </div>
                                                                            </td>
                                                                            <td className="px-4 py-3 text-sm text-gray-600">{timeDisplay || '-'}</td>
                                                                            <td className="px-4 py-3">
                                                                                {recordingUrl ? (
                                                                                    <audio controls src={recordingUrl} className="h-8 w-full max-w-[210px]" preload="none" />
                                                                                ) : (
                                                                                    <span className="text-xs text-gray-400 italic">No recording</span>
                                                                                )}
                                                                            </td>
                                                                        </tr>
                                                                    );
                                                                })}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                    {callLogsHasMore && (
                                                        <div className="flex justify-center mt-3">
                                                            <button
                                                                onClick={async () => {
                                                                    try {
                                                                        setCallLogsLoading(true);
                                                                        const entityId = lead?.LeadId || lead?.ID || lead?.Id || lead?.id;
                                                                        const data = await getCallLog({ EntityName: 'Lead', EntityID: entityId, Start: callLogsStart, Limit: 10 });
                                                                        setCallLogs(prev => [...prev, ...data]);
                                                                        setCallLogsHasMore(data.length >= 10);
                                                                        setCallLogsStart(s => s + data.length);
                                                                    } catch (err) {
                                                                        console.error('loadMoreCallLogs error:', err);
                                                                    } finally {
                                                                        setCallLogsLoading(false);
                                                                    }
                                                                }}
                                                                disabled={callLogsLoading}
                                                                className="px-5 py-2 text-sm font-medium text-blue-600 border border-blue-200 rounded-lg hover:bg-blue-50 disabled:opacity-50 transition"
                                                            >
                                                                {callLogsLoading ? 'Loading...' : 'Load More'}
                                                            </button>
                                                        </div>
                                                    )}
                                                </div>
                                            );
                                        } else if (activeTab === 'pipeline') {
                                            return (
                                                <div className="overflow-x-auto border border-gray-200 rounded-lg">
                                                    <table className="w-full min-w-[800px]">
                                                        <thead className="bg-gray-50 border-b border-gray-200">
                                                            <tr>
                                                                <th className="px-4 py-3 text-left text-[15px] font-semibold text-gray-700">Pipeline</th>
                                                                <th className="px-4 py-3 text-left text-[15px] font-semibold text-gray-700">Probability(%)</th>
                                                                <th className="px-4 py-3 text-left text-[15px] font-semibold text-gray-700">DealOwner</th>
                                                                <th className="px-4 py-3 text-left text-[15px] font-semibold text-gray-700">Creation Details</th>
                                                                <th className="px-4 py-3 text-left text-[15px] font-semibold text-gray-700">Remarks</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {items.map((p, i) => {
                                                                const dateRaw = p.CreatedDate || p.CreatedOn || p.Date || '';
                                                                let dateDisplay = dateRaw;
                                                                try {
                                                                    const d = new Date(dateRaw);
                                                                    if (!isNaN(d)) dateDisplay = d.toLocaleString();
                                                                } catch (e) { }

                                                                return (
                                                                    <tr key={`pipeline-${i}`} className="border-b border-gray-100 last:border-b-0">
                                                                        <td className="px-4 py-3 text-sm text-gray-700">
                                                                            <div className="font-medium">{p.PipelineName || '-'}</div>
                                                                            {p.StageName && <div className="text-xs text-gray-500 mt-0.5">{p.StageName}</div>}
                                                                        </td>
                                                                        <td className="px-4 py-3 text-sm text-gray-700">{p.Probability ?? '-'}</td>
                                                                        <td className="px-4 py-3 text-sm text-gray-700">{p.DealOwnerByName || p.DealOwner || '-'}</td>
                                                                        <td className="px-4 py-3 text-sm text-gray-700">{dateDisplay}</td>
                                                                        <td className="px-4 py-3 text-sm text-gray-700">{p.Remarks || p.Description || '-'}</td>
                                                                    </tr>
                                                                );
                                                            })}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            );
                                        } else if (activeTab === 'webform') {
                                            return (
                                                <div className="overflow-x-auto border border-gray-200 rounded-lg">
                                                    <table className="w-full min-w-[900px]">
                                                        <thead className="bg-gray-50 border-b border-gray-200">
                                                            <tr>
                                                                <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">Serial No</th>
                                                                <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">Form Name</th>
                                                                <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">Entry Date</th>
                                                                <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">Form Data</th>
                                                                <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">Agent</th>
                                                            </tr>
                                                        </thead>

                                                        <tbody>
                                                            {webforms.map((w, i) => {
                                                                // format date
                                                                let dateDisplay = w.EntryDate;
                                                                try {
                                                                    const d = new Date(w.EntryDate);
                                                                    if (!isNaN(d)) dateDisplay = d.toLocaleString();
                                                                } catch { }

                                                                return (
                                                                    <tr key={i} className="border-b last:border-b-0">
                                                                        <td className="px-4 py-3">{w.EntryNo}</td>
                                                                        <td className="px-4 py-3 text-blue-600 font-medium">{w.FormName}</td>
                                                                        <td className="px-4 py-3">{dateDisplay}</td>

                                                                        <td className="px-4 py-3">
                                                                            <div className="max-w-[300px] break-words text-sm text-gray-700">
                                                                                {Object.entries(w.FormData || {}).map(([key, val]) => (
                                                                                    <div key={key}>
                                                                                        <strong>{key}:</strong> {String(val)}
                                                                                    </div>
                                                                                ))}
                                                                            </div>
                                                                        </td>

                                                                        <td className="px-4 py-3">{w.Agent}</td>
                                                                    </tr>
                                                                );
                                                            })}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            );
                                        } else if (activeTab === 'chat') {
                                            return (
                                                <div className="space-y-4">
                                                    <div className="bg-gray-50 border border-gray-200 rounded-lg overflow-hidden shadow-sm">
                                                        <div className="bg-white px-4 py-3 border-b border-gray-200 flex justify-between items-center">
                                                            <h4 className="text-sm font-bold text-gray-700 uppercase tracking-wider flex items-center gap-2">
                                                                <MessageSquare className="w-4 h-4 text-blue-500" />
                                                                Archived Chat
                                                            </h4>
                                                            <div className="flex items-center gap-4 text-[10px] font-bold uppercase">
                                                                <div className="flex items-center gap-1.5">
                                                                    <span className="w-2 h-2 rounded-full bg-green-500 shadow-[0_0_5px_rgba(34,197,94,0.5)]"></span>
                                                                    <span className="text-gray-500">Agent</span>
                                                                </div>
                                                                <div className="flex items-center gap-1.5">
                                                                    <span className="w-2 h-2 rounded-full bg-gray-400"></span>
                                                                    <span className="text-gray-500">Visitor</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="p-4 space-y-4 max-h-[500px] overflow-y-auto bg-white/50">
                                                            {items.length > 0 ? items.map((log, idx) => {
                                                                const isAgent = log.Type === 'agent' || log.SenderType === 'Agent' || log.isAgent === true || log.SenderName?.toLowerCase().includes('agent');
                                                                const message = log.Message || log.Text || log.message || '';
                                                                const sender = log.SenderName || (isAgent ? 'Agent' : 'Visitor');
                                                                const timeRaw = log.CreatedDate || log.Date || log.Timestamp || '';
                                                                let timeDisplay = timeRaw;
                                                                try {
                                                                    const d = new Date(timeRaw);
                                                                    if (!isNaN(d)) timeDisplay = d.toLocaleString();
                                                                } catch (e) { }

                                                                return (
                                                                    <div key={idx} className={`flex ${isAgent ? 'justify-start' : 'justify-end'} w-full`}>
                                                                        <div className={`max-w-[85%] rounded-2xl p-4 shadow-sm border ${isAgent
                                                                            ? 'bg-green-50 border-green-100 rounded-tl-none'
                                                                            : 'bg-white border-gray-100 rounded-tr-none'
                                                                            }`}>
                                                                            <div className="flex justify-between items-center gap-6 mb-2">
                                                                                <span className={"text-[10px] font-bold uppercase tracking-tighter " + (isAgent ? "text-green-600" : "text-gray-400")}>
                                                                                    {sender}
                                                                                </span>
                                                                                <span className="text-[9px] text-gray-400 font-medium">
                                                                                    {timeDisplay}
                                                                                </span>
                                                                            </div>
                                                                            <div className="text-[13px] text-gray-800 leading-relaxed whitespace-pre-wrap">
                                                                                {message}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                );
                                                            }) : (
                                                                <div className="flex flex-col items-center justify-center py-12 text-gray-400">
                                                                    <MessageSquare className="w-12 h-12 mb-3 opacity-20" />
                                                                    <p className="text-sm font-medium">No archived chat history found</p>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        } else if (activeTab === 'wachatlog' || activeTab === 'wachat log') {
                                            const grouped = items.reduce((acc, item) => {
                                                const dateRaw = item.CreatedDate || item.Date || item.EventDate || '';
                                                let dateStr = 'Unknown';
                                                try {
                                                    const d = new Date(dateRaw);
                                                    if (!isNaN(d)) {
                                                        dateStr = d.toLocaleDateString('en-GB', { day: '2-digit', month: 'long', year: 'numeric' }).replace(/ /g, '-');
                                                    }
                                                } catch (e) { }
                                                if (!acc[dateStr]) acc[dateStr] = [];
                                                acc[dateStr].push(item);
                                                return acc;
                                            }, {});

                                            return (
                                                <div className="space-y-6">
                                                    {Object.entries(grouped).map(([date, msgs]) => (
                                                        <div key={date} className="space-y-4">
                                                            <div className="flex justify-center sticky top-0 z-10 py-2">
                                                                <span className="bg-[#56c080] text-white px-6 py-1 rounded-md text-sm font-bold shadow-sm">
                                                                    {date}
                                                                </span>
                                                            </div>
                                                            {msgs.map((m, i) => {
                                                                const isOutbound = m.Direction === 'Outbound' || m.Direction === 'Out' || m.SenderName === 'System' || !m.VisitorName;
                                                                return (
                                                                    <div key={i} className="flex items-center gap-3 w-full">
                                                                        <div className="flex-shrink-0">
                                                                            <div className="w-10 h-10 flex items-center justify-center text-gray-400">
                                                                                <Clock className="w-5 h-5" />
                                                                            </div>
                                                                        </div>
                                                                        <div className="flex-1 bg-[#e3f2fd] p-4 rounded-xl shadow-sm border border-[#bbdefb]">
                                                                            <div className="text-[15px] text-gray-800 leading-relaxed whitespace-pre-wrap">
                                                                                {m.Message || m.Text || m.EventName || ''}
                                                                            </div>
                                                                        </div>
                                                                        <div className="flex-shrink-0">
                                                                            <div className="relative">
                                                                                <div className="w-10 h-10 bg-white rounded-full border border-gray-200 flex items-center justify-center overflow-hidden">
                                                                                    <img src="https://docs.kit19.com/default/person.png" alt="bot" className="w-7 h-7 object-contain opacity-70" />
                                                                                </div>
                                                                                <div className="absolute -bottom-1 -right-1 bg-white rounded-full p-0.5 border border-gray-100">
                                                                                    <FaWhatsapp className="w-3.5 h-3.5 text-green-500" />
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                );
                                                            })}
                                                        </div>
                                                    ))}
                                                </div>
                                            );
                                        } else if (activeTab === 'meeting') {
                                            const currentList = meetingTab === 'upcoming' ? meetings : pastMeetings;

                                            return (
                                                <div className="flex flex-col h-full bg-white">
                                                    <div className="flex border-b border-gray-200 mb-4">
                                                        <button
                                                            className={`px-4 py-3 font-medium text-sm transition-colors ${meetingTab === 'upcoming' ? 'border-b-2 border-blue-600 text-blue-600' : 'text-gray-500 hover:text-gray-700 hover:border-gray-300 border-b-2 border-transparent'}`}
                                                            onClick={() => setMeetingTab('upcoming')}
                                                        >
                                                            Current/Upcoming
                                                        </button>
                                                        <button
                                                            className={`px-4 py-3 font-medium text-sm transition-colors ${meetingTab === 'past' ? 'border-b-2 border-blue-600 text-blue-600' : 'text-gray-500 hover:text-gray-700 hover:border-gray-300 border-b-2 border-transparent'}`}
                                                            onClick={() => setMeetingTab('past')}
                                                        >
                                                            Past
                                                        </button>
                                                    </div>
                                                    <div className="overflow-x-auto border border-gray-200 rounded-lg">
                                                        <table className="w-full min-w-[900px]">
                                                            <thead className="bg-gray-50 border-b border-gray-200">
                                                                <tr>
                                                                    <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">Meeting Title</th>
                                                                    <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">Scheduled On</th>
                                                                    <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">Status</th>
                                                                    <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">Action</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {currentList.length === 0 ? (
                                                                    <tr>
                                                                        <td colSpan="4" className="px-4 py-8 text-center text-gray-500">No meetings found.</td>
                                                                    </tr>
                                                                ) : currentList.map((m, i) => (
                                                                    <tr key={i} className="border-b border-gray-100 last:border-b-0 hover:bg-gray-50 transition-colors">
                                                                        <td className="px-4 py-3 align-top">
                                                                            <div className="font-bold text-gray-900">{m.Meetname || '-'}</div>
                                                                            <div className="text-sm text-gray-500 flex items-center gap-1 mt-1">
                                                                                <span className="font-medium text-gray-700">Host:</span> {m.Host || m.Email || '-'}
                                                                            </div>
                                                                        </td>
                                                                        <td className="px-4 py-3 align-top">
                                                                            <div className="font-medium text-gray-800">{m.MeetStartDate || '-'}</div>
                                                                            <div className="text-sm text-gray-500 mt-0.5">{m.MeetStartTime || '-'} <span className="text-gray-400">({m.Duration || '-'} hrs)</span></div>
                                                                        </td>
                                                                        <td className="px-4 py-3 align-top">
                                                                            <div className="text-sm text-gray-700 mb-1">
                                                                                <span className="font-medium mr-1 text-gray-600">Host/Co-host:</span> {m.CohostCount || 0}
                                                                            </div>
                                                                            <div className="text-sm text-gray-700">
                                                                                <span className="font-medium mr-1 text-gray-600">Attendees:</span> {m.ParticipantCount || 0}
                                                                            </div>
                                                                        </td>
                                                                        <td className="px-4 py-3 align-top">
                                                                            <div className="flex items-center gap-2">
                                                                                {m.Isactive === 'True' && meetingTab === 'upcoming' && m.Sequence === 1 && (m.User_Role === 'host' || m.User_Role === 'cohost') ? (
                                                                                    <a href={m.CreateMeetLink || m.JoinLink || '#'} target="_blank" rel="noreferrer" className="px-4 py-1.5 bg-[#088b7e] text-white rounded text-sm font-medium hover:bg-[#077a6e] transition">Start</a>
                                                                                ) : m.Isactive === 'True' && meetingTab === 'upcoming' ? (
                                                                                    <a href={m.JoinLink || '#'} target="_blank" rel="noreferrer" className="px-4 py-1.5 bg-blue-600 text-white rounded text-sm font-medium hover:bg-blue-700 transition">Join Now</a>
                                                                                ) : (
                                                                                    <span className="px-4 py-1.5 bg-gray-100 text-gray-600 border border-gray-200 rounded text-sm font-medium">View</span>
                                                                                )}
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            );
                                        } else if (activeTab === 'activities') {
                                            return (
                                                <div className="relative border-l-2 border-gray-300 ml-4 space-y-6 pb-4">
                                                    {items.map((item, idx) => {
                                                        const avatar = resolveUrl(item.EventType || item.Image || item.Avatar);
                                                        const time = item.EventDate || item.CallDate || item.Date || item.CreatedDate || item.CreatedOn || '';
                                                        const desc = item.EventDescription || item.Description || '';
                                                        const title = item.EventName || item.Title || '';
                                                        const timeDisplay = time ? new Date(time).toLocaleString() : '';

                                                        return (
                                                            <div key={idx} className="relative pl-6">
                                                                <div className="absolute -left-[17px] top-0 w-8 h-8 rounded-full border-2 border-gray-300 bg-white flex items-center justify-center z-10 overflow-hidden">
                                                                    <img src={avatar} alt="icon" className="w-5 h-5 object-contain" onError={(e) => e.target.src = 'https://docs.kit19.com/default/person.png'} />
                                                                </div>
                                                                <div className="flex flex-col pt-1">
                                                                    <span className="text-[13px] font-bold text-gray-800">{desc || title}</span>
                                                                    {desc && title && desc !== title && (
                                                                        <span className="text-[13px] text-gray-600 mt-0.5">{title}</span>
                                                                    )}
                                                                    {timeDisplay && (
                                                                        <span className="text-[13px] text-blue-500 mt-0.5">{timeDisplay}</span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            );
                                        }
                                        return items.map((item, idx) => {
                                            const avatar = resolveUrl(item.EventType || item.Image || item.Avatar);
                                            const time = item.EventDate || item.CallDate || item.Date || item.CreatedDate || item.CreatedOn || '';
                                            const primary = item.EventName || item.Title || item.Subject || item.TaskName || item.Name || item.Description || item.Message || JSON.stringify(item).slice(0, 80);
                                            const secondary = item.UserLogin || item.UserName || item.CreatedBy || item.Caller || item.VisitorName || item.SenderName || '';
                                            return (
                                                <div key={idx} className="flex gap-3">
                                                    <img src={avatar} alt={secondary} className="w-8 h-8 object-cover flex-shrink-0" onError={(e) => e.target.src = 'https://docs.kit19.com/default/person.png'} />
                                                    <div className="flex-1">
                                                        <p className="text-gray-900 font-medium">{primary}</p>
                                                        <p className="text-sm text-gray-500">{secondary} • {time ? new Date(time).toLocaleString() : ''}</p>
                                                    </div>
                                                </div>
                                            );
                                        });
                                    })()}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Quick Actions Sidebar - Enquiries Style */}
                    <div className={`transition-all duration-300 relative ${isRightCollapsed ? 'w-0 overflow-hidden opacity-0' : 'w-auto opacity-100'}`} style={{ maxHeight: 'calc(100vh - 120px)', overflowY: 'auto', overflowX: 'hidden', zIndex: 1 }}>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', position: 'sticky', top: '0' }}>

                            {/* Call — always visible */}
                            <button
                                onClick={(e) => handleClickToCall(e, lead?.MobileNo)}
                                style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px', padding: '14px 20px', background: '#2563eb', border: 'none', borderRadius: '8px', color: '#ffffff', fontSize: '15px', fontWeight: '600', cursor: 'pointer', width: '100%', boxShadow: '0 1px 3px rgba(0,0,0,0.1)', transition: 'all 0.2s ease' }}
                                onMouseEnter={e => { e.currentTarget.style.background = '#1d4ed8'; }}
                                onMouseLeave={e => { e.currentTarget.style.background = '#2563eb'; }}
                            >
                                <Phone style={{ color: '#ffffff', width: '20px', height: '20px' }} />
                                Call
                            </button>

                            {/* Add FollowUp */}
                            {canAddFollowup && (
                                <button
                                    onClick={() => setIsAddLeadModal(true)}
                                    style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px', padding: '14px 20px', background: '#ffffff', border: '1px solid #e2e8f0', borderRadius: '8px', color: '#16a34a', fontSize: '15px', fontWeight: '600', cursor: 'pointer', width: '100%', boxShadow: '0 1px 3px rgba(0,0,0,0.05)', transition: 'all 0.2s ease' }}
                                    onMouseEnter={e => { e.currentTarget.style.background = '#f0fdf4'; e.currentTarget.style.borderColor = '#86efac'; }}
                                    onMouseLeave={e => { e.currentTarget.style.background = '#ffffff'; e.currentTarget.style.borderColor = '#e2e8f0'; }}
                                >
                                    <Spotlight style={{ color: '#16a34a', width: '20px', height: '20px' }} />
                                    Add FollowUp
                                </button>
                            )}

                            {/* Merge Lead */}
                            {canMergeLead && (
                                <button
                                    onClick={() => setIsMergeLeadOpen(true)}
                                    style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px', padding: '14px 20px', background: '#ffffff', border: '1px solid #e2e8f0', borderRadius: '8px', color: '#16a34a', fontSize: '15px', fontWeight: '600', cursor: 'pointer', width: '100%', boxShadow: '0 1px 3px rgba(0,0,0,0.05)', transition: 'all 0.2s ease' }}
                                    onMouseEnter={e => { e.currentTarget.style.background = '#f0fdf4'; e.currentTarget.style.borderColor = '#86efac'; }}
                                    onMouseLeave={e => { e.currentTarget.style.background = '#ffffff'; e.currentTarget.style.borderColor = '#e2e8f0'; }}
                                >
                                    <GoGitBranch style={{ color: '#16a34a', width: '20px', height: '20px' }} />
                                    Merge Lead
                                </button>
                            )}

                            {/* SMS */}
                            {canSendSms && (
                                <button
                                    onClick={() => setIsSMSModalOpen(true)}
                                    style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px', padding: '14px 20px', background: '#ffffff', border: '1px solid #e2e8f0', borderRadius: '8px', color: '#16a34a', fontSize: '15px', fontWeight: '600', cursor: 'pointer', width: '100%', boxShadow: '0 1px 3px rgba(0,0,0,0.05)', transition: 'all 0.2s ease' }}
                                    onMouseEnter={e => { e.currentTarget.style.background = '#f0fdf4'; e.currentTarget.style.borderColor = '#86efac'; }}
                                    onMouseLeave={e => { e.currentTarget.style.background = '#ffffff'; e.currentTarget.style.borderColor = '#e2e8f0'; }}
                                >
                                    <MessageSquare style={{ color: '#16a34a', width: '20px', height: '20px' }} />
                                    SMS
                                </button>
                            )}

                            {/* Mail */}
                            {canSendMail && (
                                <button
                                    onClick={() => setIsMailModalOpen(true)}
                                    style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px', padding: '14px 20px', background: '#ffffff', border: '1px solid #e2e8f0', borderRadius: '8px', color: '#16a34a', fontSize: '15px', fontWeight: '600', cursor: 'pointer', width: '100%', boxShadow: '0 1px 3px rgba(0,0,0,0.05)', transition: 'all 0.2s ease' }}
                                    onMouseEnter={e => { e.currentTarget.style.background = '#f0fdf4'; e.currentTarget.style.borderColor = '#86efac'; }}
                                    onMouseLeave={e => { e.currentTarget.style.background = '#ffffff'; e.currentTarget.style.borderColor = '#e2e8f0'; }}
                                >
                                    <Mail style={{ color: '#16a34a', width: '20px', height: '20px' }} />
                                    Mail
                                </button>
                            )}

                            {/* WhatsApp */}
                            {canSendWhatsapp && (
                                <button
                                    onClick={() => setIsWhatsAppModalOpen(true)}
                                    style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px', padding: '14px 20px', background: '#ffffff', border: '1px solid #e2e8f0', borderRadius: '8px', color: '#16a34a', fontSize: '15px', fontWeight: '600', cursor: 'pointer', width: '100%', boxShadow: '0 1px 3px rgba(0,0,0,0.05)', transition: 'all 0.2s ease' }}
                                    onMouseEnter={e => { e.currentTarget.style.background = '#f0fdf4'; e.currentTarget.style.borderColor = '#86efac'; }}
                                    onMouseLeave={e => { e.currentTarget.style.background = '#ffffff'; e.currentTarget.style.borderColor = '#e2e8f0'; }}
                                >
                                    <FaWhatsapp style={{ color: '#16a34a', width: '20px', height: '20px' }} />
                                    WhatsApp
                                </button>
                            )}

                            {/* Send Voice */}
                            {canSendVoice && (
                                <button
                                    onClick={() => setIsSendVoiceModal(true)}
                                    style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px', padding: '14px 20px', background: '#ffffff', border: '1px solid #e2e8f0', borderRadius: '8px', color: '#16a34a', fontSize: '15px', fontWeight: '600', cursor: 'pointer', width: '100%', boxShadow: '0 1px 3px rgba(0,0,0,0.05)', transition: 'all 0.2s ease' }}
                                    onMouseEnter={e => { e.currentTarget.style.background = '#f0fdf4'; e.currentTarget.style.borderColor = '#86efac'; }}
                                    onMouseLeave={e => { e.currentTarget.style.background = '#ffffff'; e.currentTarget.style.borderColor = '#e2e8f0'; }}
                                >
                                    <Mic style={{ color: '#16a34a', width: '20px', height: '20px' }} />
                                    Send Voice
                                </button>
                            )}

                            {/* Create Meeting — always visible */}
                            <button
                                onClick={() => setIsCreateMeetingModal(true)}
                                style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px', padding: '14px 20px', background: '#ffffff', border: '1px solid #e2e8f0', borderRadius: '8px', color: '#16a34a', fontSize: '15px', fontWeight: '600', cursor: 'pointer', width: '100%', boxShadow: '0 1px 3px rgba(0,0,0,0.05)', transition: 'all 0.2s ease' }}
                                onMouseEnter={e => { e.currentTarget.style.background = '#f0fdf4'; e.currentTarget.style.borderColor = '#86efac'; }}
                                onMouseLeave={e => { e.currentTarget.style.background = '#ffffff'; e.currentTarget.style.borderColor = '#e2e8f0'; }}
                            >
                                <Video style={{ color: '#16a34a', width: '20px', height: '20px' }} />
                                Create Meeting
                            </button>

                            {/* Add Appointment */}
                            {canAddAppointment && (
                                <button
                                    onClick={() => setIsAddAppointmentModal(true)}
                                    style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px', padding: '14px 20px', background: '#ffffff', border: '1px solid #e2e8f0', borderRadius: '8px', color: '#16a34a', fontSize: '15px', fontWeight: '600', cursor: 'pointer', width: '100%', boxShadow: '0 1px 3px rgba(0,0,0,0.05)', transition: 'all 0.2s ease' }}
                                    onMouseEnter={e => { e.currentTarget.style.background = '#f0fdf4'; e.currentTarget.style.borderColor = '#86efac'; }}
                                    onMouseLeave={e => { e.currentTarget.style.background = '#ffffff'; e.currentTarget.style.borderColor = '#e2e8f0'; }}
                                >
                                    <CalendarCheck style={{ color: '#16a34a', width: '20px', height: '20px' }} />
                                    Add Appointment
                                </button>
                            )}

                            {/* Add Physical Appointment */}
                            {canAddAppointment && (
                                <button
                                    onClick={() => setIsAddPhysicalAppointmentModal(true)}
                                    style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px', padding: '14px 20px', background: '#ffffff', border: '1px solid #e2e8f0', borderRadius: '8px', color: '#16a34a', fontSize: '15px', fontWeight: '600', cursor: 'pointer', width: '100%', boxShadow: '0 1px 3px rgba(0,0,0,0.05)', transition: 'all 0.2s ease' }}
                                    onMouseEnter={e => { e.currentTarget.style.background = '#f0fdf4'; e.currentTarget.style.borderColor = '#86efac'; }}
                                    onMouseLeave={e => { e.currentTarget.style.background = '#ffffff'; e.currentTarget.style.borderColor = '#e2e8f0'; }}
                                >
                                    <FaUsersGear style={{ color: '#16a34a', width: '20px', height: '20px' }} />
                                    Add Physical Appointment
                                </button>
                            )}

                            {/* Add Note */}
                            {canAddNote && (
                                <button
                                    onClick={() => setIsAddNotesModal(true)}
                                    style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px', padding: '14px 20px', background: '#ffffff', border: '1px solid #e2e8f0', borderRadius: '8px', color: '#16a34a', fontSize: '15px', fontWeight: '600', cursor: 'pointer', width: '100%', boxShadow: '0 1px 3px rgba(0,0,0,0.05)', transition: 'all 0.2s ease' }}
                                    onMouseEnter={e => { e.currentTarget.style.background = '#f0fdf4'; e.currentTarget.style.borderColor = '#86efac'; }}
                                    onMouseLeave={e => { e.currentTarget.style.background = '#ffffff'; e.currentTarget.style.borderColor = '#e2e8f0'; }}
                                >
                                    <NotebookPen style={{ color: '#16a34a', width: '20px', height: '20px' }} />
                                    Add Note
                                </button>
                            )}

                            {/* Upload Document */}
                            {canUploadDocument && (
                                <button
                                    onClick={() => setIsUploadDataModal(true)}
                                    style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px', padding: '14px 20px', background: '#ffffff', border: '1px solid #e2e8f0', borderRadius: '8px', color: '#16a34a', fontSize: '15px', fontWeight: '600', cursor: 'pointer', width: '100%', boxShadow: '0 1px 3px rgba(0,0,0,0.05)', transition: 'all 0.2s ease' }}
                                    onMouseEnter={e => { e.currentTarget.style.background = '#f0fdf4'; e.currentTarget.style.borderColor = '#86efac'; }}
                                    onMouseLeave={e => { e.currentTarget.style.background = '#ffffff'; e.currentTarget.style.borderColor = '#e2e8f0'; }}
                                >
                                    <CloudUpload style={{ color: '#16a34a', width: '20px', height: '20px' }} />
                                    Upload Document
                                </button>
                            )}

                            {/* Add Task */}
                            {canAddTask && (
                                <button
                                    onClick={() => setIsAddTaskModal(true)}
                                    style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px', padding: '14px 20px', background: '#ffffff', border: '1px solid #e2e8f0', borderRadius: '8px', color: '#16a34a', fontSize: '15px', fontWeight: '600', cursor: 'pointer', width: '100%', boxShadow: '0 1px 3px rgba(0,0,0,0.05)', transition: 'all 0.2s ease' }}
                                    onMouseEnter={e => { e.currentTarget.style.background = '#f0fdf4'; e.currentTarget.style.borderColor = '#86efac'; }}
                                    onMouseLeave={e => { e.currentTarget.style.background = '#ffffff'; e.currentTarget.style.borderColor = '#e2e8f0'; }}
                                >
                                    <BookCheck style={{ color: '#16a34a', width: '20px', height: '20px' }} />
                                    Add Task
                                </button>
                            )}

                            {/* Add Deal */}
                            {canAddDeal && (
                                <button
                                    onClick={() => setIsAddDealModal(true)}
                                    style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px', padding: '14px 20px', background: '#ffffff', border: '1px solid #e2e8f0', borderRadius: '8px', color: '#16a34a', fontSize: '15px', fontWeight: '600', cursor: 'pointer', width: '100%', boxShadow: '0 1px 3px rgba(0,0,0,0.05)', transition: 'all 0.2s ease' }}
                                    onMouseEnter={e => { e.currentTarget.style.background = '#f0fdf4'; e.currentTarget.style.borderColor = '#86efac'; }}
                                    onMouseLeave={e => { e.currentTarget.style.background = '#ffffff'; e.currentTarget.style.borderColor = '#e2e8f0'; }}
                                >
                                    <SiJfrogpipelines style={{ color: '#16a34a', width: '20px', height: '20px' }} />
                                    Add Deal
                                </button>
                            )}

                            {/* Add Tax Setting */}
                            {canAddTax && (
                                <button
                                    onClick={() => setIsAddTaxSettingModal(true)}
                                    style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px', padding: '14px 20px', background: '#ffffff', border: '1px solid #e2e8f0', borderRadius: '8px', color: '#16a34a', fontSize: '15px', fontWeight: '600', cursor: 'pointer', width: '100%', boxShadow: '0 1px 3px rgba(0,0,0,0.05)', transition: 'all 0.2s ease' }}
                                    onMouseEnter={e => { e.currentTarget.style.background = '#f0fdf4'; e.currentTarget.style.borderColor = '#86efac'; }}
                                    onMouseLeave={e => { e.currentTarget.style.background = '#ffffff'; e.currentTarget.style.borderColor = '#e2e8f0'; }}
                                >
                                    <FaRegMoneyBillAlt style={{ color: '#16a34a', width: '20px', height: '20px' }} />
                                    Add Tax Setting
                                </button>
                            )}

                            {/* Add Quotation */}
                            {canAddQuotation && (
                                <button
                                    onClick={() => setIsAddQuotationModal(true)}
                                    style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px', padding: '14px 20px', background: '#ffffff', border: '1px solid #e2e8f0', borderRadius: '8px', color: '#16a34a', fontSize: '15px', fontWeight: '600', cursor: 'pointer', width: '100%', boxShadow: '0 1px 3px rgba(0,0,0,0.05)', transition: 'all 0.2s ease' }}
                                    onMouseEnter={e => { e.currentTarget.style.background = '#f0fdf4'; e.currentTarget.style.borderColor = '#86efac'; }}
                                    onMouseLeave={e => { e.currentTarget.style.background = '#ffffff'; e.currentTarget.style.borderColor = '#e2e8f0'; }}
                                >
                                    <GrDocumentConfig style={{ color: '#16a34a', width: '20px', height: '20px' }} />
                                    Add Quotation
                                </button>
                            )}

                            {/* Add Invoice */}
                            {canAddInvoice && (
                                <button
                                    onClick={() => setIsAddInvoiceModal(true)}
                                    style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px', padding: '14px 20px', background: '#ffffff', border: '1px solid #e2e8f0', borderRadius: '8px', color: '#16a34a', fontSize: '15px', fontWeight: '600', cursor: 'pointer', width: '100%', boxShadow: '0 1px 3px rgba(0,0,0,0.05)', transition: 'all 0.2s ease' }}
                                    onMouseEnter={e => { e.currentTarget.style.background = '#f0fdf4'; e.currentTarget.style.borderColor = '#86efac'; }}
                                    onMouseLeave={e => { e.currentTarget.style.background = '#ffffff'; e.currentTarget.style.borderColor = '#e2e8f0'; }}
                                >
                                    <HiOutlineDocumentText style={{ color: '#16a34a', width: '20px', height: '20px' }} />
                                    Add Invoice
                                </button>
                            )}

                            {/* Edit All Fields */}
                            {canEdit && (
                                <button
                                    onClick={() => setIsEditLeadModal(true)}
                                    style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px', padding: '14px 20px', background: '#ffffff', border: '1px solid #e2e8f0', borderRadius: '8px', color: '#16a34a', fontSize: '15px', fontWeight: '600', cursor: 'pointer', width: '100%', boxShadow: '0 1px 3px rgba(0,0,0,0.05)', transition: 'all 0.2s ease' }}
                                    onMouseEnter={e => { e.currentTarget.style.background = '#f0fdf4'; e.currentTarget.style.borderColor = '#86efac'; }}
                                    onMouseLeave={e => { e.currentTarget.style.background = '#ffffff'; e.currentTarget.style.borderColor = '#e2e8f0'; }}
                                >
                                    <Edit style={{ color: '#16a34a', width: '20px', height: '20px' }} />
                                    Edit All Fields
                                </button>
                            )}

                            {/* Webform */}
                            {canAddWebform && (
                                <button
                                    onClick={() => setIsWebFormModal(true)}
                                    style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px', padding: '14px 20px', background: '#ffffff', border: '1px solid #e2e8f0', borderRadius: '8px', color: '#16a34a', fontSize: '15px', fontWeight: '600', cursor: 'pointer', width: '100%', boxShadow: '0 1px 3px rgba(0,0,0,0.05)', transition: 'all 0.2s ease' }}
                                    onMouseEnter={e => { e.currentTarget.style.background = '#f0fdf4'; e.currentTarget.style.borderColor = '#86efac'; }}
                                    onMouseLeave={e => { e.currentTarget.style.background = '#ffffff'; e.currentTarget.style.borderColor = '#e2e8f0'; }}
                                >
                                    <ListChevronsDownUp style={{ color: '#16a34a', width: '20px', height: '20px' }} />
                                    Webform
                                </button>
                            )}
                        </div>
                    </div>


                    {/* Floating Expand Button when Right Sidebar is Collapsed */}
                    {isRightCollapsed && (
                        <button
                            onClick={() => setIsRightCollapsed(false)}
                            className="fixed  text-gray-600 rounded-full shadow-lg transition z-10"
                            style={{
                                right: '11px',
                                top: '30%',
                                transform: 'translateY(-50%)',
                                padding: '8px'
                            }}
                            title="Expand Quick Actions"
                        >
                            <ChevronLeftCircle className="w-5 h-5" />
                        </button>
                    )}
                </div>
            </div>
            <PopUpModal
                isOpen={isAddLeadModal}
                onClose={() => setIsAddLeadModal(false)}
                title="Add FollowUp"
                size="lg"
                footer={
                    <div className="flex justify-between w-full">
                        <Button
                            variant="secondary"
                            onClick={() => setIsAddLeadModal(false)}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant='primary'
                            onClick={async () => {
                                try {
                                    if (!addFollowupRef.current || !addFollowupRef.current.getFormData) {
                                        console.warn('AddFollowupForm ref not available');
                                        return;
                                    }
                                    const formObj = addFollowupRef.current.getFormData();
                                    // ensure LeadId is set
                                    const leadId = lead?.ID || lead?.LeadId || lead?.Id || lead?.id || 0;
                                    formObj.objLeadFollowup_BO.LeadId = leadId;

                                    const { userId, TokenId, parentId } = getSession();
                                    const details = {
                                        objLeadFollowup_BO: formObj.objLeadFollowup_BO,
                                        strDLTTemplateID: formObj.strDLTTemplateID || '',
                                        strUserID: String(userId || ''),
                                        strTimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone || '',
                                        strParentID: String(parentId || '')
                                    };

                                    const payload = {
                                        Token: TokenId,
                                        Message: "",
                                        LoggedUserId: userId,
                                        MAC_Address: "",
                                        IP_Address: "102.16.32.189",
                                        Details: details,
                                        BroadcastName: ""
                                    };

                                    const resp = await addLeadFollowupDLT(payload);
                                    const ok = resp && (resp.Status === 1 || resp.status === 1 || (typeof resp === 'string' && resp.includes('Msg')));
                                    if (ok) {
                                        Swal.fire({ icon: 'success', title: 'Saved', text: 'Followup saved successfully.' });
                                        setIsAddLeadModal(false);
                                    } else {
                                        console.error('addLeadFollowupDLT failed', resp);
                                        Swal.fire({ icon: 'error', title: 'Error', text: resp?.Message || 'Failed to save followup.' });
                                    }
                                } catch (err) {
                                    console.error('save followup error', err);
                                    Swal.fire({ icon: 'error', title: 'Error', text: 'An error occurred while saving followup.' });
                                }
                            }}
                        >
                            Save
                        </Button>
                    </div>
                }
            >
                <AddFollowupForm ref={addFollowupRef} selectedCount={lead} />
            </PopUpModal>


            <PopUpModal
                isOpen={isCreateMeetingModal}
                onClose={() => setIsCreateMeetingModal(false)}
                title="Create Meeting"
                size="lg"
                footer={null}
            >
                <CreateMeetingForm lead={lead} />
            </PopUpModal>

            <PopUpModal
                isOpen={isAddAppointmentModal}
                onClose={() => setIsAddAppointmentModal(false)}
                title="Add Appointment"
                size="lg"
                footer={
                    <div className="flex justify-between w-full">
                        <Button
                            variant="secondary"
                            onClick={() => setIsAddAppointmentModal(false)}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant='primary'
                            onClick={async () => {
                                try {
                                    if (!addAppointmentRef.current || !addAppointmentRef.current.getFormData) {
                                        console.warn('AddAppointment ref not available');
                                        return;
                                    }
                                    const appt = addAppointmentRef.current.getFormData();
                                    // basic validation
                                    if (!appt.Title || !appt.StartDate) {
                                        Swal.fire({ icon: 'warning', title: 'Missing fields', text: 'Please provide title and start date/time.' });
                                        return;
                                    }

                                    const details = { insertUpdateTask: appt, TimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone || '' };
                                    const payload = {
                                        Token: TokenId,
                                        Message: "",
                                        LoggedUserId: userId,
                                        MAC_Address: "",
                                        IP_Address: "102.16.32.189",
                                        Details: details,
                                        BroadcastName: ""
                                    };

                                    const resp = await insertNewTaskOrAppointmentLatest(payload);
                                    const ok = resp && (resp.Status === 1 || resp.status === 1 || (typeof resp === 'string' && resp.includes('IsInserted')));
                                    if (ok) {
                                        Swal.fire({ icon: 'success', title: 'Saved', text: 'Appointment saved successfully.' });
                                        setIsAddAppointmentModal(false);
                                    } else {
                                        console.error('insertNewTaskOrAppointmentLatest failed', resp);
                                        Swal.fire({ icon: 'error', title: 'Error', text: resp?.Message || 'Failed to save appointment.' });
                                    }
                                } catch (err) {
                                    console.error('save appointment error', err);
                                    Swal.fire({ icon: 'error', title: 'Error', text: 'An error occurred while saving appointment.' });
                                }
                            }}
                        >
                            Save
                        </Button>
                    </div>
                }
            >
                <AddAppointment ref={addAppointmentRef} />
            </PopUpModal>

            <PopUpModal
                isOpen={isAddPhysicalAppointmentModal}
                onClose={() => setIsAddPhysicalAppointmentModal(false)}
                title="Add Physical Appointment"
                size="lg"
                footer={
                    <div className="flex justify-between w-full">
                        <Button
                            variant="secondary"
                            onClick={() => setIsAddPhysicalAppointmentModal(false)}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant='primary'
                            onClick={async () => {
                                try {
                                    if (!addPhysicalAppointmentRef.current || !addPhysicalAppointmentRef.current.submit) {
                                        console.warn('AddPhysicalAppointmentForm ref not available');
                                        return;
                                    }
                                    await addPhysicalAppointmentRef.current.submit();
                                } catch (err) {
                                    console.error('error saving physical appointment from modal', err);
                                }
                            }}
                        >
                            Save
                        </Button>
                    </div>
                }
            >
                <AddPhysicalAppointmentForm ref={addPhysicalAppointmentRef} lead={lead} onClose={() => setIsAddPhysicalAppointmentModal(false)} />
            </PopUpModal>

            <PopUpModal
                isOpen={isSendVoiceModal}
                onClose={() => setIsSendVoiceModal(false)}
                title="Send Voice"
                size="lg"
                footer={
                    <div className="flex justify-between w-full">
                        <Button
                            variant="secondary"
                            onClick={() => setIsSendVoiceModal(false)}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant='primary'
                            onClick={async () => {
                                try {
                                    if (!sendVoiceRef.current || !sendVoiceRef.current.getFormData) {
                                        console.warn('SendVoiceForm ref not available');
                                        return;
                                    }
                                    const form = sendVoiceRef.current.getFormData();
                                    const details = {
                                        SendVoice: {
                                            MobileNo: form.MobileNo || '',
                                            MobileNo1: form.MobileNo1 || '',
                                            MobileNo2: form.MobileNo2 || '',
                                            Route: form.Route || '',
                                            AppFlow: form.AppFlow || '',
                                            DnidNo: form.DnidNo || '',
                                            Duration: form.Duration || '',
                                            Voice_Source: form.Voice_Source || '',
                                            EntityName: form.EntityName || 'lead',
                                            EntityId: form.EntityId || ''
                                        },
                                        ParentId: parentId || 0
                                    };

                                    const payload = {
                                        Token: TokenId,
                                        Message: "",
                                        LoggedUserId: userId,
                                        MAC_Address: "",
                                        IP_Address: "102.16.32.189",
                                        Details: details,
                                        BroadcastName: ""
                                    };

                                    const resp = await sendVoiceEnquiryOrLead(payload);
                                    if (resp && (resp.Status === 1 || resp.status === 1)) {
                                        Swal.fire({ icon: 'success', title: 'Sent', text: 'Voice sent successfully.' });
                                        setIsSendVoiceModal(false);
                                    } else {
                                        console.error('sendVoice failed', resp);
                                        Swal.fire({ icon: 'error', title: 'Error', text: resp?.Message || 'Failed to send voice.' });
                                    }
                                } catch (error) {
                                    console.error('send voice error', error);
                                    Swal.fire({ icon: 'error', title: 'Error', text: 'An error occurred while sending voice.' });
                                }
                            }}
                        >
                            Save
                        </Button>
                    </div>
                }
            >
                <SendVoiceForm ref={sendVoiceRef} lead={lead} />
            </PopUpModal>

            <PopUpModal
                isOpen={isAddNotesModal}
                onClose={() => setIsAddNotesModal(false)}
                title="Add Note"
                size="lg"
                footer={
                    <div className="flex justify-between w-full">
                        <Button
                            variant="secondary"
                            onClick={() => setIsAddNotesModal(false)}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant='primary'
                            onClick={async () => {
                                try {
                                    const payload = {
                                        Token: TokenId,
                                        Message: "",
                                        LoggedUserId: userId,
                                        MAC_Address: "",
                                        IP_Address: "102.16.32.189",
                                        Details: {
                                            LeadID: lead.ID || lead.LeadId || lead.Id || lead.id,
                                            Notes: noteText,
                                            ParentId: parentId,
                                            UserId: userId
                                        },
                                        BroadcastName: ""
                                    };
                                    const resp = await addNotes(payload);
                                    // On success close modal and refresh notes
                                    setIsAddNotesModal(false);
                                    setNoteText('');
                                    // fetch latest notes
                                    try {
                                        const notesPayload = {
                                            Token: TokenId,
                                            Message: "",
                                            LoggedUserId: userId,
                                            MAC_Address: "",
                                            IP_Address: "102.16.32.189",
                                            Details: {
                                                leadid: lead.ID,
                                                parentid: parentId,
                                                userid: userId
                                            },
                                            BroadcastName: ""
                                        };
                                        const notesResp = await getNotesByLeadId(notesPayload);
                                        let data = notesResp?.Details ?? notesResp?.d ?? notesResp ?? [];
                                        if (data && typeof data === 'string') {
                                            try { data = JSON.parse(data); } catch (e) { }
                                        }
                                        if (data && data.data) data = data.data;
                                        setNotes(Array.isArray(data) ? data : []);
                                    } catch (err) {
                                        console.error('refresh notes error:', err);
                                    }
                                } catch (error) {
                                    console.error('add note error:', error);
                                }
                            }}
                        >
                            Save
                        </Button>
                    </div>
                }
            >
                <AddNotes value={noteText} onChange={setNoteText} />
            </PopUpModal>

            <PopUpModal
                isOpen={isUploadDataModal}
                onClose={() => setIsUploadDataModal(false)}
                title="Upload Data"
                size="lg"
                footer={
                    <div className="flex justify-end w-full">
                        <Button
                            variant="secondary"
                            onClick={() => setIsUploadDataModal(false)}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="primary"
                            onClick={handleSaveUpload}
                            disabled={!selectedFile}   // ✅ correct
                        >
                            Save
                        </Button>
                    </div>
                }
            >
                <div className="space-y-4">
                    <div className="flex items-center gap-2">
                        {/* <UploadData onUpload={handleFileUpload} onOpenMediaLibrary={() => setShowUploadDataMediaLibrary(true)} /> */}
                        <UploadData
                            selectedFile={selectedFile}   // 👈 pass here
                            onFileChange={setSelectedFile} // for manual upload
                            onOpenMediaLibrary={() => setShowUploadDataMediaLibrary(true)}
                        />
                    </div>

                    {showUploadDataMediaLibrary && (
                        <MediaLibrary
                            show={showUploadDataMediaLibrary}
                            onclose={() => setShowUploadDataMediaLibrary(false)}
                            onSelectMedia={handleMediaSelect}
                            filterOption="All"
                            cardType="image"
                            leadId={lead?.ID || lead?.LeadId || lead?.Id || lead?.id || 0}
                        />
                    )}

                </div>
            </PopUpModal>

            <PopUpModal
                isOpen={isAddTaskModal}
                onClose={() => setIsAddTaskModal(false)}
                title="Add Task"
                size="lg"
                footer={
                    <div className="flex justify-between w-full">
                        <Button
                            variant="secondary"
                            onClick={() => setIsAddTaskModal(false)}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant='primary'
                            onClick={async () => {
                                try {
                                    if (!addTaskRef.current || !addTaskRef.current.getFormData) {
                                        console.warn('AddTask ref not available');
                                        return;
                                    }
                                    const task = addTaskRef.current.getFormData();
                                    // basic validation
                                    if (!task.Title || !task.StartDate) {
                                        Swal.fire({ icon: 'warning', title: 'Missing fields', text: 'Please provide title and due date/time.' });
                                        return;
                                    }

                                    const details = { insertUpdateTask: task, TimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone || '' };
                                    const payload = {
                                        Token: TokenId,
                                        Message: "",
                                        LoggedUserId: userId,
                                        MAC_Address: "",
                                        IP_Address: "102.16.32.189",
                                        Details: details,
                                        BroadcastName: ""
                                    };

                                    const resp = await insertNewTaskOrAppointmentLatest(payload);
                                    const ok = resp && (resp.Status === 1 || resp.status === 1 || (typeof resp === 'string' && resp.includes('IsInserted')));
                                    if (ok) {
                                        Swal.fire({ icon: 'success', title: 'Saved', text: 'Task saved successfully.' });
                                        setIsAddTaskModal(false);
                                    } else {
                                        console.error('insertNewTaskOrAppointmentLatest failed', resp);
                                        Swal.fire({ icon: 'error', title: 'Error', text: resp?.Message || 'Failed to save task.' });
                                    }
                                } catch (err) {
                                    console.error('save task error', err);
                                    Swal.fire({ icon: 'error', title: 'Error', text: 'An error occurred while saving task.' });
                                }
                            }}
                        >
                            Save
                        </Button>
                    </div>
                }
            >
                <AddTask ref={addTaskRef} />
            </PopUpModal>

            <PopUpModal
                isOpen={isAddDealModal}
                onClose={() => setIsAddDealModal(false)}
                title="Add Deal"
                size="lg"
                footer={
                    <div className="flex justify-between w-full">
                        <Button
                            variant="secondary"
                            onClick={() => setIsAddDealModal(false)}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant='primary'
                            onClick={async () => {
                                try {
                                    if (!addDealRef.current || !addDealRef.current.getFormData) {
                                        console.warn('AddDeal ref not available');
                                        return;
                                    }
                                    const form = addDealRef.current.getFormData();
                                    // Ensure LeadId is set
                                    const leadId = lead?.ID || lead?.LeadId || lead?.Id || lead?.id || 0;
                                    form.LeadId = leadId;

                                    // validation
                                    if (!form.PipelineId || Number(form.PipelineId) === 0) {
                                        Swal.fire({ icon: 'warning', title: 'Missing field', text: 'Please select a pipeline.' });
                                        return;
                                    }
                                    if (!form.PipelineStage || Number(form.PipelineStage) === 0) {
                                        Swal.fire({ icon: 'warning', title: 'Missing field', text: 'Please select a pipeline stage.' });
                                        return;
                                    }
                                    if (!form.Amount || Number(form.Amount) <= 0) {
                                        Swal.fire({ icon: 'warning', title: 'Missing field', text: 'Please enter a valid deal amount.' });
                                        return;
                                    }

                                    const { userId, TokenId } = getSession();
                                    const details = {
                                        LeadId: Number(form.LeadId || 0),
                                        PipelineId: Number(form.PipelineId || 0),
                                        PipelineStage: Number(form.PipelineStage || 0),
                                        Amount: Number(form.Amount || 0),
                                        ClosureDate: form.ClosureDate || '',
                                        DealOwner: Number(form.DealOwner || 0),
                                        Probability: Number(form.Probability || 0),
                                        UserId: Number(userId || 0)
                                    };

                                    const payload = {
                                        Token: TokenId,
                                        Message: '',
                                        LoggedUserId: userId,
                                        MAC_Address: '',
                                        IP_Address: "102.16.32.189",
                                        Details: details,
                                        BroadcastName: ''
                                    };

                                    const resp = await saveDealData(payload);
                                    const ok = resp && (resp.Status === 1 || resp.status === 1 || (resp.Details && typeof resp.Details === 'string' && resp.Details.toLowerCase().includes('deal saved')) || (typeof resp === 'string' && resp.toLowerCase().includes('deal saved')));
                                    if (ok) {
                                        Swal.fire({ icon: 'success', title: 'Saved', text: 'Deal saved successfully.' });
                                        setIsAddDealModal(false);
                                    } else {
                                        console.error('saveDealData failed', resp);
                                        Swal.fire({ icon: 'error', title: 'Error', text: resp?.Message || resp?.Details || 'Failed to save deal.' });
                                    }
                                } catch (err) {
                                    console.error('save deal error', err);
                                    Swal.fire({ icon: 'error', title: 'Error', text: 'An error occurred while saving deal.' });
                                }
                            }}
                        >
                            Save
                        </Button>
                    </div>
                }
            >
                <AddDeal ref={addDealRef} initial={{ leadId: lead?.ID || lead?.LeadId || lead?.Id }} />
            </PopUpModal>

            <PopUpModal
                isOpen={isWebFormModal}
                onClose={() => setIsWebFormModal(false)}
                title="Add WebForm"
                size="sm"
                footer={
                    <div className="flex justify-between w-full">
                        <Button
                            variant="secondary"
                            onClick={() => setIsWebFormModal(false)}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant='primary'
                            onClick={async () => {
                                try {
                                    const leadId = lead?.ID || lead?.LeadId || lead?.Id || lead?.id || 0;
                                    const formName = (selectedWebform && typeof selectedWebform === 'object') ? (selectedWebform.label || selectedWebform.value) : selectedWebform;
                                    if (!formName) {
                                        Swal.fire({ icon: 'warning', title: 'Missing field', text: 'Please select a webform.' });
                                        return;
                                    }

                                    const payload = {
                                        Token: TokenId,
                                        Message: '',
                                        LoggedUserId: userId,
                                        MAC_Address: '',
                                        IP_Address: "102.16.32.189",
                                        Details: { LeadId: Number(leadId || 0), formName: String(formName || ''), LoginId: userId, ParentId: parentId },
                                        BroadcastName: ''
                                    };

                                    const resp = await generateWebFormUrl(payload);
                                    // resp expected to be ResponseStatusEntity with Details containing the URL string
                                    let url = resp?.Details ?? resp?.details ?? (resp?.data && resp.data.Details) ?? resp?.data ?? null;
                                    if (typeof url === 'object' && url !== null) {
                                        // sometimes Details may be nested
                                        url = url?.Details ?? url?.url ?? null;
                                    }

                                    if (url && typeof url === 'string') {
                                        window.open(url, '_blank');
                                        setIsWebFormModal(false);
                                    } else {
                                        console.error('generateWebFormUrl failed', resp);
                                        Swal.fire({ icon: 'error', title: 'Error', text: resp?.Message || 'Failed to generate webform URL.' });
                                    }
                                } catch (err) {
                                    console.error('generate webform url error', err);
                                    Swal.fire({ icon: 'error', title: 'Error', text: 'An error occurred while generating webform URL.' });
                                }
                            }}
                        >
                            Add
                        </Button>
                    </div>
                }
            >
                {typeof WebForm === 'function' ? (
                    <WebForm onSelectChange={setSelectedWebform} />
                ) : (
                    <div className="p-4 text-sm text-red-600">WebForm component failed to load.</div>
                )}
            </PopUpModal>

            <WebhookParamsModal
                isOpen={webhookModalState.open}
                onClose={() => setWebhookModalState({ open: false, webhookId: '', requiredParams: {}, leadIds: [], batchId: '', title: 'Webhook Parameters' })}
                title={webhookModalState.title}
                requiredParams={webhookModalState.requiredParams}
                placeholders={leadPlaceholders}
                onSubmit={({ params, headerKey, headerValue, senderId }) => submitWebhookAction({
                    webhookId: webhookModalState.webhookId,
                    params,
                    leadIds: webhookModalState.leadIds,
                    batchId: webhookModalState.batchId,
                    headerKey,
                    headerValue,
                    senderId
                })}
            />

            <PopUpModal
                isOpen={isEditLeadModal}
                onClose={() => setIsEditLeadModal(false)}
                title="Edit Lead"
                size="lg"
                footer={
                    <div className="flex justify-between w-full">
                        <Button
                            variant="secondary"
                            onClick={() => setIsEditLeadModal(false)}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant='primary'
                            onClick={() => {
                                try {
                                    if (editLeadRef.current && editLeadRef.current.submit) {
                                        editLeadRef.current.submit();
                                    } else {
                                        console.warn('EditLeadForm ref not available');
                                    }
                                } catch (err) {
                                    console.error('trigger edit form submit error', err);
                                }
                            }}
                        >
                            Save
                        </Button>
                    </div>
                }
            >
                {EditLeadForm ? (
                    <EditLeadForm
                        ref={editLeadRef}
                        lead={lead}
                        onClose={() => setIsEditLeadModal(false)}
                        onSubmit={async (updatedLead) => {
                            try {
                                const leadId = Number(updatedLead?.LeadId ?? updatedLead?.ID ?? updatedLead?.Id ?? lead?.ID ?? 0) || 0;
                                const isEditMode = leadId > 0;
                                // Build RequestParamEntity envelope expected by the backend
                                const payload = {
                                    Token: TokenId,
                                    Message: "",
                                    LoggedUserId: userId,
                                    MAC_Address: "",
                                    IP_Address: "102.16.32.189",
                                    Details: updatedLead,
                                    BroadcastName: ""
                                };

                                const resp = await (isEditMode ? editLead(payload) : saveNewLead(payload));
                                const ok = resp && (resp.Status === 1 || resp.status === 1 || (resp.Details && typeof resp.Details === 'string' && resp.Details.toLowerCase().includes('success')));
                                if (ok) {
                                    Swal.fire({ icon: 'success', title: 'Saved', text: resp?.Message || (isEditMode ? 'Lead updated successfully.' : 'Lead saved successfully.') });
                                    setIsEditLeadModal(false);
                                    // Optionally refresh lead data here if you have a loader/fetch function
                                } else {
                                    console.error(isEditMode ? 'editLead failed' : 'saveNewLead failed', resp);
                                    Swal.fire({ icon: 'error', title: 'Error', text: resp?.Message || resp?.Details || 'Failed to save lead.' });
                                }
                            } catch (err) {
                                console.error('lead save error', err);
                                Swal.fire({ icon: 'error', title: 'Error', text: 'An error occurred while saving lead.' });
                            }
                        }}
                    />
                ) : (
                    <div className="p-4 text-sm text-red-600">Edit form component failed to load.</div>
                )}
            </PopUpModal>

            <PopUpModal
                isOpen={isWhatsAppModalOpen}
                onClose={() => setIsWhatsAppModalOpen(false)}
                title="WhatsApp Message"
                size="lg"
                footer={
                    <div className="flex justify-between w-full">
                        <Button
                            variant="secondary"
                            onClick={() => setIsWhatsAppModalOpen(false)}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant='primary'
                            onClick={async () => {
                                try {
                                    if (!whatsAppFormRef.current || !whatsAppFormRef.current.getFormData) {
                                        console.warn('WhatsAppForm ref not available');
                                        return;
                                    }

                                    const form = whatsAppFormRef.current.getFormData();
                                    const selectedNumbers = Array.isArray(form?.selectedNumbers) ? form.selectedNumbers.filter(Boolean) : [];
                                    if (!selectedNumbers.length) {
                                        Swal.fire({ icon: 'warning', title: 'Missing fields', text: 'Please select at least one mobile number.' });
                                        return;
                                    }
                                    if (!form?.TemplateId) {
                                        Swal.fire({ icon: 'warning', title: 'Missing fields', text: 'Please select a WhatsApp template.' });
                                        return;
                                    }
                                    if (!form?.TemplateName) {
                                        Swal.fire({ icon: 'warning', title: 'Missing fields', text: 'Template name is missing.' });
                                        return;
                                    }

                                    const components = Array.isArray(form?.TemplateComponents) ? form.TemplateComponents : [];
                                    const hasEmptyParam = components.some((component) =>
                                        Array.isArray(component?.parameters) && component.parameters.some((param) => !String(param?.text || '').trim())
                                    );
                                    if (hasEmptyParam) {
                                        Swal.fire({ icon: 'warning', title: 'Missing fields', text: 'Please fill all required placeholder values.' });
                                        return;
                                    }

                                    const leadId = Number(form?.LeadId || lead?.ID || lead?.LeadId || lead?.Id || lead?.id || 0);
                                    if (!leadId) {
                                        Swal.fire({ icon: 'warning', title: 'Missing fields', text: 'Lead ID is required to send WhatsApp template.' });
                                        return;
                                    }

                                    const destination = selectedNumbers.join(',');
                                    const normalizedProfileId = String(channelProfileId || '6');

                                    // fetch active API key to include in payload
                                    let apiKeyVal = '';
                                    try {
                                        const apiKeyResp = await getActiveApiKey({
                                            Token: TokenId,
                                            Message: '',
                                            LoggedUserId: userId,
                                            MAC_Address: '',
                                            IP_Address: "102.16.32.189",
                                            Details: { UserId: userId },
                                            BroadcastName: ''
                                        });
                                        apiKeyVal = apiKeyResp?.ApiKey ?? apiKeyResp?.apiKey ?? apiKeyResp?.Key ?? apiKeyResp?.key ?? '';
                                    } catch (err) {
                                        console.warn('Failed to fetch active API key:', err);
                                    }

                                    const initialPayload = {
                                        channelProfileId: normalizedProfileId,
                                        name: 'whatsapp',
                                        businessNumber: '919211311101',
                                        message_type: 'individual',
                                        to: destination,
                                        type: 'template',
                                        source: 'crm',
                                        source_ref: 'Lead',
                                        message_send_at: new Date().toISOString(),
                                        isTemplate: true,
                                        templateId: String(form.TemplateId),
                                        templateName: String(form.TemplateName),
                                        language: String(form.TemplateLanguage || 'en'),
                                        namespace: String(form.TemplateNamespace || ''),
                                        category: String(form.TemplateCategory || 'utility'),
                                        whatsapp: {
                                            messaging_product: 'whatsapp',
                                            recipient_type: 'individual',
                                            to: selectedNumbers[0],
                                            type: 'template',
                                            template: {
                                                name: String(form.TemplateName),
                                                language: { code: String(form.TemplateLanguage || 'en') },
                                                components
                                            }
                                        },
                                        add_to_enquiry: 'no',
                                        username: String(LoginName || DisplayName || ''),
                                        key: apiKeyVal
                                    };

                                    const replacedJson = await replaceJsonStr({
                                        jsonStr: JSON.stringify(initialPayload),
                                        entity: 'Lead',
                                        entityId: String(leadId)
                                    });

                                    let finalPayload = initialPayload;
                                    try {
                                        const parsed = JSON.parse(replacedJson);
                                        finalPayload = (parsed && typeof parsed === 'object') ? parsed : initialPayload;
                                    } catch (err) {
                                        console.warn('replaceJsonStr parse failed, using initial payload', err?.message || err);
                                    }

                                    finalPayload.channelProfileId = normalizedProfileId;
                                    finalPayload.businessNumber = finalPayload.businessNumber || '919211311101';
                                    finalPayload.whatsapp = finalPayload.whatsapp || initialPayload.whatsapp;
                                    finalPayload.whatsapp.to = finalPayload.whatsapp.to || selectedNumbers[0];
                                    finalPayload.whatsapp.template = finalPayload.whatsapp.template || initialPayload.whatsapp.template;

                                    const resp = await sendWhatsAppTemplate(finalPayload);
                                    const ok = resp && (
                                        resp.Status === 1 ||
                                        resp.status === 1 ||
                                        resp?.meta?.http_code === 200 ||
                                        (typeof resp?.Message === 'string' && /success|sent/i.test(resp.Message)) ||
                                        (typeof resp?.Details === 'string' && /success|sent/i.test(resp.Details))
                                    );

                                    if (ok) {
                                        Swal.fire({ icon: 'success', title: 'Sent', text: 'WhatsApp message sent successfully.' });
                                        setIsWhatsAppModalOpen(false);
                                    } else {
                                        console.error('sendWhatsAppTemplate failed', resp);
                                        Swal.fire({ icon: 'error', title: 'Error', text: resp?.Message || 'Failed to send WhatsApp message.' });
                                    }
                                } catch (error) {
                                    console.error('send whatsapp error', error);
                                    Swal.fire({ icon: 'error', title: 'Error', text: 'An error occurred while sending WhatsApp message.' });
                                }
                            }}
                        >
                            Add
                        </Button>
                    </div>
                }
            >
                <WhatsAppForm ref={whatsAppFormRef} lead={lead} />
            </PopUpModal>

            <PopUpModal
                isOpen={isMailModalOpen}
                onClose={() => setIsMailModalOpen(false)}
                title="Mail Message"
                size="lg"
                footer={
                    <div className="flex justify-between w-full">
                        <Button
                            variant="secondary"
                            onClick={() => setIsMailModalOpen(false)}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant='primary'
                            onClick={async () => {
                                try {
                                    if (!mailFormRef.current || !mailFormRef.current.getFormData) {
                                        console.warn('MailForm ref not available');
                                        return;
                                    }
                                    const form = mailFormRef.current.getFormData();
                                    const details = { objSendEmail: form, userId: userId };
                                    const payload = {
                                        Token: TokenId,
                                        Message: "",
                                        LoggedUserId: userId,
                                        MAC_Address: "",
                                        IP_Address: "102.16.32.189",
                                        Details: details,
                                        BroadcastName: ""
                                    };
                                    const resp = await sendEmail(payload);
                                    if (resp && (resp.Status === 1 || resp.status === 1)) {
                                        Swal.fire({ icon: 'success', title: 'Sent', text: 'Email sent successfully.' });
                                        setIsMailModalOpen(false);
                                    } else {
                                        console.error('sendEmail failed', resp);
                                        Swal.fire({ icon: 'error', title: 'Error', text: resp?.Message || 'Failed to send email.' });
                                    }
                                } catch (error) {
                                    console.error('send email error', error);
                                    Swal.fire({ icon: 'error', title: 'Error', text: 'An error occurred while sending email.' });
                                }
                            }}
                        >
                            Save
                        </Button>
                    </div>
                }
            >
                <Suspense fallback={<div className="p-4">Loading...</div>}>
                    <MailForm ref={mailFormRef} lead={lead} />
                </Suspense>
            </PopUpModal>

            <PopUpModal
                isOpen={isSMSModalOpen}
                onClose={() => setIsSMSModalOpen(false)}
                title="SMS Message"
                size="lg"
                footer={
                    <div className="flex justify-between w-full">
                        <Button
                            variant="secondary"
                            onClick={() => setIsSMSModalOpen(false)}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant='primary'
                            onClick={async () => {
                                try {
                                    if (!smsFormRef.current || !smsFormRef.current.getFormData) {
                                        console.warn('SMSForm ref not available');
                                        return;
                                    }
                                    const form = smsFormRef.current.getFormData();

                                    // Basic validation
                                    if (!form.Dest || !form.Dest.toString().trim()) {
                                        Swal.fire({ icon: 'warning', title: 'Missing fields', text: 'Please select at least one mobile number.' });
                                        return;
                                    }

                                    if (form.IsNonIndian) {
                                        // validate required fields for international send
                                        if (!form.SenderID || !form.SenderID.toString().trim() || !form.Message || !form.Message.toString().trim()) {
                                            Swal.fire({ icon: 'warning', title: 'Missing fields', text: 'Please provide destination numbers, sender id and message.' });
                                            return;
                                        }

                                        if (form.UrlTrack && (!form.TrackingUrl || !form.TrackingUrl.toString().trim())) {
                                            Swal.fire({ icon: 'warning', title: 'Missing fields', text: 'Please enter tracking URL or disable UrlTrack.' });
                                            return;
                                        }

                                        const details = {
                                            UserId: userId,
                                            dest: form.Dest,
                                            SenderId: form.SenderID,
                                            textMsg: form.Message,
                                            MassOpBatchId: 0,
                                            EntityId: form.EnquiryLeadId || 0,
                                            EntityType: form.EntityType || 'lead',
                                            urltrack: !!form.UrlTrack,
                                            urlText: form.TrackingUrl || '',
                                            placeholder: ''
                                        };

                                        const payload = {
                                            Token: TokenId,
                                            Message: "",
                                            LoggedUserId: userId,
                                            MAC_Address: "",
                                            IP_Address: "102.16.32.189",
                                            Details: details,
                                            BroadcastName: ""
                                        };

                                        const resp = await saveInternationalSms(payload);
                                        if (resp && (resp.Status === 1 || resp.status === 1)) {
                                            Swal.fire({ icon: 'success', title: 'Sent', text: 'International SMS saved/sent successfully.' });
                                            setIsSMSModalOpen(false);
                                        } else {
                                            console.error('saveInternationalSms failed', resp);
                                            Swal.fire({ icon: 'error', title: 'Error', text: resp?.Message || 'Failed to send international SMS.' });
                                        }
                                    } else {
                                        // Indian SMS validation
                                        if (!form.Account || form.Account === '--Select Accounts--' || !form.SenderName || form.SenderName === '--Select App--') {
                                            Swal.fire({ icon: 'warning', title: 'Missing fields', text: 'Please select Sender and App.' });
                                            return;
                                        }

                                        if ((!form.Message || !form.Message.toString().trim()) && (!form.Template || !form.Template.toString().trim())) {
                                            Swal.fire({ icon: 'warning', title: 'Missing fields', text: 'Please select a template or compose a message.' });
                                            return;
                                        }

                                        if (form.UrlTrack && (!form.TrackingUrl || !form.TrackingUrl.toString().trim())) {
                                            Swal.fire({ icon: 'warning', title: 'Missing fields', text: 'Please enter tracking URL or disable UrlTrack.' });
                                            return;
                                        }

                                        const details = { objSendSms: form, ParentId: parentId || 0, UserId: userId };

                                        const payload = {
                                            Token: TokenId,
                                            Message: "",
                                            LoggedUserId: userId,
                                            MAC_Address: "",
                                            IP_Address: "102.16.32.189",
                                            Details: details,
                                            BroadcastName: ""
                                        };

                                        const resp = await sendSms(payload);
                                        if (resp && (resp.Status === 1 || resp.status === 1)) {
                                            Swal.fire({ icon: 'success', title: 'Sent', text: 'SMS sent successfully.' });
                                            setIsSMSModalOpen(false);
                                        } else {
                                            console.error('sendSms failed', resp);
                                            Swal.fire({ icon: 'error', title: 'Error', text: resp?.Message || 'Failed to send SMS.' });
                                        }
                                    }
                                } catch (error) {
                                    console.error('send sms error', error);
                                    Swal.fire({ icon: 'error', title: 'Error', text: 'An error occurred while sending SMS.' });
                                }
                            }}
                        >
                            Save
                        </Button>
                    </div>
                }
            >

                <SMSForm ref={smsFormRef} lead={lead} />
            </PopUpModal>

            <MergeLead
                isOpen={isMergeLeadOpen}
                onClose={() => setIsMergeLeadOpen(false)}
                page={'lead'}
                enquiryData={lead}
            />

            {/* Call Widget Sticky Popup */ }
    {
        showCallWidget && (
            <div className={`fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 ${isCallWidgetCollapsed ? 'w-[240px]' : 'w-[380px]'} bg-white rounded shadow-[0_4px_12px_rgba(0,0,0,0.15)] border border-[#ddd] z-[9999] transition-all duration-300 overflow-hidden`}>
                {/* Header */}
                <div className="bg-[#0ea5e9] text-white px-3 py-2 flex items-center justify-between">
                    <h3 className="text-[14px] font-bold m-0">Call Widget (Kit19 80)</h3>
                    <div className="flex items-center gap-[6px]">
                        <button
                            onClick={() => setIsCallWidgetCollapsed(!isCallWidgetCollapsed)}
                            className="bg-white border border-[#ddd] text-[#555] rounded-[3px] w-[26px] h-[26px] flex items-center justify-center hover:bg-[#f1f5f9] hover:border-[#cbd5e1] transition-all"
                            title={isCallWidgetCollapsed ? "Expand" : "Collapse"}
                        >
                            {isCallWidgetCollapsed ? <Maximize2 size={14} /> : <Minus size={14} />}
                        </button>
                        <button
                            onClick={() => setShowCallWidget(false)}
                            className="bg-white border border-[#ddd] text-[#555] rounded-[3px] w-[26px] h-[26px] flex items-center justify-center hover:bg-[#f1f5f9] hover:border-[#cbd5e1] transition-all"
                            title="Close"
                        >
                            <X size={14} />
                        </button>
                    </div>
                </div>

                {/* Body */}
                {!isCallWidgetCollapsed && (
                    <div className="p-3 text-center">
                        {/* Three dots menu */}
                        <div className="flex justify-start text-[#333] mb-3 font-bold cursor-pointer" onClick={() => setShowCallWidgetMoreMenu(!showCallWidgetMoreMenu)}>
                            <MoreHorizontal size={20} color={showCallWidgetMoreMenu ? '#0ea5e9' : '#333'} />
                        </div>

                        {showCallWidgetMoreMenu ? (
                            <div className="grid grid-cols-4 gap-4 py-2 mb-5 justify-items-center animate-in fade-in slide-in-from-top-4 duration-300">
                                <button onClick={() => { setIsSMSModalOpen(true); setShowCallWidgetMoreMenu(false); }} className="flex flex-col items-center gap-2 group">
                                    <div className="w-[54px] h-[54px] rounded-full border border-[#e2e8f0] flex items-center justify-center group-hover:border-[#0ea5e9] group-hover:bg-[#f0f9ff] transition-all">
                                        <MessageSquare className="w-6 h-6 text-[#475569] group-hover:text-[#0ea5e9]" />
                                    </div>
                                </button>
                                <button onClick={() => { setIsMailModalOpen(true); setShowCallWidgetMoreMenu(false); }} className="flex flex-col items-center gap-2 group">
                                    <div className="w-[54px] h-[54px] rounded-full border border-[#e2e8f0] flex items-center justify-center group-hover:border-[#0ea5e9] group-hover:bg-[#f0f9ff] transition-all">
                                        <Mail className="w-6 h-6 text-[#475569] group-hover:text-[#0ea5e9]" />
                                    </div>
                                </button>
                                <button onClick={() => { setIsWhatsAppModalOpen(true); setShowCallWidgetMoreMenu(false); }} className="flex flex-col items-center gap-2 group">
                                    <div className="w-[54px] h-[54px] rounded-full border border-[#e2e8f0] flex items-center justify-center group-hover:border-[#0ea5e9] group-hover:bg-[#f0f9ff] transition-all">
                                        <FaWhatsapp className="w-6 h-6 text-[#25D366]" />
                                    </div>
                                </button>
                                <button onClick={() => { setIsSendVoiceModal(true); setShowCallWidgetMoreMenu(false); }} className="flex flex-col items-center gap-2 group">
                                    <div className="w-[54px] h-[54px] rounded-full border border-[#e2e8f0] flex items-center justify-center group-hover:border-[#0ea5e9] group-hover:bg-[#f0f9ff] transition-all">
                                        <Mic className="w-6 h-6 text-[#475569] group-hover:text-[#0ea5e9]" />
                                    </div>
                                </button>
                                <button onClick={() => { setIsAddNotesModal(true); setShowCallWidgetMoreMenu(false); }} className="flex flex-col items-center gap-2 group">
                                    <div className="w-[54px] h-[54px] rounded-full border border-[#e2e8f0] flex items-center justify-center group-hover:border-[#0ea5e9] group-hover:bg-[#f0f9ff] transition-all">
                                        <FilePlus className="w-6 h-6 text-[#475569] group-hover:text-[#0ea5e9]" />
                                    </div>
                                </button>
                                <button onClick={() => { setIsUploadDataModal(true); setShowCallWidgetMoreMenu(false); }} className="flex flex-col items-center gap-2 group">
                                    <div className="w-[54px] h-[54px] rounded-full border border-[#e2e8f0] flex items-center justify-center group-hover:border-[#0ea5e9] group-hover:bg-[#f0f9ff] transition-all">
                                        <CloudUpload className="w-6 h-6 text-[#475569] group-hover:text-[#0ea5e9]" />
                                    </div>
                                </button>
                                <button onClick={() => { setIsAddNotesModal(true); setShowCallWidgetMoreMenu(false); }} className="flex flex-col items-center gap-2 group">
                                    <div className="w-[54px] h-[54px] rounded-full border border-[#e2e8f0] flex items-center justify-center group-hover:border-[#0ea5e9] group-hover:bg-[#f0f9ff] transition-all">
                                        <NotebookPen className="w-6 h-6 text-[#475569] group-hover:text-[#0ea5e9]" />
                                    </div>
                                </button>
                                <button onClick={() => { setIsAddAppointmentModal(true); setShowCallWidgetMoreMenu(false); }} className="flex flex-col items-center gap-2 group">
                                    <div className="w-[54px] h-[54px] rounded-full border border-[#e2e8f0] flex items-center justify-center group-hover:border-[#0ea5e9] group-hover:bg-[#f0f9ff] transition-all">
                                        <CalendarDays className="w-6 h-6 text-[#475569] group-hover:text-[#0ea5e9]" />
                                    </div>
                                </button>
                                <button onClick={() => { setIsAddDealModal(true); setShowCallWidgetMoreMenu(false); }} className="flex flex-col items-center gap-2 group">
                                    <div className="w-[54px] h-[54px] rounded-full border border-[#e2e8f0] flex items-center justify-center group-hover:border-[#0ea5e9] group-hover:bg-[#f0f9ff] transition-all">
                                        <FaRegMoneyBillAlt className="w-6 h-6 text-[#475569] group-hover:text-[#0ea5e9]" />
                                    </div>
                                </button>
                                <button onClick={() => { setIsWebFormModal(true); setShowCallWidgetMoreMenu(false); }} className="flex flex-col items-center gap-2 group">
                                    <div className="w-[54px] h-[54px] rounded-full border border-[#e2e8f0] flex items-center justify-center group-hover:border-[#0ea5e9] group-hover:bg-[#f0f9ff] transition-all">
                                        <Globe className="w-6 h-6 text-[#475569] group-hover:text-[#0ea5e9]" />
                                    </div>
                                </button>
                            </div>
                        ) : (
                            <>
                                {/* Profile Images and Info */}
                                <div className="flex justify-between items-center mb-5 gap-2 relative w-full overflow-visible">
                                    {/* Caller */}
                                    <div className="bg-[#f0fdf4] rounded-[12px] py-4 px-2 flex-1 min-w-0 flex flex-col items-center border border-[#dcfce7] overflow-hidden">
                                        <div className="w-[64px] h-[64px] bg-[#f1f5f9] rounded-full border border-[#e2e8f0] mb-[10px] overflow-hidden shadow-[0_4px_6px_-1px_rgba(0,0,0,0.05)] flex items-center justify-center">
                                            <User className="w-8 h-8 text-[#94a3b8]" />
                                        </div>
                                        <div className="font-bold text-[13px] text-[#1e293b] mb-1 whitespace-nowrap overflow-hidden text-ellipsis w-full text-center">{callerName || 'Agent'}</div>
                                        <div className="text-[11px] text-[#64748b] font-medium whitespace-nowrap overflow-hidden text-ellipsis w-full text-center">{callerPhone || 'Agent Phone'}</div>
                                    </div>

                                    {/* Connection Icon */}
                                    <div className={`${isCallDisconnected ? 'text-red-500 bg-[#fef2f2] shadow-[0_0_15px_rgba(239,68,68,0.2)] rounded-full p-1' : 'text-[#0ea5e9]'}`}>
                                        <Wifi size={24} />
                                    </div>

                                    {/* Callee */}
                                    <div className="bg-[#f0fdf4] rounded-[12px] py-4 px-2 flex-1 min-w-0 flex flex-col items-center border border-[#dcfce7] overflow-hidden">
                                        <div 
                                            className="w-[64px] h-[64px] bg-white rounded-full border-2 mb-[10px] overflow-hidden shadow-[0_4px_6px_-1px_rgba(0,0,0,0.05)] flex items-center justify-center text-[20px] font-semibold text-[#1e293b]"
                                            style={{
                                                backgroundColor: getAvatarColorScheme(calleeName || lead?.PersonName || 'Callee').bg,
                                                color: getAvatarColorScheme(calleeName || lead?.PersonName || 'Callee').text,
                                                borderColor: getAvatarColorScheme(calleeName || lead?.PersonName || 'Callee').border || '#e2e8f0'
                                            }}
                                        >
                                            {calleeImage && calleeImage !== 'https://docs.kit19.com/default/person.png' ? (
                                                <img
                                                    src={calleeImage}
                                                    alt={calleeName || lead?.PersonName || 'Callee'}
                                                    className="w-full h-full object-cover"
                                                    onError={(e) => {
                                                        e.target.style.display = 'none';
                                                        e.target.parentElement.innerText = getInitials(calleeName || lead?.PersonName || 'Callee');
                                                    }}
                                                />
                                            ) : (
                                                getInitials(calleeName || lead?.PersonName || 'Callee')
                                            )}
                                        </div>
                                        <div className="font-bold text-[13px] text-[#1e293b] mb-1 whitespace-nowrap overflow-hidden text-ellipsis w-full text-center">{calleeName || lead?.PersonName || 'Lead'}</div>
                                        <div className="text-[11px] text-[#64748b] font-medium whitespace-nowrap overflow-hidden text-ellipsis w-full text-center">{calleePhone}</div>
                                    </div>
                                </div>

                                {/* Status and Timer */}
                                <div className="mb-6">
                                    <h4 className="font-bold text-[20px] text-[#333] m-0">{callStatus}</h4>
                                    <p className="font-bold text-[18px] text-[#666] mt-1">{callTimer}</p>
                                </div>
                            </>
                        )}

                        {/* Call Disconnected / Footer */}
                        <div className={`bg-[#4b4b4b] text-white p-3.5 text-[15px] flex justify-center items-center gap-2 rounded-b-[4px] mx-[-12px] mb-[-12px] font-semibold ${isCallDisconnected ? 'cursor-default' : 'cursor-pointer'}`}>
                            {isCallDisconnected ? (
                                reportCountdown !== null ? (
                                    <>Please wait window close in <span className="text-[#38bdf8] ml-1">{reportCountdown}</span> Sec</>
                                ) : (
                                    <>Closing...</>
                                )
                            ) : (
                                <>
                                    Call Disconnected ? 
                                    <span 
                                        className="text-[#38bdf8] hover:underline"
                                        onClick={() => {
                                            setIsCallDisconnected(true);
                                            setCallStatus('Disconnected');
                                            setReportCountdown(5);
                                        }}
                                    >
                                        Click to report
                                    </span>
                                </>
                            )}
                        </div>
                    </div>
                )}
            </div>
        )
    }

    {/* Hidden fields for legacy click-to-call parity */ }
            <input type="hidden" id="hdnDnidNo" name="hdnDnidNo" />
            <input type="hidden" id="hdnIsCTCAllowed" name="hdnIsCTCAllowed" />
            <PopUpModal
                isOpen={isAddInvoiceModal}
                onClose={() => setIsAddInvoiceModal(false)}
                title="Create New Invoice"
                size="xl"
                footer={
                    <div className="flex justify-between w-full">
                        <Button
                            variant="secondary"
                            onClick={() => setIsAddInvoiceModal(false)}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant='primary'
                            onClick={async () => {
                                try {
                                    if (!addInvoiceRef.current) return;

                                    const validation = addInvoiceRef.current.isValid();
                                    if (!validation.valid) {
                                        Swal.fire({ icon: 'warning', title: 'Validation Error', text: validation.message });
                                        return;
                                    }

                                    const __invoice = addInvoiceRef.current.getFormData();
                                    const { userId, TokenId, parentId } = getSession();

                                    const payload = {
                                        InvoiceData: JSON.stringify(__invoice),
                                        UserId: userId
                                    };

                                    const resp = await insertNewInvoice(payload);
                                    if (resp === true || resp === 'true' || resp === '1' || resp === 1 || resp?.Status === 1 || resp?.status === 1 || (typeof resp === 'string' && resp.toLowerCase().includes('success'))) {
                                        Swal.fire({ icon: 'success', title: 'Success', text: 'Invoice created successfully.' });
                                        setIsAddInvoiceModal(false);
                                    } else {
                                        Swal.fire({ icon: 'error', title: 'Error', text: resp?.Message || (typeof resp === 'string' ? resp : 'Failed to create invoice.') });
                                    }
                                } catch (error) {
                                    console.error('save invoice error', error);
                                    Swal.fire({ icon: 'error', title: 'Error', text: 'An unexpected error occurred.' });
                                }
                            }}
                        >
                            Generate Invoice
                        </Button>
                    </div>
                }
            >
                <AddInvoiceForm ref={addInvoiceRef} lead={lead} />
            </PopUpModal>

            <PopUpModal
                isOpen={isAddQuotationModal}
                onClose={() => setIsAddQuotationModal(false)}
                title="Create New Quotation"
                size="xl"
                footer={
                    <div className="flex justify-between w-full">
                        <Button
                            variant="secondary"
                            onClick={() => setIsAddQuotationModal(false)}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant='primary'
                            onClick={async () => {
                                try {
                                    if (!addQuotationRef.current) return;

                                    const validation = addQuotationRef.current.isValid();
                                    if (!validation.valid) {
                                        Swal.fire({ icon: 'warning', title: 'Validation Error', text: validation.message });
                                        return;
                                    }

                                    const quoteData = addQuotationRef.current.getQuotationData();
                                    const { userId } = getSession();

                                    // Check for duplicate quotation number
                                    const duplicateResp = await isQuotationNumberAlreadyExists({
                                        QuotationNumber: quoteData.QuotationNumber,
                                        UserId: userId
                                    });

                                    if (duplicateResp && duplicateResp !== "") {
                                        Swal.fire({ icon: 'warning', title: 'Validation Failed', text: duplicateResp });
                                        return;
                                    }

                                    const params = {
                                        QuotationData: JSON.stringify(quoteData),
                                        UserId: userId
                                    };

                                    const resp = await insertNewQuote(params);
                                    if (resp === true || resp === 'true' || resp === '1' || resp === 1 || resp?.Status === 1 || resp?.status === 1 || (typeof resp === 'string' && resp.toLowerCase().includes('success'))) {
                                        Swal.fire({ icon: 'success', title: 'Success', text: 'Quotation created successfully.' });
                                        setIsAddQuotationModal(false);
                                    } else {
                                        Swal.fire({ icon: 'error', title: 'Error', text: resp?.Message || (typeof resp === 'string' ? resp : 'Failed to create quotation.') });
                                    }
                                } catch (error) {
                                    console.error('save quotation error', error);
                                    Swal.fire({ icon: 'error', title: 'Error', text: 'An unexpected error occurred.' });
                                }
                            }}
                        >
                            Generate Quotation
                        </Button>
                    </div>
                }
            >
                <AddQuotationForm ref={addQuotationRef} lead={lead} />
            </PopUpModal>
            <PopUpModal
                isOpen={isAddTaxSettingModal}
                onClose={() => setIsAddTaxSettingModal(false)}
                title="Create New Tax Setting"
                size="xl"
                footer={
                    <div className="flex justify-between w-full">
                        <Button
                            variant="secondary"
                            onClick={() => setIsAddTaxSettingModal(false)}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant='primary'
                            onClick={async () => {
                                try {
                                    if (!addTaxSettingRef.current) return;

                                    const validation = addTaxSettingRef.current.isValid();
                                    if (!validation.valid) {
                                        Swal.fire({ icon: 'warning', title: 'Validation Error', text: validation.message });
                                        return;
                                    }

                                    const form = addTaxSettingRef.current.getFormData();
                                    const { userId, TokenId, parentId } = getSession();

                                    const payload = {
                                        Token: TokenId,
                                        Message: "",
                                        LoggedUserId: userId,
                                        MAC_Address: "",
                                        IP_Address: "102.16.32.189",
                                        Details: {
                                            ParentId: parentId,
                                            UserId: userId,
                                            LeadId: lead.ID || lead.LeadId || lead.Id || lead.id,
                                            ...form
                                        },
                                        BroadcastName: ""
                                    };

                                    const resp = await saveTaxSetting(payload);
                                    if (resp && (resp.Status === 1 || resp.status === 1 || resp.type === 'success')) {
                                        Swal.fire({ icon: 'success', title: resp.title || 'Success', text: resp.message || 'Tax Settings saved successfully.' });
                                        setIsAddTaxSettingModal(false);
                                    } else {
                                        Swal.fire({ icon: 'error', title: resp?.title || 'Error', text: resp?.message || resp?.Message || 'Failed to save tax settings.' });
                                    }
                                } catch (error) {
                                    console.error('save tax setting error', error);
                                    Swal.fire({ icon: 'error', title: 'Error', text: 'An unexpected error occurred.' });
                                }
                            }}
                        >
                            Submit
                        </Button>
                    </div>
                }
            >
                <AddTaxSettingForm ref={addTaxSettingRef} lead={lead} />
            </PopUpModal>

    {/* Custom Modal for Full Details (Basic + Other + Custom Fields) */ }
    {
        isFullDetailsOpen && (
            <div className="custom-details-modal-overlay">
                <div className="custom-details-modal-container" style={{ maxWidth: '800px' }}>
                    <div className="custom-modal-header">
                        <div className="custom-modal-header-left">
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                                <h3 className="custom-modal-title">Lead Information Details</h3>
                                <button className="custom-modal-close-btn" onClick={() => setIsFullDetailsOpen(false)} style={{ margin: 0, position: 'static' }}>
                                    <X size={20} />
                                </button>
                            </div>
                            <div className="modal-profile-header" style={{ width: '100%' }}>
                                <div className="modal-avatar-name-row" style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                    <div className="modal-avatar" style={{ width: '40px', height: '40px', borderRadius: '50%', backgroundColor: '#e2e8f0', display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden' }}>
                                        {lead.Image && lead.Image !== 'https://docs.kit19.com/default/person.png' ? (
                                            <img src={lead.Image} alt="profile" style={{ width: '100%', height: '100%', objectFit: 'cover' }} onError={(e) => { e.target.style.display = 'none'; e.target.parentElement.innerText = getInitials(lead.PersonName || 'Unknown'); }} />
                                        ) : <span style={{ fontWeight: 'bold', color: '#64748b' }}>{getInitials(lead.PersonName || 'Unknown')}</span>}
                                    </div>
                                    <div className="modal-name-col">
                                        <div className="modal-lead-name-text" style={{ fontWeight: 'bold', fontSize: '15px' }}>{lead.PersonName}</div>
                                        {lead.LeadNo && (
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                <span className="lead-no-badge-modern-v2" style={{ fontSize: '11px', backgroundColor: '#22c55e', color: 'white', padding: '2px 6px', borderRadius: '10px' }}>{lead.LeadNo}</span>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="custom-modal-body" style={{ maxHeight: 'calc(100vh - 200px)', overflowY: 'auto', padding: '20px' }}>
                        <div className="full-details-modal-content">
                            <div className="modal-section-v2 basic-info">
                                <h4 className="modal-inner-heading" style={{ fontSize: '14px', fontWeight: 'bold', color: '#334155', marginBottom: '12px', paddingBottom: '8px', borderBottom: '1px solid #e2e8f0' }}>Basic Information</h4>
                                <div className="dynamic-details-grid-columns" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                                    {!isHiddenField('MobileNo') && (
                                        <div className="flex border border-gray-200 rounded-md overflow-hidden">
                                            <div className="bg-[#f8fafc] text-[#475569] font-semibold text-[12px] px-3 py-2 w-[150px] flex items-center border-r border-gray-200 shrink-0">Mobile :</div>
                                            <div className="bg-white text-gray-800 font-medium text-[13px] px-3 py-2 flex-1 flex items-center truncate">{lead.MobileNo}</div>
                                        </div>
                                    )}
                                    {!isHiddenField('EmailID') && (
                                        <div className="flex border border-gray-200 rounded-md overflow-hidden">
                                            <div className="bg-[#f8fafc] text-[#475569] font-semibold text-[12px] px-3 py-2 w-[150px] flex items-center border-r border-gray-200 shrink-0">Email :</div>
                                            <div className="bg-white text-gray-800 font-medium text-[13px] px-3 py-2 flex-1 flex items-center truncate">{lead.EmailID}</div>
                                        </div>
                                    )}
                                    {!isHiddenField('CompanyName') && (
                                        <div className="flex border border-gray-200 rounded-md overflow-hidden">
                                            <div className="bg-[#f8fafc] text-[#475569] font-semibold text-[12px] px-3 py-2 w-[150px] flex items-center border-r border-gray-200 shrink-0">Company :</div>
                                            <div className="bg-white text-gray-800 font-medium text-[13px] px-3 py-2 flex-1 flex items-center truncate">{lead.CompanyName}</div>
                                        </div>
                                    )}
                                    {!isHiddenField('City') && !isHiddenField('StateName') && (
                                        <div className="flex border border-gray-200 rounded-md overflow-hidden">
                                            <div className="bg-[#f8fafc] text-[#475569] font-semibold text-[12px] px-3 py-2 w-[150px] flex items-center border-r border-gray-200 shrink-0">Location :</div>
                                            <div className="bg-white text-gray-800 font-medium text-[13px] px-3 py-2 flex-1 flex items-center truncate">{(lead.City && lead.City !== '') ? `${lead.City}, ${lead.StateName}` : lead.StateName}</div>
                                        </div>
                                    )}
                                </div>
                            </div>

                            <div className="modal-divider-v2" style={{ margin: '20px 0', borderBottom: '1px solid #e2e8f0' }}></div>

                            <div className="modal-section-v2 other-info">
                                <h4 className="modal-inner-heading" style={{ fontSize: '14px', fontWeight: 'bold', color: '#334155', marginBottom: '12px', paddingBottom: '8px', borderBottom: '1px solid #e2e8f0' }}>Other Details</h4>
                                <div className="dynamic-details-grid-columns" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                                    <div className="flex border border-gray-200 rounded-md overflow-hidden"><div className="bg-[#f8fafc] text-[#475569] font-semibold text-[12px] px-3 py-2 w-[150px] flex items-center border-r border-gray-200 shrink-0">Created On :</div><div className="bg-white text-gray-800 font-medium text-[13px] px-3 py-2 flex-1 flex items-center truncate">{lead.CreatedOn}</div></div>
                                    {!isHiddenField('SourceName') && <div className="flex border border-gray-200 rounded-md overflow-hidden"><div className="bg-[#f8fafc] text-[#475569] font-semibold text-[12px] px-3 py-2 w-[150px] flex items-center border-r border-gray-200 shrink-0">Source :</div><div className="bg-white text-gray-800 font-medium text-[13px] px-3 py-2 flex-1 flex items-center truncate">{lead.SourceName}</div></div>}
                                    <div className="flex border border-gray-200 rounded-md overflow-hidden"><div className="bg-[#f8fafc] text-[#475569] font-semibold text-[12px] px-3 py-2 w-[150px] flex items-center border-r border-gray-200 shrink-0">Modified On :</div><div className="bg-white text-gray-800 font-medium text-[13px] px-3 py-2 flex-1 flex items-center truncate">{lead.ModifiedOn}</div></div>
                                    {!isHiddenField('Campaign') && <div className="flex border border-gray-200 rounded-md overflow-hidden"><div className="bg-[#f8fafc] text-[#475569] font-semibold text-[12px] px-3 py-2 w-[150px] flex items-center border-r border-gray-200 shrink-0">Campaign :</div><div className="bg-white text-gray-800 font-medium text-[13px] px-3 py-2 flex-1 flex items-center truncate">{lead.Campaign}</div></div>}
                                    {!isHiddenField('Medium') && <div className="flex border border-gray-200 rounded-md overflow-hidden"><div className="bg-[#f8fafc] text-[#475569] font-semibold text-[12px] px-3 py-2 w-[150px] flex items-center border-r border-gray-200 shrink-0">Medium :</div><div className="bg-white text-gray-800 font-medium text-[13px] px-3 py-2 flex-1 flex items-center truncate">{lead.Medium}</div></div>}
                                    <div className="flex border border-gray-200 rounded-md overflow-hidden"><div className="bg-[#f8fafc] text-[#475569] font-semibold text-[12px] px-3 py-2 w-[150px] flex items-center border-r border-gray-200 shrink-0">Created By :</div><div className="bg-white text-gray-800 font-medium text-[13px] px-3 py-2 flex-1 flex items-center truncate">{lead.CreatedByName}</div></div>
                                    <div className="flex border border-gray-200 rounded-md overflow-hidden"><div className="bg-[#f8fafc] text-[#475569] font-semibold text-[12px] px-3 py-2 w-[150px] flex items-center border-r border-gray-200 shrink-0">Assigned To :</div><div className="bg-white text-gray-800 font-medium text-[13px] px-3 py-2 flex-1 flex items-center truncate">{lead.assigneduser}</div></div>
                                    <div className="flex border border-gray-200 rounded-md overflow-hidden"><div className="bg-[#f8fafc] text-[#475569] font-semibold text-[12px] px-3 py-2 w-[150px] flex items-center border-r border-gray-200 shrink-0">Follow Up Date :</div><div className="bg-white text-gray-800 font-medium text-[13px] px-3 py-2 flex-1 flex items-center truncate">{lead.NextFollowupDate}</div></div>
                                    <div className="flex border border-gray-200 rounded-md overflow-hidden"><div className="bg-[#f8fafc] text-[#475569] font-semibold text-[12px] px-3 py-2 w-[150px] flex items-center border-r border-gray-200 shrink-0">Remark :</div><div className="bg-white text-gray-800 font-medium text-[13px] px-3 py-2 flex-1 flex items-center truncate">{lead.Remarks}</div></div>

                                    {/* Dynamic API Custom Fields Mapping */}
                                    {Array.isArray(enquiryDetailData) && enquiryDetailData.map((f, idx) => {
                                        if (!f || !f.Text || typeof f.Text !== 'string') return null;
                                        const parts = f.Text.split('|');
                                        const displayValue = (parts[0] || '').replace(/^v/, '');
                                        const label = parts[1] || 'Unknown';
                                        const isSpecial = label === 'Education_diploma' || label === 'Demo_date';
                                        const cleanLabel = label.replace(/_/g, ' ');
                                        return (
                                            <div key={idx} className="flex border border-gray-200 rounded-md overflow-hidden">
                                                <div className="bg-[#f8fafc] text-[#475569] font-semibold text-[12px] px-3 py-2 w-[150px] flex items-center border-r border-gray-200 shrink-0">{cleanLabel} :</div>
                                                <div className="bg-white text-gray-800 font-medium text-[13px] px-3 py-2 flex-1 flex items-center truncate">
                                                    {isSpecial ? cleanLabel : (displayValue || '')}
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
        </>
    );
};

export default LeadDetails;
